export default {
  "brandSeo": {
    "pageTitle": "Miral AI 的{title}",
    "toolDescription": "在 Miral AI，{description}",
    "sectionTitle": "Miral AI 如何实现：{title}",
    "faqTitle": "Miral AI {title}",
    "toolFreeTrialCta": "在 Miral AI 免费试用此工具",
    "toolProcessCta": "免费{action}",
    "imageFaqs": [
      { "q": "可以在 Miral 免费试用 AI 图片生成吗？", "a": "可以。注册 Miral AI 即可领取免费积分并试用图片生成；每次生成仍会按照所选模型的积分规则扣除相应积分。" },
      { "q": "为什么选择 Miral AI 生成图片？", "a": "Miral AI 在一个平台整合多款领先图片模型，方便比较不同能力并连续创作，无需在多个平台之间切换。" }
    ],
    "toolFaqs": [
      { "q": "可以免费试用这款 Miral AI 工具吗？", "a": "可以。登录 Miral AI 后即可开始免费试用；具体可用次数受账号限制，免费试用不代表永久免费或无限使用。" },
      { "q": "为什么在 Miral AI 使用创作工具？", "a": "Miral AI 将图片生成和实用编辑工具整合在同一平台，可在一套流程中完成创作、处理和结果下载。" }
    ]
  },
  "common": {
    "loading": "加载中...",
    "error": "发生错误",
    "success": "操作成功",
    "confirm": "确定",
    "prev": "上一页",
    "next": "下一页",
    "optional": "可选",
    "remove": "移除",
    "generate": "生成",
    "generating": "正在生成中...",
    "required": "必填",
    "generateFailedContactSupport": "生成失败，请重试或者联系客服！",
    "localMediaTransferFailed": "网络波动引发服务传输及交互异常，生成流程中断，请重新生成或者联系客服",
    "tryAgainOrContactSupportTail": "，请重试或者联系客服！",
    "errorDetails": "错误详情",
    "errorCategoryImageSizeInvalid": "图片尺寸不符合要求，请更换符合要求的图片",
    "errorCategoryOutputEmptyOrSensitive": "生成内容可能触发安全策略或未能生成结果，请调整提示词/参考图片",
    "errorCategoryUpstreamBusy": "服务繁忙（上游负载已饱和）",
    "errorCategoryAiNetworkError": "网络连接异常，请检查网络后重试",
    "errorCategoryAiTimeout": "AI任务请求超时，网络可能有波动，请稍后重试",
    "close": "关闭",
    "leaveConfirmTitle": "温馨提示",
    "leaveConfirmMessage": "当前 AI 作品正在生成中，切换页面不影响生成进度，可前往【我的 - 我的作品】查看处理中或已完成的作品咯！\n您确认要离开吗？",
    "leaveConfirmConfirm": "确认离开",
    "leaveConfirmCancel": "我再想想",
    "genDotIdle": "暂无生成任务",
    "genDotActive": "正在执行生成任务，请勿关闭浏览器",
    "genRecoveryTimeout": "生成超时或页面已关闭",
    "genRecoveryInterrupted": "生成被页面刷新中断"
  },
  "api": {
    "errors": {
      "requestFailed": "请求失败",
      "badRequest": "请求参数错误",
      "unauthorized": "未授权，请重新登录",
      "forbidden": "拒绝访问",
      "notFound": "请求资源不存在",
      "serverError": "服务器内部错误",
      "timeout": "请求超时，请重试",
      "networkError": "网络错误，请检查网络连接",
      "sessionExpired": "登录已过期，请重新登录",
      "operationFailed": "操作失败！"
    }
  },
  "nav": {
    "home": "首页",
    "models": "AI 模型",
    "pricing": "定价",
    "faq": "常见问题",
    "login": "登录",
    "signup": "升级",
    "register": "注册",
    "email": "邮箱",
    "logout": "退出登录",
    "help": "帮助",
    "profile": "个人中心",
    "myWorks": "我的作品",
    "username": "用户名",
    "password": "密码",
    "confirmPassword": "确认密码",
    "processing": "处理中...",
    "haveAccount": "已有账号？",
    "noAccount": "没有账号？",
    "orContinueWith": "或使用以下方式继续",
    "loginFailed": "登录失败，请重试",
    "registerFailed": "注册失败，请重试",
    "fillRequired": "请填写所有必填项",
    "passwordMismatch": "两次输入的密码不一致",
    "passwordTooShort": "密码长度至少6位",
    "googleNotLoaded": "Google 登录服务未加载，请刷新页面重试",
    "googleInitFailed": "Google 登录初始化失败",
    "googleUserInfoFailed": "无法获取用户信息",
    "googleCancelled": "Google 登录已取消",
    "codeLoginHint": "输入邮箱，我们将发送验证码到您的邮箱",
    "verificationCode": "验证码",
    "sendCode": "发送验证码",
    "resendCode": "重新发送",
    "verifyAndLogin": "验证并登录",
    "enterEmail": "请输入邮箱地址",
    "invalidEmail": "请输入有效的邮箱地址",
    "sendCodeFailed": "发送验证码失败，请重试",
    "checkSpamFolder": "找不到邮件？检查你的垃圾邮件/垃圾文件夹",
    "enterValidCode": "请输入6位验证码",
    "verifyCodeFailed": "验证码错误或已过期",
    "googleLoginFailed": "Google 登录失败，请重试",
    "registerHint": "注册即表示您同意我们的",
    "and": "和",
    "freeCreditsLabel": "免费积分：",
    "freeCreditsDesc": "登录即可获得免费积分——无需付费！",
    "sidebar": {
      "navigation": "导航",
      "home": "首页",
      "inspiration": "灵感库",
      "history": "创作历史",
      "allModels": "所有 AI 模型",
      "videoAI": "视频AI",
      "videoGenerator": "视频生成器",
      "newModels": "新模型",
      "otherModels": "其他模型",
      "videoEnhance": "视频增强",
      "musicAI": "AI 音乐",
      "musicGenerator": "AI Music",
      "imageAI": "图片AI",
      "imageGenerator": "图片生成器",
      "hotModels": "热门模型",
      "hotTools": "热门工具",
      "upgrade": "升级"
    }
  },
  "footer": {
    "brand": "Miral",
    "siteTitle": "Miral - AI 图文、视频及音乐创作平台",
    "desc": "集图像、视频、音乐创作于一体的全能 AI 平台。",
    "fluxModels": "FLUX 模型",
    "aiImages": "AI 图片",
    "aiVideos": "AI 视频",
    "aiMusic": "AI 音乐",
    "product": "产品",
    "videoModels": "AI 视频模型",
    "imageModels": "AI 图像模型",
    "musicModels": "AI 音乐模型",
    "apps": "应用",
    "tools": "工具",
    "company": "公司",
    "about": "关于我们",
    "contact": "联系我们",
    "blog": "博客",
    "resources": "资源",
    "allModels": "所有 AI 模型",
    "pricing": "价格",
    "trustSafety": "信任与安全",
    "terms": "服务条款",
    "privacy": "隐私政策",
    "faq": "常见问题",
    "musicGenerator": "AI 音乐生成器",
    "copyright": "© 2025 Miral. All rights reserved.",
    "langZh": "简体中文",
    "langEn": "English"
  },
  "about": {
    "tag": "关于 Miral",
    "title": "关于我们",
    "subtitle": "用全球顶尖 AI 模型，让图像、视频与音乐创作更简单。",
    "paragraphs": [
      "Miral 是面向创作者、设计师与企业的 AI 内容创作平台，支持图片生成、视频生成与 AI 音乐创作，并提供去水印、文档处理等实用工具。",
      "我们持续接入领先模型与稳定渠道，让您在浏览器中即可完成从灵感到成品的完整流程。",
      "如需了解数据安全与使用规范，可查看信任与安全页面；如有问题欢迎联系支持团队。"
    ]
  },
  "contact": {
    "tag": "支持",
    "title": "联系我们",
    "subtitle": "我们会尽快回复您的问题与反馈。",
    "emailLabel": "客服邮箱",
    "hint": "也可通过邮件说明订单、积分或生成相关问题，我们通常在工作日内回复。",
    "cta": "发送邮件"
  },
  "models": {
    "image": {
      "nano-banana": {
        "name": "Nano Banana Pro",
        "desc": "电影级写实风格，人物肤质、材质纹理与光影细节更自然"
      },
      "nano-banana-31": {
        "name": "Nano Banana 3.1",
        "desc": "支持 v2.5 和 v3.1 双模式多分辨率图片生成"
      },
      "seedream-4": {
        "name": "Seedream 4",
        "desc": "艺术风格"
      },
      "seedream-5": {
        "name": "Seedream 5",
        "desc": "艺术风格"
      },
      "midjourney": {
        "name": "Midjourney",
        "desc": "艺术风格"
      },
      "gpt-image-1": {
        "name": "GPT-Image-1",
        "desc": "多用途"
      },
      "gpt-image-1-5": {
        "name": "GPT-Image-1-5",
        "desc": "多用途"
      },
      "flux-pro-1-1-ultra": {
        "name": "Flux Pro 1.1 Ultra",
        "desc": "高质量文生图"
      },
      "flux-schnell": {
        "name": "Flux Schnell",
        "desc": "快速文生图"
      },
      "flux-2": {
        "name": "FLUX.2",
        "desc": "新一代文生图"
      },
      "flux-kontext": {
        "name": "Flux Kontext",
        "desc": "高质量文生图与编辑"
      }
      ,
      "qwen-image-2-0-pro": {
        "name": "Qwen Image 2.0 Pro",
        "desc": "高分辨率文生图与精细生成"
      },
      "z-image-turbo": {
        "name": "Z Image Turbo",
        "desc": "高分辨率文生图"
      },
      "sd-3-5": {
        "name": "Stable Diffusion 3.5",
        "desc": "Stable Diffusion 3.5 文生图"
      }
    },
    "video": {
      "pollodance": {
        "name": "Pollo Dance",
        "desc": "运动控制、参考与电影级风格"
      },
      "seegen": {
        "name": "SeeGen",
        "desc": "文生/图生视频，多分辨率与比例"
      },
      "seedance": {
        "name": "Seedance AI",
        "desc": "原生音画同步"
      },
      "wan-2-5": {
        "name": "Wan 2.5",
        "desc": "动画风格"
      },
      "wan-2-6": {
        "name": "Wan 2.6",
        "desc": "增强画质"
      },
      "veo-3-1": {
        "name": "Veo 3.1",
        "desc": "多图参考"
      },
      "veo-3-1-fast": {
        "name": "Veo 3.1 Fast",
        "desc": "快速版，支持尾帧"
      },
      "veo-3-0": {
        "name": "Veo 3.0",
        "desc": "文生视频/图生视频"
      },
      "kling-2-6": {
        "name": "Kling 2.6",
        "desc": "口型同步"
      },
      "kling-3": {
        "name": "Kling 3",
        "desc": "口型同步"
      },
      "kling-2-5": {
        "name": "Kling 2.5",
        "desc": "高质量视频"
      },
      "sora-2": {
        "name": "Sora 2",
        "desc": "4秒 / 8秒 / 12秒"
      },
      "wan-2-2": {
        "name": "Wan 2.2",
        "desc": "经典稳定"
      },
      "vidu-q3-pro": {
        "name": "Vidu Q3 Pro",
        "desc": "文生/图生视频，多分辨率与时长"
      },
      "hailuo-2-3": {
        "name": "Hailuo 2.3",
        "desc": "创意视频"
      },
      "runway": {
        "name": "Runway",
        "desc": "工作台"
      },
      "wan-animate": {
        "name": "Wan Animate",
        "desc": "融合 AI 动作迁移与身份替换技术的高阶角色动画模型，高效打造高保真动态角色动画"
      }
    }
  },
  "tools": {
    "demoTitle": "效果演示",
    "page": {
      "tag": "AI 工具箱",
      "title": "专业级 AI 工具箱",
      "subtitle": "去除水印、修复旧照片、高清放大、视频增强等专业工具，满足各种后期处理需求。",
      "allTools": "所有工具"
    },
    "detail": {
      "useNow": "立即使用",
      "clickUpload": "点击或拖拽上传",
      "support": "支持格式",
      "reupload": "重新上传",
      "scale": "放大倍数",
      "process": "开始处理",
      "processing": "处理中...",
      "before": "处理前",
      "after": "处理后",
      "download": "下载结果",
      "processNew": "处理新文件",
      "howToUse": "使用方法",
      "moreTools": "更多工具",
      "notFound": "工具未找到",
      "backToList": "返回工具列表",
      "loginRequired": "请先登录",
      "loginRequiredDesc": "登录后即可使用此工具的所有功能",
      "loginNow": "立即登录",
      "demo": "效果演示",
      "uploadOriginalFailed": "原图上传失败，请重试"
    },
    "steps": {
      "upload": {
        "title": "上传文件",
        "desc": "选择或拖拽需要处理的图片或视频文件。"
      },
      "adjust": {
        "title": "调整参数",
        "desc": "根据需要调整处理参数，如放大倍数、输出格式等。"
      },
      "process": {
        "title": "一键处理",
        "desc": "AI 自动处理，通常在几秒到几分钟内完成。"
      },
      "download": {
        "title": "下载结果",
        "desc": "预览处理效果，满意后一键下载高清结果。"
      }
    },
    "fileTypes": {
      "image": "图片",
      "video": "视频"
    },
    "imageEnhancer": {
      "name": "图片增强器",
      "desc": "一键提升图片分辨率和画质，支持高清放大至 4K",
      "fullDesc": "一键提升图片分辨率和画质，支持高清放大至 4K。使用先进的 AI 算法增强细节，让模糊图片变得清晰锐利。"
    },
    "watermark-remover": {
      "name": "AI 水印去除器",
      "desc": "使用 AI 在线去除图片和照片水印",
      "fullDesc": "免费使用 AI 水印去除器，在线清除照片中的全图水印、Logo、时间戳、文字和样稿标记，同时尽量保留原图内容、背景细节与画质。",
      "aiRepair": "水印移除",
      "uploadLabel": "上传图片",
      "uploadHint": "支持最大 15MB 的 JPG、PNG 或 WebP 图片。",
      "featuresKicker": "快速准确",
      "featuresTitle": "在线去除照片中的多种水印",
      "featuresIntro": "上传 JPG、PNG 或 WebP 图片，让 AI 自动识别水印区域并自然修复背景，无需手动涂抹。",
      "features": [
        { "title": "清除全图水印", "desc": "去除重复覆盖整张图片的半透明文字或图案水印，恢复更干净的画面。", "cta": "免费试用 AI 去水印" },
        { "title": "去除时间戳和日期标记", "desc": "清理照片角落的日期、时间戳和相机标记，并尽量重建后方背景。", "cta": "在线擦除图片水印" },
        { "title": "擦除品牌 Logo", "desc": "移除图片中的品牌标志、角标和宣传标记，适合处理你有权编辑的素材。", "cta": "立即去除照片水印" },
        { "title": "清理文字与样稿标记", "desc": "去除预览图、设计稿和照片上的文字覆盖层，让视觉内容更加整洁。", "cta": "立刻试用水印移除器" }
      ],
      "useCasesKicker": "适用场景",
      "useCasesTitle": "AI 图片去水印可以处理什么？",
      "audienceLabels": ["电商卖家", "营销团队", "设计师与创作者", "时尚与服饰店铺"],
      "audienceCases": [
        { "title": "商品视觉素材准备提速 3 倍", "desc": "制作商品列表图片前，先清理已获授权的产品图、供应商图片或草稿素材，去除干扰标记，让买家更专注于商品本身。" },
        { "title": "减少 60% 手动清理，快速制作活动素材", "desc": "将自有或授权素材制作成广告、横幅和品牌视觉前，先去除多余水印。干净素材可更快用于活动推广、新品发布和商品海报制作。" },
        { "title": "更快将干净图片转化为全新创意", "desc": "从清晰整洁的源图出发探索新设计方向，无需从零重建。去水印后的草稿可继续用于 AI 草图、概念艺术或海报视觉创作。" },
        { "title": "无需重新拍摄，轻松焕新商品目录", "desc": "制作商品目录、季节上新或 AI 虚拟试穿素材前，先清理已授权的服装照片，让买家更专注于版型、面料和商品细节。" }
      ],
      "useCases": [
        { "title": "电商产品图片去水印", "desc": "清理产品图上的文字、Logo 和促销标记，方便重新排版自有商品素材。" },
        { "title": "社交媒体照片去水印", "desc": "移除自己照片上的平台标记或时间戳，获得更干净的发布版本。" },
        { "title": "批量标记图片清理", "desc": "一张图片包含多个水印时，AI 可识别并清理多个覆盖区域。" }
      ],
      "howToKicker": "简单三步",
      "howToTitle": "如何免费在线去除图片水印？",
      "howToIntro": "无需安装软件，上传图片、运行 AI 水印清除并下载处理结果。",
      "howToCta": "立即在线去除水印",
      "steps": {
        "upload": { "title": "上传带水印的图片", "desc": "选择 15MB 以内的 JPG、PNG 或 WebP 图片。请确保你拥有编辑和使用该图片的权利。" },
        "remove": { "title": "AI 自动去除水印", "desc": "启动处理后，AI 会识别 Logo、文字、时间戳或全图水印，并修复相应背景。" },
        "download": { "title": "预览并下载图片", "desc": "比较去水印前后的效果，然后下载清理后的图片或上传新图片继续处理。" }
      },
      "faqTitle": "AI 水印去除器常见问题",
      "faqs": [
        { "q": "什么是 AI 水印去除器？", "a": "AI 水印去除器会识别图片上的水印区域，并根据周围颜色、纹理和画面内容重建被遮挡的背景。" },
        { "q": "可以免费在线去除照片水印吗？", "a": "可以在线体验 Miral AI 水印去除器。注册后上传图片，即可开始处理并预览结果。" },
        { "q": "支持哪些图片格式？", "a": "当前支持 15MB 以内的 JPG、PNG 和 WebP 图片。该页面不处理视频水印。" },
        { "q": "可以去除全图水印、Logo 和时间戳吗？", "a": "可以。AI 可处理全图重复水印、品牌 Logo、日期时间戳、文字和样稿标记；实际效果取决于水印透明度、覆盖面积和背景复杂度。" },
        { "q": "一张照片中有多个水印也能处理吗？", "a": "可以尝试处理多个水印区域。水印较大或覆盖人物、复杂纹理时，建议检查预览结果。" },
        { "q": "去除图片水印是否合法？", "a": "请仅处理你拥有、已获授权或法律允许编辑的图片。未经许可移除版权水印并使用相关内容，可能侵犯权利人的权益。" },
        { "q": "去水印会降低图片画质吗？", "a": "AI 会尽量保留原始构图、分辨率和细节，但被大面积水印遮挡的内容需要推测重建，局部效果可能与原图不同。" }
      ],
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "去水印结果.png"
    },
    "full-watermark-remover": {
      "name": "AI去水印",
      "desc": "使用 AI 去除图片水印",
      "fullDesc": "使用 AI 智能识别并去除图片水印，保留原图内容、细节和画质。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "全屏水印去除结果.png"
    },
    "ai-text-remover": {
      "name": "AI去文字",
      "desc": "使用 AI 去除图片中的文字内容",
      "fullDesc": "使用 AI 去除图片中的文字内容，尽量保留背景纹理、画面细节和自然效果。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "去文字结果.png"
    },
    "ai-logo-remover": {
      "name": "AI去LOGO",
      "desc": "使用 AI 去除图片中的 LOGO",
      "fullDesc": "使用 AI 去除图片中的 LOGO，尽量保留背景纹理、画面细节和自然效果。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "去LOGO结果.png"
    },
    "ai-passersby-remover": {
      "name": "AI去路人",
      "desc": "使用 AI 去除图片中的路人",
      "fullDesc": "使用 AI 智能识别并去除图片中的路人，保留主体、背景纹理和自然画面细节。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "AI去路人结果.png"
    },
    "background-remover": {
      "name": "图片去背景",
      "desc": "AI 一键抠图并去除背景",
      "heroTitle": "免费 AI 图片去背景，一键生成透明 PNG",
      "fullDesc": "在线上传 JPG、PNG 或 WebP 图片，让 AI 自动识别人物、商品与主体轮廓，细致保留发丝和边缘，快速输出透明背景 PNG，无需 Photoshop。",
      "uploadLabel": "上传需要去背景的图片",
      "uploadHint": "点击或拖拽上传图片",
      "uploadSpec": "支持 15MB 以内的 JPG、PNG 或 WebP 图片，处理结果以透明 PNG 下载。",
      "processButton": "一键去除图片背景",
      "previewAlt": "等待 AI 去除背景的图片预览",
      "demoBeforeAlt": "人像照片去除背景前",
      "demoAfterAlt": "AI 人像背景去除后的效果",
      "processingAlt": "AI 正在去除图片背景",
      "processingLabel": "正在智能抠图",
      "resultLabel": "透明背景已生成",
      "resultBeforeAlt": "去背景前的原始图片",
      "resultAfterAlt": "AI 去背景后的透明 PNG",
      "productBeforeAlt": "商品图片去除背景前",
      "productAfterAlt": "商品图片背景变透明后的 PNG",
      "featuresKicker": "精准识别主体",
      "featuresTitle": "适合人像与商品图的在线 AI 背景去除器",
      "featuresIntro": "从复杂人像边缘到电商商品抠图，AI 自动分离主体与背景，省去手动画笔、路径和蒙版操作。",
      "features": [
        { "title": "人像去背景并保留发丝细节", "desc": "自动识别人像、服装和发丝边缘，减少生硬锯齿，适合头像、证件素材、人物海报和社交媒体图片。", "cta": "免费去除人像背景" },
        { "title": "商品图片一键抠图", "desc": "快速移除商品照片中的桌面、墙面和拍摄场景，生成可继续用于白底图、详情页与广告设计的透明素材。", "cta": "在线处理商品图片" },
        { "title": "下载透明背景 PNG", "desc": "处理结果保留透明通道，可直接叠加到新背景、Banner、演示文稿和视觉设计中，无需再次手动抠图。", "cta": "生成透明背景图片" }
      ],
      "featureAlts": {
        "portraitBefore": "人像背景去除前的照片",
        "portraitAfter": "保留发丝细节的人像去背景效果",
        "productBefore": "商品照片背景去除前",
        "productAfter": "商品照片抠图后的透明背景",
        "ecommerceBefore": "电商产品图去背景前",
        "ecommerceAfter": "电商产品透明 PNG 素材"
      },
      "useCasesKicker": "常见使用场景",
      "useCasesTitle": "哪些图片适合使用 AI 一键抠图？",
      "useCasesIntro": "适用于需要快速获得独立主体或透明背景素材的日常设计与商业图片。",
      "useCases": [
        { "title": "电商商品主图", "desc": "为商品目录、独立站和营销素材制作干净的透明底图。" },
        { "title": "人像与头像", "desc": "去除杂乱环境，同时尽量保留头发、服装和人物轮廓。" },
        { "title": "社交媒体设计", "desc": "将人物或物品叠加到封面、帖子、缩略图和短视频画面。" },
        { "title": "证件与职业照片", "desc": "先分离人物主体，再在设计工具中更换所需的纯色背景。" },
        { "title": "Logo 与图形素材", "desc": "去除不需要的底色，便于在网页、海报和演示文稿中复用。" },
        { "title": "广告与平面设计", "desc": "快速准备可自由排版的透明 PNG，减少重复手动抠图。" }
      ],
      "howToKicker": "简单三步",
      "howToTitle": "如何免费在线去除图片背景？",
      "howToIntro": "上传图片、启动 AI 自动抠图，然后预览并下载透明 PNG。",
      "steps": [
        { "title": "上传 JPG、PNG 或 WebP", "desc": "选择一张 15MB 以内、主体清晰的人像、商品或设计图片。" },
        { "title": "AI 自动识别并去除背景", "desc": "点击处理后，AI 会分离主体与背景，并保留重要边缘细节。" },
        { "title": "预览并下载透明 PNG", "desc": "检查前后效果，下载透明背景结果或继续处理新图片。" }
      ],
      "faqTitle": "AI 图片背景去除常见问题",
      "faqs": [
        { "q": "如何免费在线去除图片背景？", "a": "上传 JPG、PNG 或 WebP 图片并点击去除背景。AI 会自动识别主体，完成后可预览并下载透明 PNG。" },
        { "q": "AI 去背景能保留头发和细小边缘吗？", "a": "工具会识别人像轮廓并尽量保留发丝、衣物和细小边缘。使用主体清晰、对比明显的原图通常能获得更自然的结果。" },
        { "q": "可以移除商品照片背景吗？", "a": "可以。商品主体与背景区分越清楚，越适合生成用于电商主图、详情页和广告设计的透明素材。" },
        { "q": "去背景后会下载什么格式？", "a": "处理结果以支持透明通道的 PNG 图片下载，便于在其他背景或设计版式中继续使用。" },
        { "q": "支持哪些图片格式和文件大小？", "a": "支持 JPG、PNG 和 WebP 图片，单张文件大小应不超过 15MB。" },
        { "q": "使用在线背景去除器需要安装 Photoshop 吗？", "a": "不需要。上传图片后由 AI 自动完成主体识别和背景移除，可直接在浏览器中完成。" }
      ],
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "去背景结果.png"
    },
    "image-eraser": {
      "name": "图片擦除",
      "desc": "AI 擦除图片中的任意物体、人物或水印",
      "fullDesc": "AI 智能图片擦除工具。用画笔在照片上涂抹任意不需要的物体、人物、水印或文字，AI 将无缝擦除并用自然内容填补该区域。适合清理照片、去除画面中的干扰元素。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "擦除结果.png"
    },
    "object-remover": {
      "name": "AI 物体移除",
      "desc": "在线移除照片中的多余物体和干扰元素",
      "fullDesc": "免费使用 AI 在线移除照片中的多余物体。上传图片并涂抹人物、杂物、标牌、电线或其他干扰元素，AI 会重建被覆盖的背景，生成自然干净的图片。",
      "uploadLabel": "上传图片",
      "uploadHint": "点击或拖拽上传图片",
      "uploadSpec": "支持 JPG、PNG 或 WebP 图片。",
      "maskHint": "请完整涂抹希望 AI 移除的物体区域。",
      "processButton": "移除物体",
      "demoBeforeAlt": "移除多余物体前的照片",
      "demoAfterAlt": "移除多余物体后的照片",
      "processingAlt": "AI 正在处理标记后的照片",
      "resultBeforeAlt": "物体移除前的原始照片",
      "resultAfterAlt": "AI 移除物体后的干净照片",
      "featureImageLabels": {
        "object": "多余物体移除示例",
        "person": "照片人物移除示例",
        "distraction": "背景干扰元素移除示例"
      },
      "featuresKicker": "精准清理照片",
      "featuresTitle": "在线移除照片中的多余物体",
      "featuresIntro": "准确标记需要清理的区域，让 AI 处理日常照片中的干扰元素，无需手动修补背景。",
      "features": [
        { "title": "涂抹并移除多余物体", "desc": "使用可调画笔标记杂物、标牌、道具或其他物体，AI 会移除所选区域并补全周围图像细节。", "cta": "免费移除照片物体" },
        { "title": "移除照片背景中的人物", "desc": "清理旅行照和人像中的路人、游客或抢镜人物，让主体更加突出。", "cta": "免费清理照片背景" },
        { "title": "擦除细小背景干扰", "desc": "移除电线、垃圾桶、街道杂物、污点和孤立的干扰元素，让画面构图更整洁。", "cta": "免费擦除照片干扰" }
      ],
      "useCasesKicker": "常见用途",
      "useCasesTitle": "AI 物体移除可以清理哪些内容？",
      "useCasesIntro": "适合能够清楚涂抹多余区域、同时希望保留照片其余内容的局部编辑。",
      "useCases": [
        { "title": "旅行照片清理", "desc": "移除旅行照中的路人、标牌、垃圾桶或街道杂物。" },
        { "title": "商品照片清理", "desc": "擦除商品周围的道具、标签、电线和干扰物品。" },
        { "title": "人像背景清理", "desc": "移除背景人物和抢夺主体注意力的小物体。" },
        { "title": "房产照片整理", "desc": "清理室内或房产照片中的临时杂物和孤立物体。" },
        { "title": "社交媒体图片", "desc": "发布照片前移除画面中的明显干扰，让图片更加整洁。" },
        { "title": "创意图片编辑", "desc": "在图片用于排版或视觉项目之前，清空指定区域。" }
      ],
      "howToKicker": "简单三步",
      "howToTitle": "如何在线移除照片中的物体",
      "howToIntro": "上传照片、涂抹多余物体，然后下载 AI 清理后的结果。",
      "steps": [
        { "title": "上传照片", "desc": "选择包含待移除人物、物品或干扰元素的图片。" },
        { "title": "涂抹物体", "desc": "调整画笔并完整覆盖多余区域，可使用撤销或橡皮修正选区。" },
        { "title": "移除并下载", "desc": "启动 AI 处理，对比前后效果并下载清理后的照片。" }
      ],
      "faqTitle": "AI 物体移除常见问题",
      "faqs": [
        { "q": "如何在线移除照片中的多余物体？", "a": "上传照片，完整涂抹多余物体后开始处理。AI 会根据附近的颜色、纹理和场景细节重建所选区域。" },
        { "q": "用什么工具可以移除照片背景中的人物？", "a": "使用画笔覆盖人物，并包含影子或随身物品等细节。周围背景越清晰，通常越容易得到自然结果。" },
        { "q": "AI 可以移除标牌、电线、垃圾桶和街道杂物吗？", "a": "可以。请清楚标记多余区域，并避免覆盖需要保留的主体。较小且独立的干扰元素通常更容易重建。" },
        { "q": "怎样让物体移除效果更自然？", "a": "使用清晰的高质量原图，并让涂抹范围略微超过物体边缘。多个物体互相重叠时，可以分次处理。" },
        { "q": "物体移除会改变整张照片吗？", "a": "处理请求以涂抹蒙版为准，工具会重点重建所选区域，但物体边缘附近的像素也可能参与融合。" },
        { "q": "支持上传哪些图片格式？", "a": "上传控件支持 JPG、PNG 和 WebP 等常见图片格式。" }
      ],
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "物体移除结果.png"
    },
    "ai-person-remover": {
      "name": "AI 人物移除",
      "desc": "AI 移除图片中的多余人物",
      "fullDesc": "AI 智能人物移除工具。用画笔在照片上涂抹任意不需要的人物，AI 将无缝擦除并用自然内容填补该区域。适合去除路人、游客等画面中的多余人物。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "人物移除结果.png"
    },
    "background-blur": {
      "name": "背景虚化",
      "desc": "AI 一键虚化图片背景，突出主体",
      "fullDesc": "AI 自动识别前景主体（人/物），保留主体清晰、对背景做高斯模糊，打造 Portrait Mode 人像虚化效果。适合人像、商品特写等场景。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "背景虚化结果.png"
    },
    "white-background": {
      "name": "白色背景替换",
      "desc": "AI 一键替换图片背景为纯白色",
      "fullDesc": "AI 智能识别主体，一键将图片背景替换为纯白色。适合商品白底图、证件照等场景，保留发丝等细节。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "白色背景结果.png"
    },
    "blue-background": {
      "name": "蓝色背景替换",
      "desc": "AI 一键替换图片背景为纯蓝色",
      "fullDesc": "AI 智能识别主体，一键将图片背景替换为纯蓝色。适合证件照、护照照片等场景，保留发丝等细节。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "noImageInResponse": "未从接口解析到结果图片，请稍后重试。",
      "downloadName": "蓝色背景结果.png"
    },
    "face-swap": {
      "name": "照片换脸",
      "desc": "使用 AI 在线交换两张照片中的人脸",
      "fullDesc": "免费使用 AI 在线交换两张照片中的人脸。上传一张目标照片和一张清晰的源人脸，生成符合目标姿势、光线和构图的自然换脸结果。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "targetImage": "目标图",
      "sourceImage": "源人脸",
      "effectImageLabel": "效果图",
      "processButton": "开始换脸",
      "targetPreviewAlt": "AI 换脸目标照片预览",
      "sourcePreviewAlt": "AI 换脸源人脸预览",
      "processingAlt": "AI 换脸处理预览",
      "resultBeforeAlt": "换脸前的目标照片",
      "resultAfterAlt": "AI 换脸后的照片",
      "downloadName": "换脸结果.png",
      "step1Title": "上传图片",
      "step1Desc": "上传目标图片和源人脸图片",
      "step2Title": "AI 换脸",
      "step2Desc": "点击处理，AI 自动完成换脸",
      "step3Title": "下载结果",
      "step3Desc": "预览效果，下载换脸后的图片",
      "featuresKicker": "自然人脸替换",
      "featuresTitle": "使用 AI 交换两张照片中的人脸",
      "featuresIntro": "目标照片提供姿势和构图，清晰的源人脸用于完成聚焦明确的图片换脸。",
      "features": [
        { "title": "生成自然的 AI 换脸效果", "desc": "AI 将源人脸身份融合到目标照片中，并尽量匹配目标姿势、画面、光线和整体风格。", "cta": "免费生成 AI 换脸照片" },
        { "title": "保留目标照片构图", "desc": "可以使用人像、自拍、角色图片或创意场景作为目标，并保留原有背景和构图。", "cta": "免费体验 AI 换脸" },
        { "title": "使用清晰的源人脸", "desc": "上传正面、光线充足且面部细节清楚的源图片，有助于获得更稳定的替换效果。", "cta": "免费上传并换脸" }
      ],
      "useCasesKicker": "创意照片玩法",
      "useCasesTitle": "在线 AI 换脸的常见用途",
      "useCasesIntro": "使用一张目标图片和一张源人脸，制作有趣的创意照片。",
      "useCases": [
        { "title": "自拍与头像换脸", "desc": "在保留目标姿势、背景和构图的同时替换自拍或人像中的面孔。使用清晰的源人脸探索头像创意和个性化人像效果。", "cta": "免费制作人像换脸", "imageAlt": "自拍和头像 AI 换脸使用场景" },
        { "title": "表情包与社交反应图", "desc": "把熟悉的照片制作成个性化表情包、趣味反应图和便于分享的社交内容。目标图表情越清晰，最终图片越容易辨认。", "cta": "免费制作表情包换脸", "imageAlt": "表情包和社交反应图使用场景" },
        { "title": "Cosplay、角色与创意故事", "desc": "尝试把人脸放入服装造型、幻想人像、插画角色或主题场景中，用于探索角色概念和创作视觉故事。", "cta": "免费体验角色换脸", "imageAlt": "Cosplay 和角色换脸使用场景" }
      ],
      "howToKicker": "简单三步",
      "howToTitle": "如何使用 AI 在线交换照片人脸",
      "howToIntro": "选择目标照片、添加清晰的源人脸，然后让 AI 生成换脸结果。",
      "faqTitle": "AI 换脸常见问题",
      "faqs": [
        { "q": "如何在线交换两张照片中的人脸？", "a": "把需要保留姿势和构图的照片上传为目标图，再上传提供身份的人脸作为源图，然后开始处理。" },
        { "q": "目标照片和源人脸有什么区别？", "a": "目标照片提供姿势、背景和构图，源人脸提供用于替换的面部身份。" },
        { "q": "怎样选择适合换脸的源图片？", "a": "使用光线充足、无遮挡且面部清晰的照片。源图与目标图的角度和表情越接近，结果通常越稳定。" },
        { "q": "可以用 AI 换脸制作自拍、表情包或 Cosplay 照片吗？", "a": "可以。这些是常见的创意用途，但请确保你拥有上传图片或获得编辑授权。" },
        { "q": "为什么有时换脸效果不够自然？", "a": "人脸角度、光线、表情、分辨率差异过大，或面部被严重遮挡时，融合难度会增加。可以尝试更清晰、更匹配的源照片。" },
        { "q": "支持哪些图片格式和文件大小？", "a": "支持 JPG、PNG 和 WebP 图片，每张图片最大 15MB。" },
        { "q": "这个页面可以进行视频换脸吗？", "a": "不可以。当前页面只处理静态图片并返回图片结果。" }
      ]
    },
    "image-enhancer": {
      "name": "图片增强器",
      "desc": "AI 一键提升图片清晰度",
      "fullDesc": "一键提升图片分辨率和画质，支持高清放大至 4K。使用先进的 AI 算法增强细节，让模糊图片变得清晰锐利。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的 JPG、PNG 或 WebP。",
      "notImageFile": "请上传图片文件。",
      "downloadName": "图片增强结果.png",
      "targetResolution": "目标分辨率",
      "outputFormat": "输出格式",
      "resolutions": {
        "2k": "2K",
        "4k": "4K",
        "8k": "8K"
      },
      "formats": {
        "JPEG": "JPEG",
        "PNG": "PNG",
        "WEBP": "WEBP"
      },
      "processFailed": "处理失败，请换一张图片或更换格式后重试。"
    },
    "doc-crop-enhance": {
      "name": "图像切边矫正",
      "desc": "AI 一键切边并矫正文档形变",
      "fullDesc": "免费在线裁剪文档边缘，矫正倾斜、透视和弯曲，并通过增亮、锐化、黑白、灰度和去阴影提升扫描件清晰度。适合处理试卷、作业、教材和课堂讲义。",
      "enhanceMode": "增强模式",
      "enhanceModes": {
        "disabled": "禁用增强",
        "brighten": "增亮",
        "sharpen": "增强并锐化",
        "blackWhite": "黑白",
        "grayscale": "灰度",
        "deshadow": "去阴影增强",
        "bitmap": "点阵图"
      },
      "cropImage": "切边",
      "dewarpImage": "矫正形变",
      "featuresKicker": "文档扫描优化",
      "featuresTitle": "从手机文档照片到清晰规整的扫描效果",
      "featuresIntro": "自动处理文档边缘、倾斜、透视、弯曲、阴影和文字清晰度，覆盖常见文档拍摄与扫描优化需求。",
      "features": [
        { "title": "自动识别边缘并裁剪文档", "desc": "识别纸张和背景之间的边界，自动裁掉桌面、阴影边缘和无关画面，让文档页面更加规整。", "cta": "免费试用文档切边" },
        { "title": "矫正倾斜和透视变形", "desc": "修复手机斜拍造成的梯形、倾斜和比例失真，让合同、表格和试卷恢复正面视角。", "cta": "在线矫正文档照片" },
        { "title": "修复弯曲书页与扫描文档", "desc": "矫正书本装订处、卷曲纸张和弯折页面产生的形变，改善教材与书页照片的阅读效果。", "cta": "立即修复弯曲文档" },
        { "title": "去除扫描件和文档照片阴影", "desc": "减轻手机、手指、书脊和环境光造成的阴影，使票据、讲义和扫描文档背景更均匀。", "cta": "在线清理文档阴影" },
        { "title": "增亮并锐化扫描文字", "desc": "提高低对比度文档的亮度和文字边缘清晰度，方便阅读、打印以及后续资料整理。", "cta": "立即增强扫描文字" },
        { "title": "生成黑白、灰度或点阵扫描效果", "desc": "根据打印和归档需求，将彩色文档照片处理为黑白、灰度或点阵增强效果。", "cta": "免费优化文档图片" }
      ],
      "useCasesKicker": "常见使用场景",
      "useCasesTitle": "哪些文档图片适合切边矫正和增强？",
      "useCasesIntro": "适用于手机拍摄、扫描不规整、背景有阴影或文字不够清晰的单张文档图片。",
      "useCases": [
        { "title": "手机拍照转扫描效果", "desc": "裁掉桌面背景并修正拍摄角度，让手机照片更接近扫描件。" },
        { "title": "合同和表格切边", "desc": "整理合同、申请表和登记表边缘，恢复规整的页面比例。" },
        { "title": "票据与收据增强", "desc": "减少票据阴影并锐化浅色文字，提升查看和归档清晰度。" },
        { "title": "书页弯曲矫正", "desc": "修复教材、书籍和练习册在装订处产生的弯曲变形。" },
        { "title": "试卷和讲义优化", "desc": "矫正倾斜试卷，去除阴影并增强印刷文字，方便打印复用。" },
        { "title": "黑白文档归档", "desc": "将文档照片转换为黑白或灰度扫描风格，便于统一整理。" }
      ],
      "faqTitle": "AI 文档切边矫正常见问题",
      "faqs": [
        { "q": "什么是 AI 文档切边矫正？", "a": "它会识别图片中的文档区域，裁掉边缘背景，并根据设置修复倾斜、透视或弯曲形变。" },
        { "q": "能否自动识别并裁剪文档边缘？", "a": "可以。开启切边后，工具会尝试检测纸张边缘并移除文档外部的背景区域。" },
        { "q": "可以修复倾斜、透视和弯曲页面吗？", "a": "开启形变矫正后，可以尝试修复手机斜拍、透视变形和书页弯曲，效果取决于边缘完整度和图片清晰度。" },
        { "q": "去阴影和锐化模式有什么区别？", "a": "去阴影主要改善背景亮度不均；锐化主要增强文字和线条边缘。可根据原图问题选择相应模式。" },
        { "q": "哪种模式适合试卷、合同和票据？", "a": "有明显阴影时选择去阴影，文字偏淡时选择锐化，需要打印时可尝试黑白或灰度模式。" },
        { "q": "能把手机拍摄的文档变成扫描效果吗？", "a": "可以通过自动切边、形变矫正和增强模式改善手机照片，但输出仍为图片，不会生成 PDF 或 OCR 文字。" },
        { "q": "支持哪些图片格式和大小？", "a": "支持 JPG、PNG 和 WebP 图片，单个文件不超过 15MB。" },
        { "q": "处理会改变文档中的文字内容吗？", "a": "工具主要调整边缘、几何形变、亮度和清晰度，不提供文字编辑或内容提取功能。" }
      ],
      "education": {
        "kicker": "教育资料处理",
        "title": "让试卷、作业和教材照片更像清晰扫描件",
        "intro": "自动识别教育资料边缘，修复手机拍摄造成的倾斜、透视、弯曲和阴影，便于打印、归档和课堂使用。",
        "items": [
          { "title": "试卷拍照自动裁剪", "desc": "识别试卷边缘并去除桌面背景，将手机拍摄的试卷整理为规整页面。" },
          { "title": "作业图片切边矫正", "desc": "矫正倾斜和透视变形，让作业照片更便于查看、提交和打印。" },
          { "title": "教材书页弯曲矫正", "desc": "修复书本装订处造成的弯曲，并减少书页阴影对阅读的影响。" },
          { "title": "讲义文字锐化增强", "desc": "增亮并锐化课堂讲义和学习资料，生成更清晰的黑白或灰度扫描效果。" }
        ],
        "relatedTitle": "需要清除试卷上的手写答案？",
        "relatedDesc": "本工具负责切边、形变矫正和画面增强；如需擦除学生答案、计算过程或红笔批注，请使用手写文字擦除工具。",
        "relatedCta": "前往手写文字擦除"
      },
      "notImageFile": "请上传有效的图片文件",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片",
      "noImageInResponse": "处理失败，请重试",
      "downloadName": "doc-crop-enhanced.png"
    },
    "handwritten-erase": {
      "name": "AI 手写文字擦除工具",
      "desc": "AI 自动擦除试卷和文档中的手写字",
      "fullDesc": "免费在线擦除试卷、作业、练习册和扫描文档中的手写文字，同时尽量保留印刷试题和原始版面。支持自动旋转、切边和弯曲矫正。",
      "featuresKicker": "文档手写内容擦除",
      "featuresTitle": "擦除手写内容，还原干净文档",
      "featuresIntro": "适用于试卷、合同和扫描文档整理，清理手写答案、修改批注与审核标记，同时尽量保留印刷文字和原始版面。",
      "features": [
        { "title": "一键擦除试卷中的学生手写答案", "desc": "自动识别试卷上的手写答案、计算过程和批注，适合清理学生已作答的试卷。", "cta": "免费清理试卷答案" },
        { "title": "擦除合同中的手写内容", "desc": "清理合同上的手写补充、圈画、金额修改、箭头和审核批注，同时尽量保留印刷条款、表格与原始版面。", "cta": "在线清理合同手写内容" },
        { "title": "教师备课与试卷重新打印", "desc": "清理学生答案、红笔批注和手写标记，为课堂讲解、组卷和资料归档准备干净版本。", "cta": "试用教师试卷清理工具" },
        { "title": "清理扫描文档中的手写标记", "desc": "擦除扫描表格、检查报告和办公文档中的勾选、箭头、圈画、边注及审核标记，恢复清晰印刷内容。", "cta": "立即清理扫描文档标记" }
      ],
      "useCasesKicker": "学生与教师场景",
      "useCasesTitle": "AI 手写擦除适合哪些教育场景？",
      "useCases": [
        { "title": "试卷答案清理", "desc": "擦除学生试卷中的手写答案和计算过程。" },
        { "title": "错题试卷重做", "desc": "将已答试卷还原为可重新练习的干净版本。" },
        { "title": "练习册答案擦除", "desc": "清理练习册、作业和练习题中的手写内容。" },
        { "title": "教师备课与组卷", "desc": "制作便于课堂讲解、重新打印和归档的试卷。" },
        { "title": "扫描试卷矫正", "desc": "自动旋转、切边并矫正弯曲或倾斜的扫描文档。" },
        { "title": "合同和笔记清理", "desc": "去除一般文档中的手写字、签注和标记。" }
      ],
      "howToKicker": "简单三步",
      "howToTitle": "如何在线擦除试卷手写答案？",
      "howToIntro": "上传试卷或文档图片，选择方向、切边和弯曲矫正设置，然后下载处理结果。",
      "steps": {
        "upload": { "title": "上传试卷或文档", "desc": "上传 15MB 以内的 JPG、PNG 或 WebP 试卷、作业或扫描文档。" },
        "process": { "title": "设置并擦除手写字", "desc": "选择文档方向，并按需开启切边和弯曲矫正，然后开始处理。" },
        "download": { "title": "检查并下载结果", "desc": "对比处理前后效果，下载干净文档或继续处理新图片。" }
      },
      "faqTitle": "AI 试卷手写答案擦除常见问题",
      "faqs": [
        { "q": "可以去除学生试卷上的手写答案吗？", "a": "可以。工具会识别试卷中的手写答案、计算过程和批注，并尽量保留印刷试题和版面。" },
        { "q": "能否保留印刷试题并还原空白试卷？", "a": "可以尝试还原干净试卷。手写内容未大面积覆盖印刷文字时，通常更容易保留原有题目。" },
        { "q": "教师可以用它清理和重新打印试卷吗？", "a": "可以，可用于教师备课、课堂讲解、重新组卷和试卷资料归档。" },
        { "q": "学生可以还原错题试卷重新练习吗？", "a": "可以，将已经作答的试卷或练习题清理后，可作为错题重做和复习材料。" },
        { "q": "支持擦除铅笔字、圆珠笔字和红笔批注吗？", "a": "可以尝试处理不同颜色和书写工具形成的手写内容，效果取决于字迹清晰度及其与印刷文字的重叠程度。" },
        { "q": "可以同时矫正倾斜或弯曲的试卷吗？", "a": "支持方向旋转、自动方向识别、切边和弯曲矫正，可在擦除手写字时按需启用。" },
        { "q": "支持哪些图片格式？", "a": "支持 15MB 以内的 JPG、PNG 和 WebP 图片，当前页面不处理 PDF。" }
      ],
      "docDirection": "方向旋转",
      "docDirections": {
        "none": "不旋转",
        "rotate90": "顺时针90°",
        "rotate180": "顺时针180°",
        "rotate270": "顺时针270°",
        "auto": "自动识别"
      },
      "crop": "切边",
      "dewarp": "弯曲矫正",
      "notImageFile": "请上传有效的图片文件",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片",
      "noImageInResponse": "处理失败，请重试",
      "downloadName": "handwritten-erased.png"
    },
    "video-enhancer": {
      "name": "视频增强",
      "desc": "使用 AI 提升视频画质与分辨率",
      "fullDesc": "使用 AI 将视频提升至高清/4K，支持帧插值与锐化。",
      "notVideoFile": "请上传视频文件（如 MP4、MOV、AVI）。",
      "fileTooLarge": "视频文件过大，请使用 100MB 以内的文件。"
    },
    "cartoon-video-style-converter": {
      "name": "卡通风格转化器",
      "desc": "将视频转换为卡通风格",
      "fullDesc": "上传视频后，AI 会将画面转换为卡通风格，保留主要运动和构图，生成风格化视频结果。",
      "notVideoFile": "请上传有效的视频文件。",
      "fileTooLarge": "视频文件过大，请选择 100MB 以内的视频。",
      "downloadName": "卡通风格视频.mp4"
    },
    "anime-video-style-converter": {
      "name": "动漫风格转化器",
      "desc": "将视频转换为动漫风格",
      "fullDesc": "上传视频后，AI 会将画面转换为动漫风格，保留主体动作和镜头节奏，生成动漫化视频结果。",
      "notVideoFile": "请上传有效的视频文件。",
      "fileTooLarge": "视频文件过大，请选择 100MB 以内的视频。",
      "downloadName": "动漫风格视频.mp4"
    },
    "oil-painting-video-style-converter": {
      "name": "油画风格转化器",
      "desc": "将视频转换为油画风格",
      "fullDesc": "上传视频后，AI 会将画面转换为油画风格，呈现更丰富的色彩层次和绘画质感。",
      "notVideoFile": "请上传有效的视频文件。",
      "fileTooLarge": "视频文件过大，请选择 100MB 以内的视频。",
      "downloadName": "油画风格视频.mp4"
    },
    "cyberpunk-video-style-converter": {
      "name": "赛博朋克风格转化器",
      "desc": "将视频转换为赛博朋克风格",
      "fullDesc": "上传视频后，AI 会将画面转换为赛博朋克风格，生成高对比、霓虹感的未来视觉效果。",
      "notVideoFile": "请上传有效的视频文件。",
      "fileTooLarge": "视频文件过大，请选择 100MB 以内的视频。",
      "downloadName": "赛博朋克风格视频.mp4"
    },
    "photo-restore": {
      "name": "照片修复",
      "desc": "使用 AI 修复老旧、模糊或破损照片",
      "fullDesc": "使用 AI 修复老旧、模糊或破损照片，支持降噪、增强清晰度和补全缺失区域，让珍贵回忆重新清晰。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "老照片修复结果.png"
    },
    "blurry-photo-repair": {
      "name": "修复模糊图片",
      "desc": "使用 AI 修复模糊图片并恢复清晰细节",
      "fullDesc": "使用 AI 修复模糊图片，增强清晰度，恢复面部、纹理等细节，让发虚照片更清晰。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "模糊图片修复结果.png"
    },
    "cartoon-digital-human": {
      "name": "AI 卡通角色生成器",
      "desc": "将人物照片转换成卡通风格",
      "fullDesc": "将人物照片生成动漫卡通数字人头像，保留人物可识别特征，同时生成线条干净、色彩鲜明、适合作为头像的卡通效果。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "卡通数字人结果.png"
    },
    "manga-digital-human": {
      "name": "AI 漫画风格角色生成器",
      "desc": "将人物照片转换成漫画风格",
      "fullDesc": "将人物照片生成漫画风格数字人头像，保留人物可识别特征，同时生成线条有表现力、明暗层次清晰的漫画效果。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "漫画数字人结果.png"
    },
    "oil-painting-digital-human": {
      "name": "AI 油画肖像生成器",
      "desc": "将人物照片转换成油画风格",
      "fullDesc": "将人物照片生成油画风格数字人头像，保留人物可识别特征，同时生成色彩丰富、笔触自然的油画肖像效果。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "油画数字人结果.png"
    },
    "id-photo-generator": {
      "name": "证件照生成器",
      "desc": "将人像照片生成规范的证件照",
      "fullDesc": "使用 AI 将人像照片生成干净、专业的证件照效果，自动整理主体呈现，适合头像、资料照和证件照风格用途。",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "downloadName": "证件照结果.png"
    },
    "ai-change-clothes": {
      "name": "AI 服装更换",
      "desc": "上传服装图和人物图，一键换装",
      "fullDesc": "第一张上传服装图片，第二张上传人物图片。AI 将指定服装迁移到人物照片中，保留人物主体、姿态和自然画面细节。",
      "demoTitle": "效果演示",
      "notImageFile": "请上传有效的图片文件。",
      "fileTooLarge": "图片过大，请选择 15MB 以内的图片。",
      "firstImageLabel": "衣服",
      "uploadFirstImage": "上传衣服图片",
      "changeFirstImage": "更换衣服图片",
      "secondImageLabel": "人物",
      "uploadSecondImage": "上传人物图片",
      "changeSecondImage": "更换人物图片",
      "uploadingSecondImage": "人物图片上传中...",
      "downloadName": "AI换装结果.png"
    },
    "category": {
      "image": "图片处理",
      "video": "视频处理",
      "document": "文档处理"
    },
    "categoryModal": {
      "title": "选择工具分类"
    },
    "convert": {
      "success": "转换完成！",
      "zipHint": "结果已打包为 ZIP 文件，包含多张图片",
      "fileTooLarge": "文件过大，请选择 50MB 以内的文件",
      "multiImageHint": "支持上传多张图片，合并为一个 PDF",
      "addMore": "继续添加",
      "demoTitle": "转换示意",
      "sourceLabel": "源格式",
      "targetLabel": "目标格式"
    },
    "pdf-to-word": {
      "name": "PDF转Word",
      "desc": "将PDF文件转换为可编辑的Word文档",
      "fullDesc": "将PDF文件智能转换为可编辑的Word文档，精准还原文档排版、表格、图片等内容，支持中英文混排。"
    },
    "image-to-word": {
      "name": "图片转Word",
      "desc": "将图片中的文字识别并转换为Word文档",
      "fullDesc": "将图片中的文字、表格等内容智能识别并还原为Word文档，保留原始版面格式，支持印章提取和手写文字识别。"
    },
    "pdf-to-excel": {
      "name": "PDF转Excel",
      "desc": "将PDF表格转换为可编辑的Excel文件",
      "fullDesc": "将PDF文件中的表格内容智能识别并转换为可编辑的Excel文件，精准还原表格结构和数据。"
    },
    "pdf-to-ppt": {
      "name": "PDF转PPT",
      "desc": "将PDF文件转换为可编辑的PPT演示文稿",
      "fullDesc": "将PDF文件智能转换为可编辑的PPT演示文稿，保留原始排版、图片和文字内容。"
    },
    "pdf-to-image": {
      "name": "PDF转图片",
      "desc": "将PDF每页转换为高清图片",
      "fullDesc": "将PDF文件的每一页转换为高清图片，支持多页PDF批量转换，结果打包为ZIP下载。"
    },
    "word-to-pdf": {
      "name": "Word转PDF",
      "desc": "将Word文档转换为PDF文件",
      "fullDesc": "将Word文档快速转换为PDF文件，保留原始排版、字体和图片，确保格式一致性。"
    },
    "excel-to-pdf": {
      "name": "Excel转PDF",
      "desc": "将Excel表格转换为PDF文件",
      "fullDesc": "将Excel表格转换为PDF文件，保留表格结构和数据排版，便于分享和打印。"
    },
    "image-to-pdf": {
      "name": "图片转PDF",
      "desc": "将多张图片合并为一个PDF文件",
      "fullDesc": "将多张图片合并生成一个PDF文件，支持JPG、PNG、BMP等常见图片格式，便于统一管理和分享。"
    },
    "word-to-image": {
      "name": "Word转图片",
      "desc": "将Word文档每页转换为图片",
      "fullDesc": "将Word文档的每一页转换为高清图片，支持多页文档批量转换，结果打包为ZIP下载。"
    }
  },
  "plans": {
    "basic": {
      "name": "基础版",
      "features": [
        "所有积分一次性发放",
        "最高可生成 2,600 张 AI 图片",
        "可生成 520 个 AI 视频",
        "最高可生成 480 首 AI 音乐",
        "FLUX 与 Runway 访问",
        "无水印",
        "商业许可"
      ]
    },
    "pro": {
      "name": "专业版",
      "features": [
        "所有积分一次性发放",
        "最高可生成 10,600 张 AI 图片",
        "最高可生成 2,120 支 AI 视频",
        "最高可生成 1,920 首 AI 音乐",
        "所有高级模型",
        "优先队列",
        "优先支持",
        "隐私模式与 DPA 合规文件"
      ]
    },
    "ultimate": {
      "name": "极致",
      "features": [
        "所有积分一次性发放",
        "最高可生成 36,600 张 AI 图片",
        "最高可生成 7,320 支 AI 视频",
        "最高可生成 6,720 首 AI 音乐",
        "所有高级模型",
        "API 访问",
        "专属支持",
        "隐私模式与 DPA 合规文件"
      ]
    }
  },
  "faq": {
    "categories": {
      "all": "全部",
      "general": "通用",
      "pricing": "定价",
      "models": "模型",
      "features": "功能"
    },
    "items": [
      {
        "q": "什么是 Miral？",
        "a": "Miral 是一个一站式 AI 创作平台，集成了全球 29+ 顶级 AI 模型，支持图像生成、视频创作、音乐制作及专业编辑工具。无需在多个平台间切换，一个账号即可调用 FLUX、Midjourney、Sora、Veo、Kling 等所有主流模型。"
      },
      {
        "q": "支持哪些 AI 模型？",
        "a": "我们支持 29+ 顶级 AI 模型，包括图像模型（FLUX 2 Max、Midjourney、Seedream、GPT-Image-1、Nano Banana 等）、视频模型（Veo 3.1、Sora 2、Kling 2.6、Seedance、Wan 2.5 等）以及 AI 音乐生成模型。所有模型持续更新。"
      },
      {
        "q": "积分系统如何运作？",
        "a": "我们采用统一的积分系统。图片生成 2 积分起，视频生成 10 积分起，音乐生成每支曲目 10 积分。高级模型可能消耗更多积分。订阅用户享受更低的积分单价，也可单独购买积分包。"
      },
      {
        "q": "可以生成图片、视频和音乐吗？",
        "a": "是的！Miral 支持文生图、图像编辑、风格迁移、文生视频、图片转视频、AI 音乐创作等全方位创作功能，满足从个人创作到商业项目的各种需求。"
      },
      {
        "q": "生成速度怎么样？",
        "a": "多数图像生成可在 30 秒内完成，视频生成约需 1-6 分钟。我们持续优化底层架构，确保快速稳定的生成体验。"
      },
      {
        "q": "我可以将 Miral 用于商业用途吗？",
        "a": "可以。所有付费方案均包含商业许可，您可以将生成的内容用于商业项目、营销材料、社交媒体等用途。"
      },
      {
        "q": "提供 API 接入吗？",
        "a": "是的，极致版方案包含 API 访问权限。通过我们完善的 API，您可以将 AI 图像、视频和音乐生成功能直接集成到您的应用中。"
      },
      {
        "q": "可以用 AI 生成音乐吗？",
        "a": "当然可以！我们的 AI 音乐生成器支持多种音乐风格，只需输入描述即可生成原创音乐作品，适用于视频配乐、播客背景音乐等场景。"
      },
      {
        "q": "你们如何处理数据隐私和安全？",
        "a": "我们严格遵守 GDPR 合规标准，所有数据加密存储，不参与 AI 训练。用户可随时注销账号并删除所有数据。"
      },
      {
        "q": "其他人能看到我的作品吗？",
        "a": "默认情况下，您的作品仅对您可见。专业版和极致版用户可启用隐私模式，确保作品完全私密。"
      },
      {
        "q": "如何注销账号并删除数据？",
        "a": "您可以在账号设置中随时申请注销账号，我们将在 30 天内删除您的所有数据和生成内容。"
      },
      {
        "q": "如果遇到问题，我可以获得支持吗？",
        "a": "当然！您可以通过 miral_support@miralvis.com 联系我们的支持团队。专业版用户享有优先支持，极致版用户享有专属支持服务。"
      }
    ]
  },
  "testimonials": {
    "items": [
      {
        "name": "Alex Chen",
        "role": "数字营销总监",
        "tag": "节省90%时间",
        "content": "Miral 已成为我们的视觉内容中心。用 Midjourney 生成产品图，用 Veo 做宣传片，再用 Miral 统一修图，全程无需切换平台。"
      },
      {
        "name": "Sarah Rodriguez",
        "role": "电商店主",
        "tag": "提升40%转化率",
        "content": "一站式调用 29+ 模型简直是神器。我用 Seedream 拍产品，Seedance 做视频广告，再用放大工具出画册。转化率提升了 40%！"
      },
      {
        "name": "David Kim",
        "role": "内容创作者",
        "tag": "超过500K粉丝",
        "content": "我先用 FLUX 和 Nano Banana 出图，再用可灵和 Sora 转成爆款视频。积分制很合理，按需使用，粉丝们非常喜欢这种多样化的内容！"
      },
      {
        "name": "Emma Thompson",
        "role": "平面设计师",
        "tag": "专业级别",
        "content": "作为设计师，我曾对 AI 平台持怀疑态度。但 Miral 丰富的模型库和精准的编辑工具确实惊艳，从概念草图到最终成品都能轻松搞定。"
      },
      {
        "name": "James Wilson",
        "role": "视频制作",
        "tag": "工作流提速 10 倍",
        "content": "这里的视频模型太强了——Veo 极具电影感，Seedance 出片极快，Wan 的人物动效非常自然。所有模型共用一套积分系统，省时又省钱。"
      },
      {
        "name": "Lisa Park",
        "role": "创意机构负责人",
        "tag": "团队首选",
        "content": "我们团队已全员转向 Miral。API 接入非常顺滑，丰富的模型选择让我们总能找到最合适的工具。这是目前最好用的 AI 平台。"
      }
    ]
  },
  "langModal": {
    "title": "选择语言"
  },
  "home": {
    "searchModel": "搜索模型...",
    "newModels": "最新模型",
    "otherModels": "其他模型",
    "selectModel": "选择模型",
    "promptPlaceholderImage": "描述你想创建的图片...",
    "promptPlaceholderVideo": "描述你想创建的视频...",
    "generate": "生成",
    "chatDisabledGenerateHint": "请输入提示词",
    "compactChatPlaceholder": "输入提示词，生成精美的 AI 图像、视频和原创音乐",
    "hero": {
      "title": "Miral – 一站式 AI 图像、视频与音乐创作平台",
      "subtitle": "由多功能 AI 模型驱动，Miral 支持一站式图像编辑、视频生成和 AI 音乐创作。编辑照片、制作电影感人像视频，并为个人和商业创作定制背景音乐。",
      "createVideo": "创建视频",
      "createImage": "创建图片"
    },
    "stats": {
      "models": "顶级 AI 模型",
      "works": "已生成作品",
      "tools": "专业工具",
      "platforms": "合作平台"
    },
    "generatorNew": {
      "promptPlaceholder": "描述你想生成的视频内容...",
      "promptPlaceholderImage": "描述你想生成的图片内容...",
      "generating": "生成中...",
      "noHistory": "生成结果将在这里展示",
      "generationFailed": "生成失败",
      "historyTitle": "历史记录",
      "myAssets": "我的资产"
    },
    "quickTools": {
      "title": "快捷 AI 工具"
    },
    "exploreMore": {
      "title": "探索更多 AI 功能"
    },
    "musicPresets": [
      { "label": "欢快流行金曲", "value": "Upbeat Pop Anthem" },
      { "label": "放松 Lo-fi 节拍", "value": "Chill Lo-fi Beat" },
      { "label": "电影史诗配乐", "value": "Cinematic Epic Score" },
      { "label": "民谣吉他弹唱", "value": "Acoustic Folk Song" },
      { "label": "电子舞曲", "value": "Electronic Dance Track" },
      { "label": "爵士酒吧氛围", "value": "Jazz Lounge Vibe" },
      { "label": "摇滚力量之歌", "value": "Rock Power Ballad" },
      { "label": "冥想环境音乐", "value": "Ambient Meditation" }
    ],
    "musicPresetsPlaceholder": "选择音乐预设",
    "platform": {
      "tag": "平台",
      "title": "让创作更简单的 AI 工具箱",
      "subtitle": "集图像生成、视频创作、音乐制作及专业工具于一体，由行业领先的 AI 模型驱动。",
      "tabs": {
        "image": "AI图片",
        "video": "AI视频",
        "music": "AI 音乐",
        "tools": "AI 工具箱"
      },
      "image": {
        "title": "利用全球顶尖 AI 模型，生成并编辑惊艳图像",
        "desc": "涵盖文生图、精准编辑、风格迁移及高清放大。借助 FLUX、Midjourney、Seedream、GPT-Image-1 和 Nano Banana，让想象力落地。",
        "explore": "探索图像模型 →"
      },
      "video": {
        "title": "用 AI 创作电影级视频内容",
        "desc": "从文生视频到图片动效，支持 Veo、Sora、Kling、Seedance 及 Wan 等顶级模型，轻松生成带同步音效和专业运镜的视频。",
        "explore": "探索视频模型 →"
      },
      "music": {
        "title": "AI 驱动的原创音乐创作",
        "desc": "输入描述即可生成原创音乐，支持多种风格和时长。适用于视频配乐、播客背景音乐、社交媒体内容等场景。",
        "explore": "探索 AI 音乐 →"
      },
      "tools": {
        "title": "专业级 AI 工具箱",
        "desc": "去除水印、修复旧照片、高清放大、视频增强等专业工具，满足各种后期处理需求。",
        "explore": "查看所有工具 →"
      }
    },
    "models": {
      "tag": "模型",
      "title": "全球顶级 AI 模型一站式集成",
      "subtitle": "一个平台集成所有主流 AI 模型，告别多账号切换和繁琐订阅。",
      "imageModels": "图像模型",
      "videoModels": "视频模型",
      "musicModels": "AI 音乐",
      "musicDesc": "输入描述即可生成原创音乐",
      "filterAll": "全部",
      "credits": "积分",
      "viewAll": "查看全部 →"
    },
    "features": {
      "tag": "核心功能",
      "title": "创作惊艳的图片、视频与音乐",
      "subtitle": "从文生图、文生视频到 AI 音乐创作，再到精准编辑和高清放大 —— 全能创作，一站式搞定。",
      "items": {
        "textToImage": {
          "tag": "文转图",
          "title": "文转图",
          "desc": "输入描述，见证奇迹。无论是超写实人像还是奇幻景观，利用 Midjourney、Seedream、Nano Banana 等模型，简单提示词即可生成视觉大片。",
          "cta": "图像生成",
          "imageAlt": "利用 Midjourney、Seedream、Nano Banana 等模型，简单提示词即可生成视觉大片"
        },
        "imageEdit": {
          "tag": "图像编辑与风格迁移",
          "title": "图像编辑与风格迁移",
          "desc": "利用 AI 精准重塑图像。无论是切换风格、修改物体、更换背景还是编辑文字，都能保持高度一致性。",
          "cta": "图像编辑",
          "beforeAlt": "图像编辑与风格迁移之前",
          "afterAlt": "图像编辑与风格迁移之后"
        },
        "textToVideo": {
          "tag": "文本转视频",
          "title": "文本转视频",
          "desc": "只需输入提示词，即可生成带同步音效、专业运镜和逼真动态的电影感视频。可选 Veo、Sora、Kling、Seedance 及 Wan 模型。",
          "cta": "视频生成"
        },
        "imageToVideo": {
          "tag": "图片转视频",
          "title": "图片转视频",
          "desc": "让静态图秒变电影级动态视频。无论是产品图、插画还是 AI 生成的图像，都能通过自然动效和配音焕发生机。",
          "cta": "图片动效"
        },
        "upscale": {
          "tag": "图影高清放大",
          "title": "图影高清放大",
          "desc": "利用 AI 提升图影画质。支持细节无损的高清放大，并将视频分辨率增强至 4K 专业级别。",
          "cta": "立即高清放大",
          "imageAlt": "利用 AI 提升图影画质"
        },
        "templates": {
          "tag": "40+ 图像模板",
          "title": "40+ 图像模板",
          "desc": "海量模板一键激发灵感：3D 模型、吉卜力画风、潮玩手办、表情包生成器、杂志封面等——上传照片，即刻出片。",
          "cta": "浏览模板",
          "imageAlt": "图像模板示例"
        }
      }
    },
    "gallery": {
      "tag": "作品画廊",
      "title": "探索无限可能",
      "subtitle": "看看创作者们正用 Miral 打造什么 —— 从超写实大片到电影级视频，灵感触手可及。",
      "images": {
        "alt1": "Midjourney 生成图像示例",
        "alt2": "Seedream 生成图像示例",
        "alt3": "GPT-Image-1 生成图像示例",
        "alt4": "Flux 生成图像示例",
        "alt5": "Flux Pro 生成图像示例",
        "alt6": "Midjourney 生成图像示例",
        "alt7": "Seedream 生成图像示例",
        "alt8": "GPT-Image-1 生成图像示例"
      }
    },
    "whyChoose": {
      "tag": "为什么选择 Miral",
      "title": "全能创作，应有尽有",
      "subtitle": "一站式平台，汇聚全球顶尖的 AI 图像、视频和音乐创作模型。",
      "items": {
        "allModels": {
          "title": "全模型集成，一个就够了",
          "desc": "一站式调用 OpenAI、Google、阿里、字节跳动等 29+ 顶级 AI 模型，无需在不同工具间切换，更不用管理多个订阅。"
        },
        "fast": {
          "title": "闪电般快速",
          "desc": "多数图像生成可在 30 秒内完成，视频生成约需 1-6 分钟。优化的底层架构确保你无需漫长等待。"
        },
        "credits": {
          "title": "简单的积分系统",
          "desc": "按需付费，价格透明。从免费积分开始体验——无需订阅即可开启创作。"
        },
        "api": {
          "title": "开发者 API",
          "desc": "通过我们完善的 API，将 AI 图像、视频和音乐生成功能直接集成到你的应用中。基于顶尖 AI 模型构建你的产品。"
        }
      }
    },
    "testimonials": {
      "tag": "用户故事",
      "title": "受到全球创作者信赖",
      "subtitle": "加入成千上万专业人士与创作者的行列，使用 Miral 生成图像、创作视频，全面赋能你的创意工作流。"
    },
    "faq": {
      "tag": "支持",
      "title": "常见问题解答",
      "subtitle": "关于平台、支持模型、价格方案及功能特性的全方位指南。"
    },
    "cta": {
      "title": "立即开启 AI 创作之旅",
      "subtitle": "加入数万名创作者、设计师和企业的行列，在 Miral 用全球顶尖 AI 模型实现创意。",
      "createImage": "创建图片 →",
      "createVideo": "创建视频 →",
      "note": "新用户注册即送免费积分，无需绑定信用卡。"
    },
    "apps": {
      "title": "应用",
      "quickTitle": "快捷 AI 应用",
      "more": "更多",
      "keywords": {
        "viralVideo": "社交短视频带货",
        "tiktokAds": "短视频广告投放",
        "productShowcase": "电商产品演示",
        "aiAvatar": "数字人出镜口播",
        "homeModernKitchen": "室内效果图"
      },
      "social": "社交媒体",
      "posters": "海报",
      "interior": "家居",
      "entertainment": "娱乐",
      "lifestyle": "生活方式",
      "comic": "漫画",
      "items": {
        "viralVideo": "爆款视频",
        "celebrityVideo": "名人视频",
        "productShowcase": "产品展示",
        "tiktokAds": "TikTok 广告",
        "aiMeme": "AI 梗图",
        "aiAvatar": "AI 数字人",
        "logoAnimation": "Logo 动画",
        "socialShorts": "社交短视频",
        "brandStory": "品牌故事",
        "tutorialClip": "教程片段",
        "musicVideo": "AI 音乐视频",
        "animeScene": "动漫场景",
        "movieTrailer": "电影预告",
        "gameCinematic": "游戏过场",
        "visualPoetry": "视觉诗歌",
        "natureDoc": "自然纪录片",
        "cyberpunkCity": "赛博城市",
        "underwaterWorld": "水下世界",
        "timelapseArt": "延时艺术",
        "dailyVlog": "日常 Vlog",
        "cookingShow": "烹饪节目",
        "fitnessCoach": "健身教练",
        "travelDiary": "旅行日记",
        "fashionShow": "时尚秀场",
        "petParadise": "萌宠乐园",
        "weddingMoment": "婚礼时刻",
        "yogaFlow": "瑜伽流",
        "homeDecor": "家居装饰",
        "sunsetRun": "日落奔跑",
        "instagramReels": "Instagram Reels",
        "youtubeIntro": "YouTube 开场",
        "linkedinPromo": "LinkedIn 推广",
        "aiThumbnail": "AI 缩略图",
        "podcastClip": "播客片段",
        "horrorShort": "恐怖短片",
        "danceVideo": "舞蹈视频",
        "aiComic": "AI 漫画",
        "magicShow": "魔术表演",
        "fantasyWorld": "奇幻世界",
        "diyCraft": "手工制作",
        "morningRoutine": "晨间日常",
        "babyGrowth": "宝宝成长",
        "streetFood": "街头美食",
        "bookTrailer": "书籍预告",
        "socialLuxuryBag": "奢华手袋广告",
        "socialFashionVote": "穿搭投票",
        "socialSneakerDrop": "城市奢华球鞋",
        "socialTropicalCocktail": "周末鸡尾酒",
        "socialCityBillboard": "城市广告牌",
        "socialStreetwearDrop": "街头潮牌上新",
        "socialBoxingGloves": "拳击手套广告",
        "homeEclecticLiving": "现代混搭客厅",
        "homeFarmhouseKitchen": "农庄风厨房",
        "homeModernKitchen": "现代极简厨房",
        "homeVictorianStairs": "维多利亚楼梯",
        "homeScandiLiving": "北欧风客厅",
        "homeMediterraneanPatio": "地中海庭院",
        "homeBohoSunroom": "波西米亚日光室",
        "homeEclecticBedroom": "混搭风卧室",
        "comicPortrait": "超级英雄漫画",
        "animeCharacter": "机甲动漫",
        "mangaScene": "雨夜漫画",
        "comicOilPainting": "生活漫画",
        "comicCover": "能量英雄漫画",
        "animePortrait": "屋顶飞掠漫画",
        "comicCouple": "少年英雄漫画",
        "mangaWarrior": "魔法法师漫画"
      }
    }
  },
  "musicTags": {
    "pop": "流行",
    "electronic": "电子",
    "classical": "古典",
    "jazz": "爵士"
  },
  "music": {
    "breadcrumb": {
      "home": "首页",
      "aiMusic": "AI 音乐"
    },
    "model": {
      "label": "模型",
      "aiMusicName": "AI Music",
      "desc": "输入描述即可生成原创音乐，支持多种风格和时长。",
      "tagMusic": "音乐生成",
      "tagLyrics": "歌词创作"
    },
    "mode": {
      "describe": "描述",
      "lyrics": "写歌词"
    },
    "form": {
      "musicDesc": "音乐描述",
      "musicDescPlaceholder": "描述您想要的音乐风格、情感和场景...\n\n例如：一首轻快的电子音乐，带有未来感的合成器旋律，适合科技产品宣传片",
      "optimize": "优化",
      "songTitle": "歌曲标题",
      "songTitlePlaceholder": "输入歌曲标题...",
      "lyricsDescLabel": "歌词描述",
      "lyricsDescPlaceholder": "在这里写下你的歌词描述...\n\n例如：\n【前奏】\n...\n【主歌】\n...\n【副歌】\n...",
      "styleTags": "风格标签",
      "styleTagsPlaceholder": "点击下方标签快速添加（可多选）"
    },
    "tags": {
      "sections": [
        {
          "label": "前奏",
          "value": "【前奏】\n"
        },
        {
          "label": "主歌",
          "value": "【主歌】\n"
        },
        {
          "label": "副歌",
          "value": "【副歌】\n"
        },
        {
          "label": "桥段",
          "value": "【桥段】\n"
        },
        {
          "label": "尾声",
          "value": "【尾声】\n"
        }
      ],
      "styles": [
        {
          "label": "流行",
          "value": "Pop"
        },
        {
          "label": "摇滚",
          "value": "Rock"
        },
        {
          "label": "爵士",
          "value": "Jazz"
        },
        {
          "label": "古典",
          "value": "Classical"
        },
        {
          "label": "电子",
          "value": "Electronic"
        },
        {
          "label": "节奏布鲁斯",
          "value": "R&B"
        },
        {
          "label": "嘻哈",
          "value": "Hip-Hop"
        },
        {
          "label": "乡村",
          "value": "Country"
        },
        {
          "label": "民谣",
          "value": "Folk"
        },
        {
          "label": "氛围",
          "value": "Ambient"
        },
        {
          "label": "影视原声",
          "value": "Cinematic"
        },
        {
          "label": "低保真",
          "value": "Lo-fi"
        },
        {
          "label": "金属",
          "value": "Metal"
        },
        {
          "label": "雷鬼",
          "value": "Reggae"
        },
        {
          "label": "蓝调",
          "value": "Blues"
        },
        {
          "label": "灵魂",
          "value": "Soul"
        },
        {
          "label": "放克",
          "value": "Funk"
        },
        {
          "label": "独立",
          "value": "Indie"
        }
      ]
    },
    "options": {
      "duration": "时长",
      "instrumental": "纯音乐",
      "instrumentalDescOn": "仅生成伴奏，无人声",
      "instrumentalDescOff": ""
    },
    "errors": {
      "titleRequired": "歌词标题必填",
      "lyricsDescRequired": "歌词描述必填"
    },
    "footer": {
      "creditsRequired": "所需积分：",
      "creditsLeft": "剩余：",
      "generate": "生成音乐"
    },
    "preview": {
      "generating": "正在生成音乐...",
      "generatedTitle": "生成的音乐",
      "emptyTitle": "AI 音乐生成器",
      "emptySubtitle": "利用 AI 创作原创音乐。描述风格或输入歌词，几秒钟内即可生成专属歌曲。",
      "emptyTags": [
        "流行",
        "爵士",
        "影视原声",
        "低保真",
        "摇滚"
      ],
      "track": "音轨",
      "play": "播放",
      "pause": "暂停",
      "mute": "静音",
      "unmute": "取消静音",
      "download": "下载",
      "showLyrics": "显示歌词",
      "hideLyrics": "隐藏歌词",
      "generateFailed": "生成失败",
      "requestFailed": "请求失败，请重试",
      "downloadMp3": "下载 MP3",
      "downloadWav": "下载 WAV",
      "regenerate": "重新生成",
      "noHistory": "暂无历史记录"
    },
    "intro": {
      "title": "AI 音乐生成器",
      "desc": "使用先进的 AI 技术，只需输入描述或歌词，即可生成高质量的原创音乐。支持多种音乐风格，适用于视频配乐、广告、播客等场景。",
      "tagMusic": "音乐生成",
      "tagLyrics": "歌词创作",
      "tagStyles": "多风格支持",
      "tagCommercial": "商业授权"
    },
    "features": {
      "badge": "核心功能",
      "title": "AI 音乐生成器能为您做什么？",
      "items": {
        "styles": {
          "icon": "🎵",
          "title": "多风格支持",
          "desc": "支持流行、摇滚、电子、爵士、古典、嘻哈等数十种音乐风格，满足各种创作需求。"
        },
        "lyrics": {
          "icon": "📝",
          "title": "歌词创作",
          "desc": "输入歌词即可生成完整的歌曲，支持段落标记（Verse、Chorus 等），AI 自动编曲配乐。"
        },
        "vocals": {
          "icon": "🎤",
          "title": "人声合成",
          "desc": "支持男声、女声等多种音色，AI 演唱您的歌词，效果自然流畅。"
        },
        "instrumental": {
          "icon": "🎹",
          "title": "纯音乐模式",
          "desc": "生成高品质纯音乐伴奏，适用于视频配乐、播客背景音乐等场景。"
        },
        "fast": {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "先进的 AI 模型确保快速出曲，大多数音乐可在 30 秒内完成生成。"
        },
        "commercial": {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的音乐均可用于商业用途，包括视频、广告、播客等。"
        }
      }
    },
    "faq": {
      "title": "常见问题解答",
      "items": {
        "howItWorks": {
          "q": "AI 音乐生成器如何工作？",
          "a": "我们的 AI 音乐生成器使用先进的深度学习模型，根据您的文字描述或歌词生成原创音乐。您只需输入想要的音乐风格、情感和场景描述，AI 将自动创作完整的音乐作品。"
        },
        "commercial": {
          "q": "生成的音乐可以用于商业用途吗？",
          "a": "是的，使用我们平台生成的所有音乐均可用于商业用途，包括 YouTube 视频、广告、播客、游戏等。"
        },
        "styles": {
          "q": "支持哪些音乐风格？",
          "a": "支持流行、摇滚、电子、爵士、古典、嘻哈、R&B、乡村、金属、民谣等数十种音乐风格，您也可以混合多种风格创作独特的音乐。"
        },
        "credits": {
          "q": "每次生成需要多少积分？",
          "a": "根据选择的模型不同，每次生成消耗 8-10 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        "download": {
          "q": "生成的音乐可以下载吗？",
          "a": "是的，生成的音乐支持 MP3 和 WAV 两种格式下载，您可以根据需要选择合适的格式。"
        }
      }
    },
    "demoTracks": {
      "summerBreeze": {
        "title": "夏日微风",
        "style": "流行 / 轻快",
        "duration": "2:00"
      },
      "spaceJourney": {
        "title": "星际旅行",
        "style": "电子 / 未来感",
        "duration": "1:30"
      },
      "rainWalk": {
        "title": "雨中漫步",
        "style": "爵士 / 慵懒",
        "duration": "2:30"
      },
      "mountainDawn": {
        "title": "山间晨曦",
        "style": "古典 / 宁静",
        "duration": "3:00"
      }
    }
  },
  "pricing": {
    "title": "灵感不设限，选择最适合您的方案",
    "subtitle": "解锁全部 AI 模型，批量生成图像、视频和音乐。",
    "promo": "限时优惠 — 年付方案立省 30%",
    "monthly": "按月",
    "yearly": "按年",
    "yearlyNote": "年度方案 — 积分一次性到账，单笔支付更划算",
    "popular": "热门推荐",
    "currentPlan": "当前方案",
    "currentPlanBtn": "当前套餐",
    "upgrade": "升级",
    "unavailable": "不可用",
    "upgradeSuccess": "升级成功！",
    "upgradeFailed": "升级失败",
    "upgradeModal": {
      "title": "确认升级",
      "item1": "我们将按差价向您的卡收取相应金额。",
      "item2": "支付成功后，额外的余额将自动添加。",
      "item3": "新计划将在支付成功后生效。",
      "tip": "提示：请确保您的支付方式有效。支付成功后，余额将在几秒内增加。",
      "cancel": "取消",
      "confirm": "确认升级"
    },
    "subscribe": "立即订阅",
    "processing": "处理中...",
    "creditsPer": "积分 /",
    "extraCredits": "额外积分",
    "creditsRate": "100 积分 = $",
    "perMonth": "月",
    "perYear": "年",
    "yearlyBilling": "按年计费",
    "saveVsMonthly": "对比月付立省：",
    "planDesc": {
      "basic": "非常适合入门使用",
      "pro": "最适合创作者与专业人士",
      "ultimate": "适用于团队与高级用户"
    },
    "creditsPack": {
      "title": "加购积分包",
      "subtitle": "单次购买，无需订阅",
      "buy": "购买积分",
      "oneTime": "单次购买",
      "permanent": "额度永久有效",
      "tip": "提示：订阅会员更划算",
      "tipItems": [
        "积分单价更低（最高省 40-60%）",
        "购买所有积分包均享 8.5 折优惠"
      ]
    },
    "security": {
      "noTraining": "不参与 AI 训练",
      "encrypted": "加密存储",
      "gdpr": "符合 GDPR 合规标准",
      "delete": "自主注销账号"
    },
    "dataSafety": "了解我们的数据安全承诺 →",
    "allPlansInclude": "所有计划包括",
    "includes": {
      "models": "高级AI模型",
      "fast": "快速生成",
      "privacy": "100%隐私",
      "commercial": "商业用途"
    },
    "creditsInfo": {
      "title": "积分说明",
      "subtitle": "查看所有模型的积分消耗",
      "model": "模型",
      "type": "类型",
      "cost": "积分消耗",
      "speed": "速度",
      "image": "图像",
      "video": "视频"
    },
    "questions": "有疑问？",
    "contact": "需要帮助？",
    "contactUs": "联系我们",
    "faq": {
      "items": [
        {
          "q": "用积分能创建什么？",
          "a": "积分可用于生成 AI 图片、视频和音乐。图片生成 2 积分起，视频生成 10 积分起，音乐生成每支曲目 10 积分。高级模型可能消耗更多积分。"
        },
        {
          "q": "可以随时取消吗？",
          "a": "是的，您可以随时取消订阅。在本计费周期结束前，您仍可继续使用。"
        },
        {
          "q": "积分用完了怎么办？",
          "a": "您可以随时购买单次积分包（无需订阅）。订阅用户购买积分包可享 8.5 折优惠。您也可以升级订阅方案，以更优的价格获取更多每月配额。"
        },
        {
          "q": "是否有退款政策？",
          "a": "支持。首次购买单次套餐或首次订阅，在 7 个自然日内且积分使用量低于 3% 的情况下，可申请退款。"
        }
      ]
    }
  },
  "modelDetail": {
    "breadcrumb": {
      "home": "首页",
      "models": "模型"
    },
    "model": "模型",
    "modelVersion": "模型版本",
    "standard": "标准版",
    "pro": "专业版",
    "standardDesc": "标准质量，快速生成",
    "proDesc": "高质量，支持高分辨率",
    "credits": "积分",
    "imagePrompt": "图像提示",
    "imagePromptPlaceholder": "描述您想要生成的图像...",
    "videoPrompt": "视频提示",
    "videoPromptPlaceholder": "描述您想要生成的视频...",
    "referenceImage": "参考图片",
    "aspectRatio": "纵横比",
    "thinkingLevel": "思维等级",
    "thinkingMinimal": "低延迟",
    "thinkingHigh": "高保真",
    "referenceImageFormats": "PNG, JPG, JPEG, WEBP",
    "uploadImageHint": "PNG, JPG, JPEG, WEBP",
    "nanoBanana2EmptyPreview": "Nano Banana 2 官方图像输出预览",
    "characters": "字符",
    "imageSize": "图片尺寸",
    "auto": "自动",
    "resolution": "分辨率",
    "duration": "时长",
    "seconds": "秒",
    "creditsRequired": "所需积分：",
    "creditsRemaining": "剩余：",
    "remaining": "剩余：",
    "generate": "生成",
    "getMoreCredits": "获取更多积分",
    "generating": "正在生成中...",
    "demoPrompt": "演示提示",
    "modelLabel": "模型：",
    "version": "版本：",
    "size": "尺寸：",
    "download": "下载",
    "regenerate": "重新生成",
    "noHistory": "暂无生成历史",
    "features": {
      "badge": "核心功能",
      "title": "这个模型能做什么？",
      "items": {
        "realistic": {
          "icon": "📷",
          "title": "电影级写实风格",
          "desc": "支持高质感写实生成，人物肤质、材质纹理与环境光影更自然，适合人像、产品与场景创作。"
        },
        "artistic": {
          "icon": "🎨",
          "title": "艺术风格",
          "desc": "创作各种绘画风格的艺术图像。"
        },
        "portrait": {
          "icon": "👤",
          "title": "人像摄影",
          "desc": "专业人像摄影，肤色自然。"
        },
        "landscape": {
          "icon": "🏔️",
          "title": "风景摄影",
          "desc": "惊艳的风景和自然摄影。"
        },
        "product": {
          "icon": "📦",
          "title": "产品摄影",
          "desc": "高质量电商产品摄影。"
        },
        "fast": {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数图像在 10-30 秒内生成。"
        },
        "highRes": {
          "icon": "🖼️",
          "title": "高分辨率",
          "desc": "支持最高 4K 分辨率输出。"
        },
        "cinematic": {
          "icon": "🎬",
          "title": "电影级",
          "desc": "创建具有专业运镜的电影级视频。"
        },
        "audioSync": {
          "icon": "🔊",
          "title": "音画同步",
          "desc": "原生音视频同步。"
        },
        "lipSync": {
          "icon": "👄",
          "title": "对口型",
          "desc": "精准的角色口型同步。"
        },
        "animation": {
          "icon": "🎭",
          "title": "动画",
          "desc": "流畅的角色动画和动作。"
        },
        "longVideo": {
          "icon": "⏱️",
          "title": "长视频",
          "desc": "支持更长的视频时长。"
        },
        "privacy": {
          "icon": "🔒",
          "title": "隐私安全",
          "desc": "所有数据加密传输，不参与 AI 训练。您的创作内容完全属于您。"
        }
      }
    },
    "whyChoose": {
      "items": [
        "基于 {name} AI 模型的智能创作",
        "快速高效地完成复杂的创作任务",
        "生成的内容可以用于商业用途",
        "持续更新，功能不断增强",
        "统一积分系统，按需使用"
      ]
    },
    "faq": {
      "title": "常见问题解答",
      "imageType": "图片",
      "videoType": "视频",
      "imageFormats": "支持 PNG、JPEG 和 WebP 格式输出，您可以根据需要选择合适的格式。",
      "videoFormats": "视频以 MP4 格式输出，支持 480p 和 720p 分辨率，以及多种纵横比。",
      "items": [
        {
          "q": "{name} 如何工作？",
          "a": "您可以上传参考图片或直接输入文字描述，{name} 模型将根据您的指令生成高质量的{type}内容。整个过程简单直观，无需专业技能。"
        },
        {
          "q": "生成的{type}可以用于商业用途吗？",
          "a": "是的，使用 {name} 生成的所有内容均可用于商业用途，包括营销材料、社交媒体、产品展示等。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 {name} 每次生成消耗 {credits} 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "生成速度如何？",
          "a": "{name} 的平均生成速度为 {speed}。我们持续优化底层架构，确保快速稳定的生成体验。"
        },
        {
          "q": "支持哪些输出格式？",
          "a": ""
        }
      ]
    },
    "qwenImage20Pro": {
      "negativePromptLabel": "反向提示词（可选）",
      "negativePromptPlaceholder": "描述你不想出现的内容（例如：低清晰度、畸形手等）",
      "customWidth": "宽度",
      "customHeight": "高度",
      "sizeHint": "范围：512*512 至 2048*2048",
      "sizeErrorRequired": "请输入宽高",
      "sizeErrorInteger": "宽高必须为整数",
      "sizeErrorRange": "分辨率需在 512*512 至 2048*2048 之间",
      "promptEnhanceTitle": "提示词增强",
      "promptEnhanceDesc": "增强提示词细节以获得更丰富的输出",
      "watermarkTitle": "水印",
      "watermarkDesc": "在生成的图片上添加水印",
      "demoPromptText": "雪山间，小男孩穿滑雪服戴护目镜，脚踩雪板畅快滑行，雪粒随滑痕轻扬，身后是连绵覆雪山峦。",
      "faqSizeSupportQ": "支持哪些尺寸？",
      "faqSizeSupportA": "输入宽高需在 512~2048 之间（例如 2048*2048）。",
      "faqMaxCountQ": "最多一次生成几张？",
      "faqMaxCountA": "最多 4 张（n=1..4）。",
      "faqLinkUsageQ": "生成后图片链接怎么用？",
      "faqLinkUsageA": "会先下载 DashScope 返回的临时 URL，再上传到业务服务器，返回可长期访问的 URL。"
    },
    "zImageTurbo": {
      "promptExtendTitle": "提示词增强",
      "promptExtendDesc": "增强提示词细节以获得更丰富的输出",
      "customWidth": "宽度",
      "customHeight": "高度",
      "sizeHint": "范围：512*512 至 2048*2048",
      "sizeErrorRequired": "请输入宽高",
      "sizeErrorInteger": "宽高必须为整数",
      "sizeErrorRange": "分辨率需在 512*512 至 2048*2048 之间",
      "seedLabel": "种子",
      "seedErrorRequired": "请输入种子",
      "seedErrorInteger": "种子必须为整数",
      "seedErrorRange": "种子范围需在 0 到 2147483647 之间",
      "tagQuality": "高质量",
      "tagOfficial": "官方直连",
      "tagHighRes": "高分辨率",
      "tagSeed": "可控种子",
      "tagPromptExtend": "提示词增强",
      "feature1Title": "高质量输出",
      "feature1Desc": "生成高分辨率图片并上传为可长期访问的 URL。",
      "feature2Title": "自定义分辨率",
      "feature2Desc": "支持输入宽高，范围 512~2048。",
      "feature3Title": "可控生成",
      "feature3Desc": "支持种子与提示词增强开关，便于复现与调优。",
      "demoPromptText": "细腻的金色沙滩上，一串清晰的脚印向画面深处延伸，脚印边缘带着湿润的沙粒质感，沙滩表面在阳光下泛着细碎的光泽，引向远处的灯塔。",
      "faqSizeSupportQ": "支持哪些尺寸？",
      "faqSizeSupportA": "输入宽高需在 512~2048 之间（例如 1024*1536）。",
      "faqSeedQ": "seed 有什么用？",
      "faqSeedA": "同样的提示词与参数下，seed 可以帮助你复现相近结果。",
      "faqPromptExtendQ": "提示词增强是什么？",
      "faqPromptExtendA": "开启后会增强提示词细节以获得更丰富的输出。"
    }
  },
  "modelIntro": {
    "common": {
      "videoMode": "视频模式",
      "textToVideo": "文生视频",
      "imageToVideo": "图生视频",
      "referenceImage": "参考图片",
      "referenceAudio": "参考音频",
      "negativePrompt": "反向提示词",
      "duration": "时长",
      "resolution": "分辨率",
      "aspectRatio": "画面比例",
      "seed": "随机种子",
      "generateAudio": "生成音频",
      "watermark": "添加水印",
      "endFrame": "尾帧图片",
      "promptEnhance": "提示词增强",
      "promptExtend": "提示词扩展",
      "imageSize": "图片尺寸",
      "imageCount": "生成数量",
      "style": "风格",
      "sizeMode": "尺寸模式",
      "width": "宽度",
      "height": "高度",
      "optional": "可选",
      "uploading": "上传中...",
      "clickToUpload": "点击上传",
      "quality": "画质",
      "qualityAuto": "自动",
      "qualityLow": "低质量",
      "qualityMedium": "中等质量",
      "qualityHigh": "高质量",
      "multipleOf64Hint": "宽度和高度必须是 64 的倍数。"
    },
    "seegen": {
      "aspectAdaptive": "自动",
      "genMode": "生成模式",
      "modeStand": "标准",
      "modeSpeed": "快速"
    },
    "pollodance": {
      "variantLabel": "模型版本",
      "card20": "2.0",
      "card20Fast": "2.0 FAST",
      "card20Ref": "2.0 REF",
      "card20FastRef": "2.0 FAST REF",
      "opt20Desc": "先进运动控制、电影级风格转换与工业级视频生成。",
      "opt20FastDesc": "高速视频生成与低延迟处理。",
      "opt20RefDesc": "视频间参考、风格迁移与主体追踪。",
      "opt20FastRefDesc": "高速生成 + 精准视频间参考。",
      "refImages": "参考图片（可多张）",
      "refVideo": "参考视频",
      "refAudio": "参考音频",
      "webSearch": "联网搜索"
    },
    "nanoBanana": {
      "version": "模型版本",
      "title": "Nano Banana Pro AI 图像生成器",
      "desc": "Nano Banana 是高性能 AI 图像生成模型，支持写实风格图像生成，擅长人像和自然场景。提供 Standard 和 Pro 两种版本满足不同需求。",
      "v25Type": "低延迟",
      "v25TypeBadge": "快速",
      "v25TypeDesc": "固定 1024px 分辨率，生成速度快",
      "v31Type": "高保真",
      "v31TypeBadge": "高品质",
      "v31TypeDesc": "支持 1K / 2K / 4K 多种分辨率",
      "demoPrompt": "电影级人像，金色黄昏光线，自然肤质纹理，柔和散景背景",
      "multiSize": "多种尺寸",
      "multiSizeDesc": "支持自动、1:1、4:3、3:4、16:9、9:16、3:2、2:3 等多种图片尺寸。",
      "featuresDesc": "Nano Banana 提供高质量的图像生成能力，支持多种尺寸和分辨率选项。",
      "flexiblePricing": "灵活定价",
      "flexiblePricingDesc": "Standard 5积分，Pro 20积分，按需选择。",
      "commercial": "商业授权",
      "commercialDesc": "所有生成的图像均可用于商业用途。",
      "enterPrompt": "请输入提示词",
      "generateFailed": "生成失败",
      "requestFailed": "请求失败，请重试",
      "faq": [
        {
          "q": "Standard 和 Pro 版本有什么区别？",
          "a": "Standard 版本适合快速生成标准质量图像，消耗 5 积分。Pro 版本支持更高分辨率（1K/2K/4K），图像质量更高，消耗 20 积分。"
        },
        {
          "q": "Nano Banana 如何工作？",
          "a": "您只需输入文字描述，Nano Banana 模型将根据您的提示生成高质量的写实风格图像。"
        },
        {
          "q": "支持哪些图片尺寸？",
          "a": "支持自动、1:1（方形）、4:3、3:4、16:9（横向）、9:16（竖向）、3:2、2:3 等多种尺寸。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，使用 Nano Banana 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "nanoBanana2": {
      "genType": "生成版本"
    },
    "seedream": {
      "title": "Seedream 4 AI 图像生成器",
      "desc": "Seedream 4 是先进的 AI 图像生成模型，专注于艺术和创意图像。非常适合插画、概念艺术和风格化视觉作品。",
      "webSearch": "联网搜索",
      "webSearchDesc": "启用联网搜索以获取更准确的参考信息",
      "watermark": "添加水印",
      "watermarkDesc": "在生成的图片上添加水印",
      "sizeModeResolution": "按分辨率",
      "sizeModeCustom": "自定义尺寸",
      "customWidth": "宽度",
      "customHeight": "高度",
      "sizeHint": "面积 1024×1024～4096×4096，宽高比 1/16～16",
      "sizeErrorArea": "面积需在 1024×1024 至 4096×4096 之间",
      "sizeErrorRatio": "宽高比需在 1/16 至 16 之间",
      "demoPromptExample": "午后侧光洒在露营帐篷上，帐篷帆布的粗糙质感清晰可见。一只德国牧羊犬卧在帐内，主人蹲下与它握手。",
      "features": [
        {
          "icon": "🎨",
          "title": "艺术风格",
          "desc": "生成各种绘画和插画风格的惊艳艺术图像。"
        },
        {
          "icon": "🖼️",
          "title": "高分辨率",
          "desc": "支持最高 4K 分辨率，细节丰富。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数图像在 15 秒内生成。"
        },
        {
          "icon": "🎭",
          "title": "风格迁移",
          "desc": "将各种艺术风格应用到您的创作中。"
        },
        {
          "icon": "📐",
          "title": "多种尺寸",
          "desc": "支持多种纵横比满足不同需求。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的图像均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Seedream 4 最适合什么？",
          "a": "Seedream 4 擅长生成艺术和创意图像，包括插画、概念艺术和风格化视觉作品。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Seedream 4 每次生成消耗 8 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "支持哪些风格？",
          "a": "Seedream 4 支持各种艺术风格，包括油画、水彩、数字艺术、动漫等。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，使用 Seedream 4 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "seedream5": {
      "title": "Seedream 5 AI 图像生成器",
      "desc": "Seedream 5 是先进的 AI 图像生成模型，专注于艺术和创意图像。非常适合插画、概念艺术和风格化视觉作品。",
      "webSearch": "联网搜索",
      "webSearchDesc": "启用联网搜索以获取更准确的参考信息",
      "watermark": "添加水印",
      "watermarkDesc": "在生成的图片上添加水印",
      "sizeModeResolution": "按分辨率",
      "sizeModeCustom": "自定义尺寸",
      "customWidth": "宽度",
      "customHeight": "高度",
      "sizeHint": "面积 2560×1440～3072×3072，宽高比 1/16～16",
      "sizeErrorArea": "面积需在 2560×1440 至 3072×3072 之间",
      "sizeErrorRatio": "宽高比需在 1/16 至 16 之间",
      "demoPromptExample": "午后侧光洒在露营帐篷上，帐篷帆布的粗糙质感清晰可见。一只德国牧羊犬卧在帐内，主人蹲下与它握手。",
      "features": [
        {
          "icon": "🎨",
          "title": "艺术风格",
          "desc": "生成各种绘画和插画风格的惊艳艺术图像。"
        },
        {
          "icon": "🖼️",
          "title": "高分辨率",
          "desc": "支持 2K 和 3K 输出，细节丰富。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数图像在 15 秒内生成。"
        },
        {
          "icon": "🎭",
          "title": "风格迁移",
          "desc": "将各种艺术风格应用到您的创作中。"
        },
        {
          "icon": "📐",
          "title": "灵活尺寸",
          "desc": "支持预设分辨率和自定义尺寸。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的图像均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Seedream 5 最适合什么？",
          "a": "Seedream 5 擅长生成艺术和创意图像，包括插画、概念艺术和风格化视觉作品。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Seedream 5 每次生成消耗 10 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "支持哪些分辨率？",
          "a": "支持 2K 和 3K 预设分辨率，也支持在允许范围内自定义尺寸。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，使用 Seedream 5 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "midjourney": {
      "title": "Midjourney AI 图像生成器",
      "desc": "Midjourney 是领先的 AI 图像生成模型，以卓越的艺术质量和创意能力著称。非常适合专业艺术作品和创意项目。",
      "referenceBoxTitle": "添加参考图进行图生图",
      "referenceBoxSubtitle": "支持 PNG、JPEG、WEBP 格式（最大 100KB）。最多 5 张图。图片越少，效果越精准。",
      "demoPrompt": "天空中的神秘浮岛，古老废墟上覆盖着发光的水晶，瀑布倾泻入下方云海，空灵光影，奇幻艺术风格",
      "referenceImages": "参考图片",
      "referenceImagesCount": "最多 5 张",
      "refImageMaxSize": "单张图片不能超过 100KB",
      "style": "风格",
      "styleRealistic": "写实",
      "styleAnime": "二次元",
      "generationSpeed": "生成速度",
      "fastDesc": "标准速度生成",
      "turboDesc": "快速生成，优先处理",
      "creative": "创意",
      "highQuality": "高质量",
      "fastTurbo": "Fast/Turbo",
      "creativeGeneration": "创意生成",
      "speed": "速度",
      "features": [
        {
          "icon": "🎨",
          "title": "艺术卓越",
          "desc": "行业领先的艺术质量和创意输出。"
        },
        {
          "icon": "🖼️",
          "title": "高分辨率",
          "desc": "生成适合专业使用的高质量图像。"
        },
        {
          "icon": "🎭",
          "title": "独特风格",
          "desc": "独特的艺术风格让您的作品脱颖而出。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数图像在 20 秒内生成。"
        },
        {
          "icon": "📐",
          "title": "多种尺寸",
          "desc": "支持多种纵横比和分辨率。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的图像均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Fast 和 Turbo 有什么区别？",
          "a": "Fast 模式消耗 10 积分，标准速度生成。Turbo 模式消耗 20 积分，生成速度更快且优先处理。"
        },
        {
          "q": "Midjourney 如何工作？",
          "a": "您只需输入文字描述，Midjourney 将根据您的提示生成富有艺术感的图像。"
        },
        {
          "q": "支持哪些图片尺寸？",
          "a": "支持 1:1（方形）、4:3、3:4、16:9（横向）、9:16（竖向）、3:2、2:3 等多种尺寸。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，使用 Midjourney 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "gptImage": {
      "title": "GPT-Image-1 AI 图像生成器",
      "desc": "GPT-Image-1 是 OpenAI 的多功能图像生成模型，能够根据文字描述创建各种图像。非常适合通用图像生成。",
      "demoPromptExample": "暮色下的托斯卡纳田野，起伏的山丘铺满金色麦浪，远处是柏树与古老石砌农舍，夕阳把天空染成温暖的红色，治愈系风光摄影，黄金时刻。",
      "imageCount": "图片数量",
      "promptEnhance": "提示增强",
      "promptEnhanceDesc": "自动优化提示词以获得更好的生成效果",
      "count": "数量",
      "multiPurpose": "多功能",
      "batchGeneration": "批量生成",
      "size1024Square": "1024×1024（正方形）",
      "size1536Landscape": "1536×1024（横向）",
      "size1024Portrait": "1024×1536（纵向）",
      "threeSizes": "三种固定尺寸",
      "tagQuality": "高质量",
      "tagCommercialShort": "商业授权",
      "features": [
        {
          "icon": "🎨",
          "title": "多功能生成",
          "desc": "创建各种用途的图像。"
        },
        {
          "icon": "🖼️",
          "title": "高质量",
          "desc": "生成细节准确的高质量图像。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数图像在 15 秒内生成。"
        },
        {
          "icon": "📝",
          "title": "文本理解",
          "desc": "出色理解复杂的文字描述。"
        },
        {
          "icon": "📐",
          "title": "三种固定尺寸",
          "desc": "1024×1024（正方形）、1536×1024（横向）、1024×1536（纵向）。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的图像均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "GPT-Image-1 如何工作？",
          "a": "您只需输入文字描述，GPT-Image-1 将根据您的提示生成高质量图像。"
        },
        {
          "q": "支持哪些图片尺寸？",
          "a": "支持 1024×1024（正方形）、1536×1024（横向）、1024×1536（纵向）三种固定尺寸。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，使用 GPT-Image-1 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "gptImage15": {
      "title": "GPT-Image-1.5 AI 图像生成器",
      "desc": "GPT-Image-1.5 是 OpenAI 的多功能图像生成模型，能够根据文字描述创建各种图像。非常适合通用图像生成。",
      "demoPromptExample": "暮色下的托斯卡纳田野，起伏的山丘铺满金色麦浪，远处是柏树与古老石砌农舍，夕阳把天空染成温暖的红色，治愈系风光摄影，黄金时刻。",
      "imageCount": "图片数量",
      "promptEnhance": "提示增强",
      "promptEnhanceDesc": "自动优化提示词以获得更好的生成效果",
      "count": "数量",
      "multiPurpose": "多功能",
      "batchGeneration": "批量生成",
      "size1024Square": "1024×1024（正方形）",
      "size1536Landscape": "1536×1024（横向）",
      "size1024Portrait": "1024×1536（纵向）",
      "threeSizes": "三种固定尺寸",
      "tagQuality": "高质量",
      "tagCommercialShort": "商业授权",
      "features": [
        {
          "icon": "🎨",
          "title": "多功能生成",
          "desc": "创建各种用途的图像。"
        },
        {
          "icon": "🖼️",
          "title": "高质量",
          "desc": "生成细节准确的高质量图像。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数图像在 15 秒内生成。"
        },
        {
          "icon": "📝",
          "title": "文本理解",
          "desc": "出色理解复杂的文字描述。"
        },
        {
          "icon": "📐",
          "title": "三种固定尺寸",
          "desc": "1024×1024（正方形）、1536×1024（横向）、1024×1536（纵向）。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的图像均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "GPT-Image-1.5 如何工作？",
          "a": "您只需输入文字描述，GPT-Image-1.5 将根据您的提示生成高质量图像。"
        },
        {
          "q": "支持哪些图片尺寸？",
          "a": "支持 1024×1024（正方形）、1536×1024（横向）、1024×1536（纵向）三种固定尺寸。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，使用 GPT-Image-1.5 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "fluxKontext": {
      "title": "Flux Kontext AI 图像生成器",
      "desc": "领略 Flux Kontext AI 顶尖的 AI 绘图实力。生成最高 2K 分辨率的震撼写实大片，具备专业级审美与质感。",
      "imageCount": "图片数量",
      "count": "数量",
      "demoPrompt1": "黄金时刻，一位年轻女子坐在屋顶上，身穿宽松牛仔外套，颈戴白色耳机，手捧透明塑料杯喝着冰咖啡。她短短的卷发随风轻扬，远处城市灯火初上。",
      "demoPrompt2": "二十多岁的男子坐在凌乱的艺术工作室地板上，周围是未完成的画布和颜料管。他身穿沾满颜料的白色背心和破洞牛仔裤。",
      "demoPrompt3": "一位年轻妈妈坐在野餐垫上为宝宝整理毛线帽。她穿着米色毛衣和长款灯芯绒裙，赤脚踩在草地上。",
      "highQuality": "高质量",
      "fastGen": "快速生成",
      "multiSize": "多种尺寸",
      "outputStyle": "输出风格",
      "outputStyleDesc": {
        "auto": "默认值，模型自动判断风格，无强制画风",
        "photographic": "摄影写实风，真实照片质感、光影自然",
        "digital_art": "数字艺术/插画风，CG质感、色彩饱满",
        "anime": "二次元/动漫风，日系卡通、线条干净"
      },
      "outputStyleLabel": {
        "auto": "默认",
        "photographic": "写实",
        "digital_art": "艺术",
        "anime": "二次元"
      },
      "features": [
        {
          "icon": "✨",
          "title": "高质量输出",
          "desc": "生成细节丰富、画质出色的图像。"
        },
        {
          "icon": "🎨",
          "title": "文生图",
          "desc": "根据文字描述精准生成对应画面。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "多数图像在约 15 秒内完成。"
        },
        {
          "icon": "📐",
          "title": "多种尺寸",
          "desc": "支持 1:1、3:2、2:3 等纵横比。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "生成的图像可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Flux Kontext 如何工作？",
          "a": "输入文字描述，Flux Kontext 将根据提示生成高质量图像，支持单张或多张同时生成。"
        },
        {
          "q": "支持哪些图片尺寸？",
          "a": "支持 1:1（方形）、3:2（横向）、2:3（竖向）三种尺寸。"
        },
        {
          "q": "可以一次生成多张图片吗？",
          "a": "可以，可选择生成 1～3 张图片，每张单独计费。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，使用 Flux Kontext 生成的内容可用于商业用途。"
        }
      ]
    },
    "fluxPro11Ultra": {
      "title": "Flux Pro 1.1 Ultra AI 图像生成器",
      "desc": "Flux Pro 1.1 Ultra 高质量文生图，支持多种比例与批量生成。",
      "imageCount": "图片数量",
      "count": "数量",
      "demoPrompt1": "黄金时刻，一位年轻女子坐在屋顶上，身穿宽松牛仔外套，颈戴白色耳机，手捧透明塑料杯喝着冰咖啡。她短短的卷发随风轻扬，远处城市灯火初上。",
      "demoPrompt2": "二十多岁的男子坐在凌乱的艺术工作室地板上，周围是未完成的画布和颜料管。他身穿沾满颜料的白色背心和破洞牛仔裤。",
      "demoPrompt3": "一位年轻妈妈坐在野餐垫上为宝宝整理毛线帽。她穿着米色毛衣和长款灯芯绒裙，赤脚踩在草地上。",
      "highQuality": "高质量",
      "fastGen": "快速生成",
      "multiSize": "多种尺寸",
      "outputStyle": "输出风格",
      "outputStyleDesc": {
        "auto": "默认值，模型自动判断风格，无强制画风",
        "photographic": "摄影写实风，真实照片质感、光影自然",
        "digital_art": "数字艺术/插画风，CG质感、色彩饱满",
        "anime": "二次元/动漫风，日系卡通、线条干净"
      },
      "outputStyleLabel": {
        "auto": "默认",
        "photographic": "写实",
        "digital_art": "艺术",
        "anime": "二次元"
      },
      "features": [
        {
          "icon": "✨",
          "title": "高质量输出",
          "desc": "生成细节丰富、画质出色的图像。"
        },
        {
          "icon": "🎨",
          "title": "文生图",
          "desc": "根据文字描述精准生成对应画面。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "多数图像在约 15 秒内完成。"
        },
        {
          "icon": "📐",
          "title": "多种尺寸",
          "desc": "支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "生成的图像可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Flux Pro 1.1 Ultra 如何工作？",
          "a": "输入文字描述，即可生成高质量图像，支持 1～4 张同时生成。"
        },
        {
          "q": "支持哪些图片尺寸？",
          "a": "支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "q": "可以一次生成多张图片吗？",
          "a": "可以，可选择生成 1～4 张图片，每张单独计费。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，生成的内容可用于商业用途。"
        }
      ]
    },
    "fluxSchnell": {
      "title": "Flux Schnell AI 图像生成器",
      "desc": "Flux Schnell 快速文生图，支持多种比例与批量生成。",
      "imageCount": "图片数量",
      "count": "数量",
      "demoPrompt1": "黄金时刻，一位年轻女子坐在屋顶上，身穿宽松牛仔外套，颈戴白色耳机，手捧透明塑料杯喝着冰咖啡。她短短的卷发随风轻扬，远处城市灯火初上。",
      "demoPrompt2": "二十多岁的男子坐在凌乱的艺术工作室地板上，周围是未完成的画布和颜料管。他身穿沾满颜料的白色背心和破洞牛仔裤。",
      "demoPrompt3": "一位年轻妈妈坐在野餐垫上为宝宝整理毛线帽。她穿着米色毛衣和长款灯芯绒裙，赤脚踩在草地上。",
      "highQuality": "高质量",
      "fastGen": "快速生成",
      "multiSize": "多种尺寸",
      "outputStyle": "输出风格",
      "outputStyleDesc": {
        "auto": "默认值，模型自动判断风格，无强制画风",
        "photographic": "摄影写实风，真实照片质感、光影自然",
        "digital_art": "数字艺术/插画风，CG质感、色彩饱满",
        "anime": "二次元/动漫风，日系卡通、线条干净"
      },
      "outputStyleLabel": {
        "auto": "默认",
        "photographic": "写实",
        "digital_art": "艺术",
        "anime": "二次元"
      },
      "features": [
        {
          "icon": "✨",
          "title": "高质量输出",
          "desc": "生成细节丰富、画质出色的图像。"
        },
        {
          "icon": "🎨",
          "title": "文生图",
          "desc": "根据文字描述精准生成对应画面。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "多数图像在约 15 秒内完成。"
        },
        {
          "icon": "📐",
          "title": "多种尺寸",
          "desc": "支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "生成的图像可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Flux Schnell 如何工作？",
          "a": "输入文字描述，即可快速生成高质量图像，支持 1～4 张同时生成。"
        },
        {
          "q": "支持哪些图片尺寸？",
          "a": "支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16、9:21。"
        },
        {
          "q": "可以一次生成多张图片吗？",
          "a": "可以，可选择生成 1～4 张图片，每张单独计费。"
        },
        {
          "q": "生成的图像可以用于商业用途吗？",
          "a": "是的，生成的内容可用于商业用途。"
        }
      ]
    },
    "flux2": {
      "title": "FLUX.2 AI 图像生成器",
      "desc": "FLUX.2 带来企业级效率和专业精度，生成逼真细节，精准还原手部、面部和纹理。",
      "variant": "模型版本",
      "variantLabel": "模型版本",
      "variantDesc": {
        "klein-04": "实时生成",
        "klein-09": "速度与质量均衡",
        "max": "最高质量",
        "pro": "生产级",
        "flex": "可自定义"
      },
      "promptUpsampling": "提示词增强",
      "promptUpsamplingHint": "增强提示词细节以获得更丰富的输出（Klein 版本不支持）。",
      "steps": "步数",
      "stepsHint": "步数越高细节越多，但速度越慢。仅 Flex 版本可用。",
      "guidance": "引导值",
      "guidanceHint": "控制输出与提示词的贴合程度。仅 Flex 版本可用。",
      "tagPhotorealism": "照片级真实",
      "tagMultilingual": "多语言",
      "tagVariants": "5 个版本",
      "demoPrompt1": "黄金时刻，一位年轻女子坐在屋顶上，身穿宽松牛仔外套，颈戴白色耳机，手捧透明塑料杯喝着冰咖啡。她短短的卷发随风轻扬，远处城市灯火初上。",
      "features": [
        { "icon": "✨", "title": "照片级细节", "desc": "精准还原手部、面部、布料、标志和小物体，最高 4MP 分辨率。" },
        { "icon": "🎨", "title": "排版与设计", "desc": "渲染清晰可读的文字排版，遵循复杂的布局指令。" },
        { "icon": "🌍", "title": "多语言支持", "desc": "支持母语提示词，具有最先进的指令理解能力。" },
        { "icon": "🎯", "title": "5 个模型版本", "desc": "Klein 4B/9B 追求速度，Max 追求质量，Pro 面向生产，Flex 可自定义控制。" },
        { "icon": "⚙️", "title": "灵活控制", "desc": "可调节步数、引导值、尺寸和安全容忍度，适配生产工作流。" }
      ],
      "faq": [
        { "q": "FLUX.2 有哪些模型版本？", "a": "FLUX.2 提供 5 个版本：Klein 4B 和 9B（快速、大批量）、Max（最高质量，支持搜索增强）、Pro（生产级规模）、Flex（可调节步数和引导值）。" },
        { "q": "支持哪些图片尺寸？", "a": "FLUX.2 使用像素尺寸（宽 x 高），必须是 16 的倍数。预设包括 1:1 (1024x1024)、4:3、3:4、16:9、9:16、21:9 和 9:21。" },
        { "q": "什么是提示词增强？", "a": "启用后，模型会在内部增强提示词以获得更丰富的细节。适用于 Max、Pro 和 Flex 版本（Klein 不支持）。" },
        { "q": "Flex 模式下的步数和引导值是什么？", "a": "步数（1-50）控制推理质量——越高细节越多但速度越慢。引导值（1.5-10）控制与提示词的贴合程度——越高越贴近描述。" },
        { "q": "生成的图像可以用于商业用途吗？", "a": "是的，生成的内容可用于商业用途。" }
      ]
    },
    "seedance": {
      "title": "Seedance AI 视频生成器",
      "desc": "Seedance 是新一代 AI 视频模型，支持原生音画同步、电影级动态及情感表达。涵盖文生视频、图生视频及视频外扩模式，视频与音频同步生成，确保画面、对白与环境音完美契合。",
      "textToVideo": "文本转视频",
      "imageToVideo": "图片转视频",
      "videoExtend": "视频延展",
      "uploadImage": "点击上传参考图片",
      "uploadHint": "PNG, JPG, JPEG (最大 20MB)",
      "endFrame": "尾帧图片",
      "endFrameHint": "（可选）上传尾帧图片来控制视频结尾",
      "uploadEndFrame": "点击上传尾帧图片",
      "uploadVideo": "点击上传参考视频",
      "uploadVideoHint": "MP4, MOV, WebM (最大 100MB)",
      "videoPrompt": "视频提示",
      "promptPlaceholder": "描述您想要生成的视频...",
      "videoPromptPlaceholder": "描述您想要生成的视频...",
      "negativePrompt": "负面提示",
      "negativePromptPlaceholder": "描述你不想出现的内容（可选）",
      "duration": "时长",
      "videoDuration": "视频时长",
      "resolution": "分辨率",
      "aspectRatio": "纵横比",
      "promptEnhance": "提示增强",
      "promptEnhanceDesc": "自动优化提示词以获得更好的生成效果",
      "generateAudio": "生成音频",
      "audioOn": "原生音频（语音+音效）",
      "audioOff": "仅视频，无音频",
      "seedValue": "种子值",
      "seedHint": "种子值是作品整体风格的唯一标识，输入相同种子值可保持风格不变，微调其他参数即可优化画面细节",
      "seedPlaceholder": "-1 (随机)",
      "characters": "字符",
      "creditsRequired": "所需积分：",
      "creditsRemaining": "剩余：",
      "generate": "生成",
      "generating": "正在生成中...",
      "demoPrompt": "演示提示",
      "demoPromptExample": "一只柔软可爱的小白猫踮着脚尖快乐地跳舞，它蓬松的身体轻轻摇摆，小小的粉色爪子抬起。在温暖的黄色灯光下，柔软的地毯上，治愈系卡通风格，细节精致，色彩柔和温柔。",
      "modelLabel": "模型：",
      "durationLabel": "时长：",
      "techSpecsTitle": "技术规格",
      "techSpecsDesc": "Seedance 支持原生音画同步、电影级动态及情感表达。涵盖文生视频、图生视频及视频外扩模式。",
      "t2vTitle": "文本转视频 (T2V)",
      "t2vDesc": "将提示转化为电影级视频场景",
      "i2vTitle": "图像转视频 (I2V)",
      "i2vDesc": "使用 AI 动画化单张图片",
      "input": "输入：",
      "textPrompt": "文本提示",
      "imagePrompt": "图片 + 提示",
      "audio": "音频：",
      "nativeAudio": "原生音频生成",
      "bestFor": "最适合：",
      "t2vBestFor": "非常适合电影级内容创作、广告和社交媒体视频。",
      "i2vBestFor": "最适合人像动画、产品展示和创意内容。",
      "featuresDesc": "无论您是设计师、营销人员、内容创作者还是普通用户，Seedance 都可以帮助您快速创作高质量的 AI 内容。",
      "features": [
        {
          "icon": "🎬",
          "title": "原生音视频生成",
          "desc": "同步生成画面与声音，一次成片，尽显电影质感。自然的口型同步与对话配音。"
        },
        {
          "icon": "😊",
          "title": "情感驱动表情系统",
          "desc": "新增情感感知表演，让面部表情更真实。细微表情包括犹豫、悲伤、紧张或情感克制。"
        },
        {
          "icon": "🎥",
          "title": "导演级镜头控制",
          "desc": "支持推、拉、平移、环绕和跟踪等镜头运动。首尾帧引导，实现平滑过渡。"
        },
        {
          "icon": "📱",
          "title": "多模态输入",
          "desc": "支持文生视频、图生视频等多种灵活的创作工作流。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "优化的推理引擎确保快速出片，大多数视频可在几分钟内完成。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途，适用于广告、社交媒体等。"
        }
      ],
      "enterPrompt": "请输入提示词",
      "imageRequired": "图片转视频模式需要上传参考图片",
      "videoRequired": "视频延展模式需要上传参考视频",
      "generateFailed": "生成失败",
      "requestFailed": "请求失败，请重试",
      "faq": [
        {
          "q": "Seedance 如何工作？",
          "a": "您可以上传参考图片或直接输入文字描述，Seedance 模型将根据您的指令生成高质量的视频内容，并同步生成音频。整个过程简单直观，无需专业技能。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "是的，使用 Seedance 生成的所有内容均可用于商业用途，包括营销材料、社交媒体、产品展示等。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Seedance 每次生成消耗 18 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "生成速度如何？",
          "a": "Seedance 的平均生成速度约为 1.5 分钟。我们持续优化底层架构，确保快速稳定的生成体验。"
        },
        {
          "q": "支持哪些输出格式？",
          "a": "视频以 MP4 格式输出，支持 480p、720p 和 1080p 分辨率，时长可选 5 秒或 10 秒，支持多种纵横比。"
        }
      ]
    },
    "veo": {
      "title": "Veo 3.1 AI 视频生成器",
      "desc": "Google Veo 3.1 是最先进的 AI 视频模型，支持原生音频生成、超高分辨率和长视频创作。非常适合专业视频制作。",
      "fastType": "快速类型",
      "fastTypeBadge": "速度快、成本更低",
      "fastTypeDesc": "（支持 16:9 的参考图片）",
      "qualityType": "画质类型",
      "qualityTypeBadge": "细节更丰富",
      "qualityTypeDesc": "动态更流畅。图片模式结束帧是可选项，用于控制最后一帧。",
      "imageMode": "生成模式",
      "startEndFrames": "起始帧/结束帧",
      "referenceImage": "参考图片",
      "startFrame": "起始帧",
      "startFrameHint": "设置第一帧。视频从该帧开始动画。",
      "uploadStartFrame": "点击上传起始帧",
      "endFrame": "结束帧",
      "endFrameHint": "设置最后一帧。视频在该帧结束。",
      "uploadEndFrame": "点击上传结束帧",
      "negativePrompt": "负向提示",
      "negativePromptPlaceholder": "描述您不希望在视频中出现的元素...",
      "features": [
        {
          "icon": "🎬",
          "title": "原生音频生成",
          "desc": "同步生成视频和音频，包括对话和音效。"
        },
        {
          "icon": "📺",
          "title": "超高清分辨率",
          "desc": "支持最高 4K 分辨率输出，适合专业视频制作。"
        },
        {
          "icon": "⏱️",
          "title": "长视频支持",
          "desc": "生成最长 2 分钟的视频，满足各种创作需求。"
        },
        {
          "icon": "🎥",
          "title": "电影级动态",
          "desc": "专业的镜头运动和平滑过渡。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "优化的推理引擎确保快速出片。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "快速类型和画质类型有什么区别？",
          "a": "快速类型更快捷、更经济，适合快速迭代。画质类型生成更丰富的细节和更流畅的动态，适合最终输出。"
        },
        {
          "q": "Veo 3.1 如何工作？",
          "a": "输入文字描述或上传参考图片，Veo 3.1 将根据您的指令生成高质量的视频内容，可选择同步生成音频。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Veo 3.1 每次生成消耗 30 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "支持哪些分辨率和时长？",
          "a": "支持 720p 和 1080p 分辨率，时长可选 5 秒、10 秒，长视频最长可达 2 分钟。"
        }
      ]
    },
    "veo31": {
      "genType": "生成类型",
      "genTypeFast": "快速",
      "genTypeQuality": "高质量",
      "endFrame": "尾帧图片"
    },
    "veo30": {
      "title": "Veo 3.0 AI 视频生成器",
      "desc": "Google Veo 3.0 是先进的 AI 视频模型，支持文生视频与图生视频，支持 4s/6s/8s 时长与 720p/1080p 输出。",
      "fastType": "快速类型",
      "fastTypeBadge": "速度快、成本更低",
      "fastTypeDesc": "（支持 16:9 的参考图片）",
      "qualityType": "画质类型",
      "qualityTypeBadge": "细节更丰富",
      "qualityTypeDesc": "动态更流畅。图片模式结束帧是可选项，用于控制最后一帧。",
      "imageMode": "图片模式",
      "startEndFrames": "起始帧/结束帧",
      "referenceImage": "参考图片",
      "referenceImageHint": "上传参考图片，视频将基于该图生成。",
      "uploadReferenceImage": "点击上传参考图片",
      "startFrame": "起始帧",
      "startFrameHint": "设置第一帧。视频从该帧开始动画。",
      "uploadStartFrame": "点击上传起始帧",
      "endFrame": "结束帧",
      "endFrameHint": "设置最后一帧。视频在该帧结束。",
      "uploadEndFrame": "点击上传结束帧",
      "negativePrompt": "负向提示",
      "negativePromptPlaceholder": "描述您不希望在视频中出现的元素...",
      "seedRangeError": "Seed 需为 0～2147483647 的整数",
      "duration": "时长",
      "resolution": "分辨率",
      "demoPrompt": "A teenage girl sketching in a notebook at a café window, rain tapping on the glass...",
      "features": [
        {
          "icon": "🎬",
          "title": "原生音频生成",
          "desc": "同步生成视频和音频，包括对话和音效。"
        },
        {
          "icon": "📺",
          "title": "高清分辨率",
          "desc": "支持 720p、1080p 输出，适合专业视频制作。"
        },
        {
          "icon": "⏱️",
          "title": "多档时长",
          "desc": "支持 4 秒、6 秒、8 秒视频生成。"
        },
        {
          "icon": "🎥",
          "title": "电影级动态",
          "desc": "专业的镜头运动和平滑过渡。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "优化的推理引擎确保快速出片。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "快速类型和画质类型有什么区别？",
          "a": "快速类型更快捷、更经济，适合快速迭代。画质类型生成更丰富的细节和更流畅的动态，适合最终输出。"
        },
        {
          "q": "Veo 3.0 如何工作？",
          "a": "输入文字描述或上传参考图片，Veo 3.0 将根据您的指令生成高质量的视频内容，可选择同步生成音频。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Veo 3.0 每次生成消耗 25 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "支持哪些分辨率和时长？",
          "a": "支持 720p 和 1080p 分辨率，时长可选 4 秒、6 秒或 8 秒。"
        }
      ]
    },
    "veo31fast": {
      "title": "Veo 3.1 Fast AI 视频生成器",
      "desc": "Google Veo 3.1 Fast 快速版，支持文生视频与图生视频，可选尾帧，支持 4s/6s/8s 时长与 720p/1080p/4K 输出。",
      "referenceImage": "参考图片",
      "referenceImageHint": "上传参考图片，视频将基于该图生成。",
      "uploadReferenceImage": "点击上传参考图片",
      "endFrame": "尾帧",
      "endFrameHint": "可选。设置视频最后一帧对应的图片，用于控制结束画面。",
      "uploadEndFrame": "点击上传尾帧",
      "duration": "时长",
      "resolution": "分辨率",
      "seedRangeError": "Seed 需为 0～2147483647 的整数",
      "demoPrompt": "A teenage girl sketching in a notebook at a café window, rain tapping on the glass...",
      "features": [
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "优化推理，出片更快。"
        },
        {
          "icon": "📺",
          "title": "4K 分辨率",
          "desc": "支持 720p、1080p、4K 输出。"
        },
        {
          "icon": "⏱️",
          "title": "多档时长",
          "desc": "支持 4 秒、6 秒、8 秒视频。"
        },
        {
          "icon": "🖼️",
          "title": "可选尾帧",
          "desc": "图生视频可上传尾帧图片控制结束画面。"
        },
        {
          "icon": "🎥",
          "title": "电影级动态",
          "desc": "专业的镜头运动和平滑过渡。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Veo 3.1 Fast 和 Veo 3.1 有什么区别？",
          "a": "Veo 3.1 Fast 为快速版，生成速度更快、积分消耗更低，支持 4K 与可选尾帧。"
        },
        {
          "q": "尾帧是什么？",
          "a": "图生视频时可上传一张尾帧图片，视频将以此图作为结束画面，便于控制结尾。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Veo 3.1 Fast 每次生成消耗 20 积分。"
        },
        {
          "q": "支持哪些分辨率和时长？",
          "a": "支持 720p、1080p、4K 分辨率，时长可选 4 秒、6 秒或 8 秒。"
        }
      ]
    },
    "kling": {
      "title": "Kling 2.6 AI 视频生成器",
      "desc": "Kling 2.6 是高性能 AI 视频模型，支持文生视频和图生视频，具有出色的动态质量和快速生成速度。",
      "features": [
        {
          "icon": "🎬",
          "title": "高质量动态",
          "desc": "流畅自然的动态效果，专业级输出质量。"
        },
        {
          "icon": "📱",
          "title": "多种纵横比",
          "desc": "支持 1:1、16:9、9:16 等多种纵横比。"
        },
        {
          "icon": "🔊",
          "title": "音频生成",
          "desc": "可选的原生音频生成，完整视频体验。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数视频在 2 分钟内完成。"
        },
        {
          "icon": "🖼️",
          "title": "图片转视频",
          "desc": "用 AI 动画让静态图片动起来。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Kling 2.6 如何工作？",
          "a": "输入文字描述或上传参考图片，Kling 2.6 将根据您的指令生成高质量的视频内容。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Kling 2.6 每次生成消耗 28 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "支持哪些分辨率和时长？",
          "a": "支持 720p 和 1080p 分辨率，时长可选 5 秒和 10 秒。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "是的，使用 Kling 2.6 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "kling3": {
      "title": "Kling 3.0 AI 视频生成器",
      "desc": "Kling 3.0 是高性能 AI 视频模型，支持文生视频和图生视频，具有出色的动态质量和快速生成速度。",
      "features": [
        {
          "icon": "🎬",
          "title": "高质量动态",
          "desc": "流畅自然的动态效果，专业级输出质量。"
        },
        {
          "icon": "📱",
          "title": "多种纵横比",
          "desc": "支持 1:1、16:9、9:16 等多种纵横比。"
        },
        {
          "icon": "🔊",
          "title": "音频生成",
          "desc": "可选的原生音频生成，完整视频体验。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "大多数视频在 2 分钟内完成。"
        },
        {
          "icon": "🖼️",
          "title": "图片转视频",
          "desc": "用 AI 动画让静态图片动起来。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Kling 3.0 如何工作？",
          "a": "输入文字描述或上传参考图片，Kling 3.0 将根据您的指令生成高质量的视频内容。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Kling 3.0 每次生成消耗 28 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "支持哪些分辨率和时长？",
          "a": "支持 720p 和 1080p 分辨率，时长可选 5 秒和 10 秒。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "是的，使用 Kling 3.0 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "sora": {
      "title": "Sora 2 AI 视频生成器",
      "desc": "Sora 2 是 OpenAI 的先进 AI 视频模型，能够生成具有逼真动态和电影级质量的高质量视频。",
      "demoPromptExample": "@sama OpenAI 首席执行官 Sam 正在介绍这款橱柜产品，称与他自己家用的是同款，非常实用。",
      "landscape": "横向",
      "portrait": "竖向",
      "removeWatermark": "去除水印",
      "enabled": "已启用",
      "disabled": "已禁用",
      "noWatermark": "无水印",
      "cinematic": "电影品质",
      "restrictedAccess": "受限访问",
      "60secDuration": "4秒 / 8秒 / 12秒时长",
      "photorealistic": "照片级真实",
      "physicsSimulation": "物理仿真",
      "features": [
        {
          "icon": "🎬",
          "title": "电影级质量",
          "desc": "生成具有专业电影观感的视频。"
        },
        {
          "icon": "🎥",
          "title": "逼真动态",
          "desc": "角色和场景的自然逼真动态。"
        },
        {
          "icon": "⏱️",
          "title": "灵活时长",
          "desc": "支持多种视频长度满足不同需求。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "优化快速视频制作流程。"
        },
        {
          "icon": "🖼️",
          "title": "多模态输入",
          "desc": "支持文生视频和图生视频模式。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Sora 2 如何工作？",
          "a": "输入文字描述或上传参考图片，Sora 2 将根据您的指令生成高质量的视频内容。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "使用 Sora 2 每次生成消耗 15 积分。您可以通过订阅计划获得更优惠的积分价格。"
        },
        {
          "q": "Sora 2 有什么特别之处？",
          "a": "Sora 2 擅长生成逼真的动态和电影级质量的视频，非常适合专业内容创作。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "是的，使用 Sora 2 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "wan": {
      "title": "Wan AI 视频生成器",
      "desc": "Wan 是多功能 AI 视频模型，支持文生视频和图生视频，具有出色的质量和速度。",
      "multiFormat": "多种格式",
      "smoothMotion": "流畅动态",
      "referenceAudio": "参考音频",
      "uploadAudio": "点击上传参考音频",
      "uploadAudioHint": "MP3, WAV, M4A（可选，用于驱动视频音轨）",
      "features": [
        {
          "icon": "🎬",
          "title": "高质量输出",
          "desc": "从文字或图片生成专业级视频。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "高效的视频制作流程。"
        },
        {
          "icon": "📱",
          "title": "多种格式",
          "desc": "支持多种纵横比和分辨率。"
        },
        {
          "icon": "🖼️",
          "title": "图片动画",
          "desc": "用 AI 动态让静态图片焕发生机。"
        },
        {
          "icon": "🎥",
          "title": "流畅动态",
          "desc": "生成视频中自然流畅的动态。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Wan 如何工作？",
          "a": "输入文字描述或上传参考图片，Wan 将根据您的指令生成高质量的视频内容。"
        },
        {
          "q": "应该使用哪个 Wan 版本？",
          "a": "Wan 2.5 和 2.6 提供最新功能和最佳质量。Wan 2.2 是简单项目的经济选择。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "Wan 2.6 消耗 70 积分，Wan 2.5 消耗 60 积分，Wan 2.2 消耗 10 积分。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "是的，使用 Wan 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "wan25": {
      "title": "Wan 2.5 AI 视频生成器",
      "desc": "Wan 2.5 是多功能 AI 视频模型，支持文生视频和图生视频，具有出色的质量和速度。",
      "features": [
        {
          "icon": "🎬",
          "title": "高质量输出",
          "desc": "从文字或图片生成专业级视频。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "高效的视频制作流程。"
        },
        {
          "icon": "📱",
          "title": "多种格式",
          "desc": "支持多种纵横比和分辨率。"
        },
        {
          "icon": "🖼️",
          "title": "图片动画",
          "desc": "用 AI 动态让静态图片焕发生机。"
        },
        {
          "icon": "🎥",
          "title": "流畅动态",
          "desc": "生成视频中自然流畅的动态。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Wan 2.5 如何工作？",
          "a": "输入文字描述或上传参考图片，Wan 2.5 将根据您的指令生成高质量的视频内容。"
        },
        {
          "q": "Wan 2.5 与 Wan 2.6 有什么区别？",
          "a": "Wan 2.6 在画质和稳定性上进一步优化；Wan 2.5 性价比高，适合大多数场景。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "Wan 2.5 每次生成消耗 60 积分。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "是的，使用 Wan 2.5 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "wan26": {
      "title": "Wan 2.6 AI 视频生成器",
      "desc": "Wan 2.6 是增强版 AI 视频模型，画质与稳定性全面提升，支持文生视频和图生视频。",
      "features": [
        {
          "icon": "🎬",
          "title": "高质量输出",
          "desc": "从文字或图片生成专业级视频，画质更优。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "高效的视频制作流程。"
        },
        {
          "icon": "📱",
          "title": "多种格式",
          "desc": "支持多种纵横比和分辨率。"
        },
        {
          "icon": "🖼️",
          "title": "图片动画",
          "desc": "用 AI 动态让静态图片焕发生机。"
        },
        {
          "icon": "🎥",
          "title": "流畅动态",
          "desc": "生成视频中自然流畅的动态。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "所有生成的视频均可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Wan 2.6 与 Wan 2.5 有什么区别？",
          "a": "Wan 2.6 在画质和稳定性上进一步优化，适合对质量要求更高的场景。"
        },
        {
          "q": "Wan 2.6 如何工作？",
          "a": "输入文字描述或上传参考图片，Wan 2.6 将根据您的指令生成高质量的视频内容。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "Wan 2.6 消耗 70 积分。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "是的，使用 Wan 2.6 生成的所有内容均可用于商业用途。"
        }
      ]
    },
    "wan22": {
      "title": "Wan 2.2 经典版 AI 视频生成器",
      "desc": "Wan 2.2 是经典版 AI 视频模型，支持文生视频与图生视频，稳定可靠且性价比高。",
      "demoPromptExample": "日落时分，有着零星雀斑、一头蓬乱红发的女孩坐在屋顶上，略显磨损的牛仔外套，手中拿着宝丽来相机，身后城市天际线在柔和色调中闪耀。",
      "resolutionBadge": "720p",
      "classicVersion": "经典版本",
      "stableReliable": "稳定可靠",
      "costEffective": "高性价比",
      "features": [
        {
          "icon": "🎬",
          "title": "文生/图生视频",
          "desc": "支持文生视频与图生视频，适合日常创作与批量测试。"
        },
        {
          "icon": "⚡",
          "title": "稳定出片",
          "desc": "成熟经典模型，生成效果稳定可控。"
        },
        {
          "icon": "💰",
          "title": "成本友好",
          "desc": "积分消耗更低，适合高频使用。"
        },
        {
          "icon": "📐",
          "title": "常用比例",
          "desc": "支持 16:9 与 9:16 常见画幅。"
        },
        {
          "icon": "🎥",
          "title": "清晰输出",
          "desc": "提供清晰稳定的视频输出效果。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "生成内容可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Wan 2.2 和 Wan 2.5 的区别是什么？",
          "a": "Wan 2.2 更适合成本敏感和批量场景；Wan 2.5/2.6 在能力和画质上更强。"
        },
        {
          "q": "Wan 2.2 如何工作？",
          "a": "输入文本提示词或上传参考图，模型将按指令生成视频内容。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "可以，Wan 2.2 生成内容支持商业用途。"
        }
      ]
    },
    "kling25": {
      "title": "Kling 2.5 AI 视频生成器",
      "desc": "Kling 2.5 是标准版 AI 视频模型，支持文生视频与图生视频，稳定可靠且性价比较高。",
      "standard": "标准版",
      "reliable": "稳定可靠",
      "costEffective": "高性价比",
      "standardQuality": "标准质量",
      "textToVideo": "文本转视频",
      "imageToVideo": "图片转视频",
      "referenceImage": "参考图片",
      "referenceImageHint": "点击上传或拖拽文件",
      "referenceImageFormats": "支持 PNG、JPG、JPEG、WEBP（<=10MB）",
      "endFrame": "尾帧图片",
      "endFrameOptional": "可选",
      "endFrameFormats": "PNG, JPG, JPEG",
      "endFrameHint": "用于约束视频结尾画面，建议与参考图比例一致",
      "videoPrompt": "视频提示词",
      "promptPlaceholder": "描述你想生成的视频内容...",
      "negativePrompt": "负面提示词",
      "negativePromptPlaceholder": "描述你不希望出现的内容...",
      "duration": "时长",
      "aspectRatio": "纵横比",
      "uploading": "上传中...",
      "clickToUploadReference": "点击上传参考图",
      "clickToUploadEndFrame": "点击上传尾帧图",
      "remove": "移除",
      "creditsRequired": "所需积分：",
      "remaining": "剩余：",
      "generate": "生成",
      "generating": "生成中...",
      "demoPrompt": "演示提示",
      "demoPromptExample": "以上传的科幻小巷图为首帧。保持同一条小巷、霓虹招牌、反光与戴兜帽女子远去的背影。镜头缓缓沿小巷向前推进……",
      "model": "模型：",
      "durationLabel": "时长：",
      "introTitle": "使用 Kling 2.5 标准版生成高质量视频",
      "featuresBadge": "核心功能",
      "featuresTitle": "{name} 能做什么？",
      "faqTitle": "常见问题",
      "errorPromptRequired": "请输入提示词",
      "errorImageRequired": "图生视频模式需要上传参考图片",
      "errorGenerationFailed": "生成失败",
      "errorRequestFailed": "请求失败，请重试",
      "errorUploadFailed": "上传失败，请重试",
      "features": [
        {
          "icon": "🎬",
          "title": "文生/图生视频",
          "desc": "支持文生视频和图生视频，支持 5s/10s。"
        },
        {
          "icon": "⚡",
          "title": "稳定可靠",
          "desc": "成熟稳定的标准模型，出片质量稳定。"
        },
        {
          "icon": "💰",
          "title": "高性价比",
          "desc": "相比高阶版本积分消耗更低。"
        },
        {
          "icon": "📐",
          "title": "多比例支持",
          "desc": "支持 1:1、16:9、9:16。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "生成内容可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Kling 2.5 和 Kling 2.6 的区别是什么？",
          "a": "Kling 2.5 更适合成本与效率场景，Kling 2.6 在能力上更全面。"
        },
        {
          "q": "Kling 2.5 如何工作？",
          "a": "输入提示词或上传参考图，模型将按你的描述生成视频。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "可以，Kling 2.5 生成内容支持商业用途。"
        }
      ]
    },
    "hailuo": {
      "title": "Hailuo 2.3 AI 视频生成器",
      "desc": "Hailuo 2.3 是新一代 AI 视频模型，支持高质量视频生成，适合创意内容创作。",
      "demoPromptExample": "电影感镜头：日落时分海浪拍打礁石海岸，金色余晖映在水面上……",
      "highQuality": "高质量",
      "highQualityOutput": "高质量输出",
      "features": [
        {
          "icon": "🎬",
          "title": "文本转视频",
          "desc": "输入文本描述即可生成高质量视频。"
        },
        {
          "icon": "✨",
          "title": "提示优化",
          "desc": "支持提示词优化，提升生成结果质量。"
        },
        {
          "icon": "🌊",
          "title": "创意风格",
          "desc": "擅长创意与艺术风格内容。"
        },
        {
          "icon": "⚡",
          "title": "快速生成",
          "desc": "优化推理流程，减少等待时间。"
        },
        {
          "icon": "🎨",
          "title": "画质表现",
          "desc": "输出细节丰富、质量稳定的视频内容。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "生成内容可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Hailuo 2.3 如何工作？",
          "a": "输入提示词或上传参考图，模型会根据指令生成视频内容。"
        },
        {
          "q": "什么是提示优化？",
          "a": "提示优化会自动改写和补全描述，以获得更稳定的结果。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "可以，Hailuo 2.3 生成内容支持商业用途。"
        },
        {
          "q": "每次生成需要多少积分？",
          "a": "每次生成按当前模型积分规则计费。"
        }
      ]
    },
    "viduq3pro": {
      "title": "Vidu Q3 Pro AI 视频生成",
      "desc": "Vidu Q3 Pro 支持文生视频与图生视频，可选分辨率、1–16 秒时长、画幅比例与配音。",
      "imageUrlHint": "仅支持 HTTPS 图片 URL（上传后将自动获得可访问链接）；图片宽高比需在 1:4 至 4:1 之间。",
      "lengthLabel": "时长（秒）",
      "optional": "可选",
      "tagHighQuality": "高质量",
      "tagLength": "1–16 秒",
      "tagResolution": "最高 2K",
      "demoPromptExample": "晨光中的海滨步道，行人慢跑，海鸥掠过海面，远处帆船缓缓移动。",
      "features": [
        { "icon": "🎬", "title": "文生与图生", "desc": "文本描述或参考图均可驱动生成。" },
        { "icon": "📐", "title": "灵活画幅", "desc": "文生支持 16:9、9:16、1:1、4:3、3:4。" },
        { "icon": "⏱️", "title": "时长可选", "desc": "支持 1 至 16 秒输出。" },
        { "icon": "🎵", "title": "可选配音", "desc": "可开启自然风格配音生成。" },
        { "icon": "🎲", "title": "种子控制", "desc": "可选 seed，便于复现相近结果。" }
      ],
      "faq": [
        { "q": "图生视频对图片有什么要求？", "a": "需提供可公网访问的 HTTPS 图片链接（JPG/PNG）；宽高比须小于 1:4 或 4:1。" },
        { "q": "文生和图生参数有什么不同？", "a": "文生需选择画幅比例；图生需上传参考图，接口使用图片比例而非文生的 aspectRatio。" },
        { "q": "如何计费？", "a": "按当前页面展示的积分规则，与时长、分辨率及是否开启配音相关。" }
      ]
    },
    "wanAnimate": {
      "title": "Wan Animate",
      "desc": "基于参考图与参考视频的角色动画：标准模式或专业模式，可选水印。",
      "animateMode": "动画模式",
      "modeAnimate": "图生动作",
      "modeReplace": "视频换人",
      "referenceVideo": "参考视频",
      "quality": "画质模式",
      "refImageLabel": "参考图片",
      "refImageHint": "需动画化的角色或主体（JPG/PNG/JPEG/BMP/WEBP，最大 5MB，边长 200–4096px，宽高比 1:3～3:1）。",
      "refVideoLabel": "参考视频",
      "refVideoHint": "动作参考（MP4/AVI/MOV，2–30 秒，最大 200MB，边长 200–2048px，宽高比 1:3～3:1）。",
      "animateModeLabel": "动画模式",
      "btnAnimate": "动画化",
      "animateModeBadgeAnimate": "动作",
      "animateModeBadgeReplace": "换角",
      "btnAnimateDesc": "将图像中的角色与视频中的运动结合进行动画化。",
      "btnReplace": "替换",
      "btnReplaceDesc": "用图片中的角色替换视频中的角色。",
      "qualityLabel": "画质模式",
      "qualityStd": "标准",
      "qualityPro": "专业",
      "watermarkLabel": "水印",
      "uploadVideoRequired": "请上传参考视频。",
      "uploadImage": "上传图片",
      "uploadVideo": "上传视频",
      "uploading": "上传中…",
      "imageUploadHint": "JPG、PNG、JPEG、BMP、WEBP · 最大 5MB",
      "videoUploadHint": "MP4、AVI、MOV · 2–30 秒 · 最大 200MB",
      "uploadImageRequired": "请上传参考图片。",
      "errImageFileTooLarge": "图片超过大小限制（最大 5MB）。",
      "errImageDimensions": "图片宽高需在 200–4096 像素之间。",
      "errImageAspect": "图片宽高比需在 1:3 至 3:1 之间。",
      "errImageInvalid": "图片无效或无法读取。",
      "errVideoFileTooLarge": "视频超过大小限制（最大 200MB）。",
      "errVideoDuration": "视频时长需在 2–30 秒之间。",
      "errVideoDimensions": "视频宽高需在 200–2048 像素之间。",
      "errVideoAspect": "视频宽高比需在 1:3 至 3:1 之间。",
      "errVideoInvalid": "视频无效或无法读取。",
      "defaultModelName": "Wan Animate",
      "demoEmptyHint": "上传角色图片和动作视频，使用 Wan Animate 创建惊艳的角色动画。",
      "demoEmptyTitle": "角色动画",
      "demoStepCharacter": "角色",
      "demoStepMotion": "运动",
      "demoStepAnimate": "动画",
      "faqCredits": "专业模式单次消耗积分高于标准模式，见上方积分显示。",
      "characterAnimation": "角色动画",
      "faceSwap": "换脸",
      "motionTransfer": "动作迁移",
      "identityReplacement": "身份替换",
      "motionAccuracy": "高运动还原",
      "features": [
        { "icon": "🎭", "title": "双模式", "desc": "动画化迁移动作，或替换视频中的角色。" },
        { "icon": "📐", "title": "阿里云百炼", "desc": "基于 Wan 2.2 Animate 官方异步任务。" },
        { "icon": "⚡", "title": "标准 / 专业", "desc": "每任务可选 wan-std 或 wan-pro。" },
        { "icon": "💧", "title": "可选水印", "desc": "可自行选择是否添加水印。" }
      ],
      "faq": [
        { "q": "需要哪些输入？", "a": "上传后得到可公网访问的 HTTPS 图片与视频地址；需满足格式、大小与宽高比限制。" },
        { "q": "动画化与替换有什么区别？", "a": "动画化将参考视频的运动迁移到参考图角色；替换用参考图角色替换视频中的角色。" },
        { "q": "积分如何计算？", "a": "专业模式高于标准模式，以页面展示为准。" }
      ]
    },
    "runway": {
      "title": "Runway AI 视频生成器",
      "desc": "Runway 是专业级 AI 视频模型，支持多种比例与参数控制，适合专业内容制作。",
      "demoPromptExample": "暮色中，新加坡某建筑工地的起重机剪影映衬在绚烂的夕阳下。几名戴着安全帽的工人正在收拾工具，准备收工离开……",
      "professional": "专业级",
      "multiOption": "多参数可选",
      "highQuality": "高质量",
      "multiFormat": "多种画幅",
      "reproducibleSeed": "可复现种子",
      "features": [
        {
          "icon": "🎬",
          "title": "图生视频",
          "desc": "上传参考图并输入提示词，快速生成高质量视频。"
        },
        {
          "icon": "📐",
          "title": "多种比例",
          "desc": "支持 16:9、9:16、1:1、4:3、3:4、21:9。"
        },
        {
          "icon": "🎲",
          "title": "种子控制",
          "desc": "支持 seed，便于复现相近结果。"
        },
        {
          "icon": "⚡",
          "title": "专业输出",
          "desc": "输出质量稳定，适合创作与商用场景。"
        },
        {
          "icon": "🖼️",
          "title": "图片动画",
          "desc": "将静态图片转换为动态视频镜头。"
        },
        {
          "icon": "💼",
          "title": "商业授权",
          "desc": "生成内容可用于商业用途。"
        }
      ],
      "faq": [
        {
          "q": "Runway 如何工作？",
          "a": "上传参考图并输入提示词，模型会生成对应视频内容。"
        },
        {
          "q": "支持哪些画幅比例？",
          "a": "支持 16:9、9:16、1:1、4:3、3:4、21:9。"
        },
        {
          "q": "生成的视频可以用于商业用途吗？",
          "a": "可以，Runway 生成内容支持商业用途。"
        }
      ]
    }
  },
  "privacy": {
    "title": "隐私政策",
    "lastUpdated": "最后更新：2025年1月15日",
    "navTerms": "服务条款 →",
    "navTrust": "信任与安全 →",
    "sections": [
      {
        "title": "1. 信息收集",
        "paragraphs": [
          "我们收集您在注册和使用服务时提供的信息，包括电子邮件地址、用户名和付款信息。",
          "我们还会自动收集使用数据，如 IP 地址、浏览器类型、访问时间和使用的功能。"
        ]
      },
      {
        "title": "2. 信息使用",
        "paragraphs": [
          "我们使用收集的信息来提供、维护和改进我们的服务，处理交易，发送服务相关通知，以及防止欺诈和滥用。",
          "我们不会将您的个人信息出售给第三方。"
        ]
      },
      {
        "title": "3. AI 生成内容",
        "paragraphs": [
          "您上传的图片和输入的提示词仅用于生成您请求的内容，不会被用于训练 AI 模型。",
          "生成的内容会在服务器上临时存储以供您下载，之后会按照我们的数据保留政策进行删除。"
        ]
      },
      {
        "title": "4. 数据安全",
        "paragraphs": [
          "我们采用行业标准的安全措施来保护您的个人信息，包括 SSL 加密、访问控制和定期安全审计。",
          "尽管我们尽最大努力保护您的数据，但没有任何互联网传输方法是 100% 安全的。"
        ]
      },
      {
        "title": "5. Cookie 使用",
        "paragraphs": [
          "我们使用 Cookie 和类似技术来改善用户体验、分析使用情况和提供个性化内容。",
          "您可以通过浏览器设置管理 Cookie 偏好。禁用 Cookie 可能会影响某些功能的正常使用。"
        ]
      },
      {
        "title": "6. 第三方服务",
        "paragraphs": [
          "我们可能使用第三方服务提供商来协助我们提供服务，如支付处理、数据分析和客户支持。",
          "这些第三方服务提供商仅在为我们执行服务所需的范围内访问您的个人信息。"
        ]
      },
      {
        "title": "7. 您的权利",
        "paragraphs": [
          "您有权访问、更正或删除您的个人信息。您也有权要求我们限制处理您的数据或将您的数据转移到其他服务。",
          "如需行使这些权利，请通过 miral_support@miralvis.com 联系我们。我们将在 30 天内回复您的请求。"
        ]
      },
      {
        "title": "8. GDPR 合规",
        "paragraphs": [
          "对于欧洲经济区的用户，我们遵守《通用数据保护条例》(GDPR) 的要求。我们处理您的数据的法律依据包括合同履行、合法利益和您的同意。"
        ]
      },
      {
        "title": "9. 联系我们",
        "paragraphs": [
          "如果您对我们的隐私政策有任何疑问或关切，请通过 miral_support@miralvis.com 联系我们的数据保护团队。"
        ]
      }
    ]
  },
  "terms": {
    "title": "服务条款",
    "lastUpdated": "最后更新：2025年1月15日",
    "navPrivacy": "隐私政策 →",
    "navTrust": "信任与安全 →",
    "sections": [
      {
        "title": "1. 服务概述",
        "paragraphs": [
          "Miral（以下简称\"本平台\"）是一个集图像、视频、音乐创作于一体的 AI 平台。本服务条款（以下简称\"条款\"）规定了您使用本平台服务的条件和规则。",
          "使用本平台即表示您同意受这些条款的约束。如果您不同意这些条款，请不要使用本平台。"
        ]
      },
      {
        "title": "2. 账户注册",
        "paragraphs": [
          "您必须年满 18 岁才能注册账户。您需要提供准确、完整的注册信息，并负责维护账户安全。",
          "您对通过您的账户进行的所有活动负责。如果发现任何未经授权的使用，请立即通知我们。"
        ]
      },
      {
        "title": "3. 服务使用",
        "paragraphs": [
          "本平台提供基于积分的 AI 内容生成服务。积分可通过订阅或单次购买获得。不同的 AI 模型和功能消耗不同数量的积分。",
          "您同意不会将本平台用于任何非法、有害或侵权的目的。禁止生成违法、色情、暴力或侵犯他人权利的内容。"
        ]
      },
      {
        "title": "4. 知识产权",
        "paragraphs": [
          "您通过本平台生成的内容的知识产权归您所有，但需遵守各 AI 模型提供商的使用条款。",
          "本平台的商标、标识、界面设计和软件代码受知识产权法保护，未经授权不得使用。"
        ]
      },
      {
        "title": "5. 付款与退款",
        "paragraphs": [
          "所有付款均以美元计价。订阅费用按月或按年收取，具体取决于您选择的方案。",
          "首次购买单次套餐或首次订阅，在 7 个自然日内且积分使用量低于 3% 的情况下，可申请退款。"
        ]
      },
      {
        "title": "6. 免责声明",
        "paragraphs": [
          "本平台按\"现状\"提供服务，不对服务的可用性、准确性或适用性做出任何明示或暗示的保证。",
          "AI 生成的内容可能存在不准确或不完美之处。用户应自行判断生成内容的适用性。"
        ]
      },
      {
        "title": "7. 责任限制",
        "paragraphs": [
          "在法律允许的最大范围内，本平台对因使用或无法使用服务而导致的任何直接、间接、附带或后果性损害不承担责任。",
          "本平台的总责任不超过您在过去 12 个月内支付的费用总额。"
        ]
      },
      {
        "title": "8. 条款修改",
        "paragraphs": [
          "我们保留随时修改这些条款的权利。修改后的条款将在本页面发布时生效。",
          "继续使用本平台即表示您接受修改后的条款。重大变更将通过电子邮件或平台通知告知您。"
        ]
      },
      {
        "title": "9. 联系我们",
        "paragraphs": [
          "如果您对这些条款有任何疑问，请通过 miral_support@miralvis.com 联系我们。"
        ]
      }
    ]
  },
  "trustSafety": {
    "tag": "🛡️ 信任与安全",
    "title": "您的数据安全是我们的首要任务",
    "subtitle": "了解我们如何保护您的隐私和数据安全。",
    "badges": [
      {
        "icon": "🛡️",
        "title": "不参与 AI 训练",
        "desc": "您上传的内容和生成的作品绝不会被用于训练任何 AI 模型。"
      },
      {
        "icon": "🔒",
        "title": "端到端加密",
        "desc": "所有数据传输均采用 TLS 1.3 加密，存储数据使用 AES-256 加密。"
      },
      {
        "icon": "✓",
        "title": "GDPR 合规",
        "desc": "完全符合欧盟《通用数据保护条例》的要求。"
      },
      {
        "icon": "🗑️",
        "title": "自主数据控制",
        "desc": "您可以随时导出或删除您的所有数据，包括注销账号。"
      }
    ],
    "sections": [
      {
        "title": "数据处理透明度",
        "paragraphs": [
          "我们对数据的处理方式完全透明。您上传的图片和视频仅用于生成您请求的内容，处理完成后会在 24 小时内从服务器删除。",
          "生成的内容存储在您的账户中，您可以随时下载或删除。我们不会在未经您同意的情况下分享您的内容。"
        ]
      },
      {
        "title": "安全基础设施",
        "paragraphs": [
          "我们的服务部署在全球领先的云基础设施上，具备多层安全防护。所有服务器都位于通过 SOC 2 和 ISO 27001 认证的数据中心。",
          "我们定期进行安全审计和渗透测试，确保系统的安全性。所有员工都接受严格的安全培训。"
        ]
      },
      {
        "title": "内容安全",
        "paragraphs": [
          "我们部署了先进的内容安全系统，自动检测和阻止有害内容的生成。这包括但不限于暴力、色情和侵权内容。",
          "如果您发现任何违规内容，请通过 abuse@miral.org 向我们举报。"
        ]
      },
      {
        "title": "合规与认证",
        "paragraphs": [
          "我们遵守全球主要的数据保护法规，包括 GDPR（欧盟）、CCPA（加利福尼亚）和 LGPD（巴西）。",
          "我们的支付处理符合 PCI DSS 标准，确保您的支付信息安全。"
        ]
      }
    ],
    "ctaTitle": "有安全方面的疑虑？",
    "ctaDesc": "我们的安全团队随时为您解答",
    "ctaButton": "联系安全团队",
    "navTerms": "服务条款 →",
    "navPrivacy": "隐私政策 →"
  },
  "gallery": {
    "tag": "创作历史",
    "title": "我的创作",
    "subtitle": "查看您的所有 AI 创作历史记录。",
    "loginRequired": "请登录后查看创作历史",
    "empty": "暂无创作记录",
    "loadMore": "加载更多",
    "filters": {
      "all": "全部",
      "pending": "处理中",
      "finish": "已完成",
      "failed": "失败"
    },
    "usePrompt": "使用此提示词生成",
    "download": "下载",
    "status": {
      "pending": "处理中",
      "finish": "已完成",
      "failed": "失败"
    }
  },
  "inspiration": {
    "title": "灵感库",
    "subtitle": "看看创作者们正用 Miral 打造什么 —— 从超写实大片到电影级视频，灵感触手可及。",
    "filters": {
      "all": "全部",
      "image": "图片",
      "video": "视频",
      "portrait": "人像",
      "landscape": "风景",
      "fantasy": "奇幻",
      "anime": "动漫"
    }
  },
  "profile": {
    "joinTime": "加入时间",
    "tabs": {
      "account": "账户",
      "billing": "计费",
      "privacy": "数据与隐私"
    },
    "balance": {
      "title": "余额概览",
      "available": "可用积分"
    },
    "subscription": {
      "currentPlan": "当前计划",
      "status": "状态",
      "activated": "已激活",
      "cancelled": "在当前周期结束时取消",
      "pending": "处理中",
      "failed": "支付失败",
      "expiryDate": "有效期至",
      "permanent": "永久有效",
      "upgradePlan": "升级或变更方案",
      "cancelPlan": "取消订阅",
      "cancelNote": "您的订阅在当前账期结束前依然有效",
      "cancelWarning": "您的订阅将被取消。您可以在此之前继续使用所有功能，直到",
      "restorePlan": "恢复订阅"
    },
    "upgrade": {
      "title": "升级",
      "desc": "获得无限制访问和专享福利",
      "btn": "查看套餐"
    },
    "billing": {
      "title": "支付记录",
      "subtitle": "查看您的支付记录并下载发票",
      "empty": "暂无账单记录",
      "creditsPack": "积分包",
      "oneTime": "一次性",
      "monthly": "按月",
      "yearly": "按年",
      "refresh": "刷新",
      "plan": "套餐",
      "date": "日期",
      "amount": "金额",
      "invoice": "发票",
      "download": "下载",
      "invoiceModal": {
        "title": "发票详情",
        "orderInfo": "订单信息",
        "invoiceInfo": "发票信息",
        "plan": "套餐",
        "date": "支付日期",
        "amount": "支付金额",
        "paymentId": "订单号",
        "close": "关闭",
        "download": "下载发票",
        "fullName": "姓名",
        "fullNamePlaceholder": "请输入姓名",
        "email": "邮箱",
        "emailPlaceholder": "请输入邮箱",
        "company": "公司名称",
        "companyPlaceholder": "公司法定名称",
        "taxId": "税号",
        "taxIdPlaceholder": "请输入税号",
        "addressLine1": "地址行1",
        "addressLine1Placeholder": "街道地址",
        "addressLine2": "地址行2",
        "addressLine2Placeholder": "公寓、楼层等（可选）",
        "city": "城市",
        "cityPlaceholder": "城市",
        "province": "省份",
        "provincePlaceholder": "省份",
        "postalCode": "邮编",
        "postalCodePlaceholder": "邮政编码",
        "country": "国家",
        "countryPlaceholder": "国家",
        "invoiceRemarks": "备注",
        "invoiceRemarksPlaceholder": "发票备注信息",
        "optional": "可选",
        "required": "此项为必填"
      }
    },
    "privacy": {
      "title": "隐私设置",
      "cardTitle": "您的数据已受保护",
      "cardSubtitle": "我们对您数据隐私与安全的承诺",
      "item1": "您的数据绝不用于 AI 模型训练",
      "item2": "数据传输与存储全程加密",
      "item3": "生成的作品将在存储期满后自动删除",
      "item4": "无反馈循环，不进行衍生数据二次利用",
      "item5": "严格遵守数据保护法规"
    },
    "support": {
      "title": "需要帮助？",
      "desc": "我们的客服团队随时为您服务",
      "btn": "联系客服",
      "note": "miral_support@miralvis.com · 24小时内回复"
    }
  },
  "payment": {
    "success": {
      "title": "支付成功",
      "message": "感谢您的购买！您的订单已成功处理，积分已添加到您的账户。",
      "goHome": "返回首页",
      "viewProfile": "查看个人中心"
    },
    "cancel": {
      "title": "支付已取消",
      "message": "您的支付已取消。如果您有任何问题，请随时联系我们的客服团队。",
      "tryAgain": "重新购买",
      "goHome": "返回首页"
    }
  },
  "seo": {
    "default": {
      "title": "Miral - AI 图文、视频及音乐创作平台",
      "description": "Miral 是一站式 AI 创作平台，支持 Seedream 4、Midjourney、GPT Image、Veo 3、Sora 2 等顶级 AI 模型，轻松生成精美图片、视频和音乐。",
      "keywords": "AI 图片生成, AI 视频生成, AI 音乐生成, 文生图, 文生视频, Seedream, Midjourney, Veo, Sora, Miral"
    },
    "home": {
      "title": "Miral AI 图片、视频与音乐生成平台 | Veo、Seedream、Midjourney",
      "description": "使用 Miral 一站式创作高质量 AI 图片、视频和音乐，支持 Seedream 5、Midjourney、Veo 3.1、Sora 2 等领先模型，快速完成设计、营销和内容创作。"
    },
    "pricing": {
      "title": "定价 - Miral AI 创作平台",
      "description": "Miral 提供灵活的定价方案，满足不同创作需求。购买积分，按需使用，无订阅压力。"
    },
    "profile": {
      "title": "个人中心 - Miral",
      "description": "管理您的 Miral 账户，查看订单记录和创作历史。"
    },
    "models": {
      "title": "AI 模型 - Miral",
      "description": "探索 Miral 平台的顶级 AI 模型，包括图片生成、视频生成和音乐生成模型。",
      "wan25": {
        "title": "Wan 2.5 - 强大的 AI 视频模型",
        "description": "Wan 2.5 提供下一代 AI 视频生成。创建逼真流畅的视频，具备高级运动和细节表现，适合创作者和企业使用。"
      },
      "wan26": {
        "title": "Wan 2.6 - 增强版 AI 视频生成器",
        "description": "使用 Wan 2.6 升级您的视频创作。该高级 AI 模型以改进的运动、细节和速度生成超逼真视频，适用于专业内容。"
      },
      "wan22": {
        "title": "Wan 2.2 - 快速 AI 视频生成器",
        "description": "Wan 2.2 是一款快速可靠的 AI 视频模型。快速生成高质量视频，适合需要高效专业内容制作的创作者。"
      },
      "wanAnimate": {
        "title": "Wan Animate - 角色动画 - Miral",
        "description": "使用阿里云 Wan 2.2 Animate，参考图 + 参考视频生成角色动画或替换。"
      },
      "veo30": {
        "title": "Veo 3.0 - 领先的 AI 视频模型",
        "description": "Veo 3.0 是顶级 AI 视频生成器。利用高级 AI 创建逼真的电影级视频，适合专业内容创作和营销推广。"
      },
      "veo31": {
        "title": "Veo 3.1 - 顶级 AI 视频生成",
        "description": "Veo 3.1 是领先的 AI 视频模型，可生成精美逼真的视频。以无与伦比的质量和速度创建电影级片段和动画。"
      },
      "kling26": {
        "title": "Kling 2.6 - 高端 AI 视频模型",
        "description": "Kling 2.6 实现专业级 AI 视频生成。利用高级 AI 生成高质量流畅视频，适合创作者、营销人员和企业使用。"
      },
      "kling3": {
        "title": "Kling 3 - AI 视频生成 - Miral",
        "description": "使用 Kling 3 模型生成高质量 AI 视频。"
      },
      "kling25": {
        "title": "Kling 2.5 - 可靠的 AI 视频模型",
        "description": "Kling 2.5 为创作者提供强大的 AI 视频生成。制作运动流畅、细节丰富的高质量视频，适合内容和营销使用。"
      },
      "seedance": {
        "title": "Seedance AI - 高级 AI 视频生成器",
        "description": "使用 Seedance AI 生成高质量 AI 视频。利用前沿 AI 模型创建精美片段、动画和电影级内容，快速获得专业效果。"
      },
      "sora2": {
        "title": "Sora 2 AI 视频生成器 – 文生视频与图生视频 | Miral",
        "description": "在 Miral 使用 Sora 2 根据文字或图片生成 AI 视频。注册领取免费积分，并可选择 4–12 秒、720p/1080p 及 16:9/9:16。"
      },
      "hailuo23": {
        "title": "Hailuo 2.3 - 智能 AI 视频生成器",
        "description": "Hailuo 2.3 提供智能 AI 视频生成。利用高级 AI 创建高质量创意视频，适合内容创作者和企业使用。"
      },
      "viduq3pro": {
        "title": "Vidu Q3 Pro - AI 视频生成 - Miral",
        "description": "使用 Vidu Q3 Pro 生成文生视频与图生视频，支持多分辨率与时长。"
      },
      "runway": {
        "title": "Runway - AI 视频创作平台",
        "description": "Runway 是面向创作者的领先 AI 视频平台。利用强大的 AI 工具编辑、生成和增强视频，适合专业内容制作。"
      },
      "nanobanana": {
        "title": "Nano Banana - AI 图像生成 - Miral",
        "description": "使用 Nano Banana 模型快速生成创意图像。"
      },
      "seedream4": {
        "title": "Seedream 4 - AI 图像生成器",
        "description": "使用 Seedream 4 创建精美高分辨率 AI 图像。利用高级 AI 生成逼真的艺术作品、插画和设计，适合专业创意工作。"
      },
      "seedream5": {
        "title": "Seedream 5 - 字节跳动 AI 图像生成 - Miral",
        "description": "使用字节跳动 Seedream 5 模型生成高质量 AI 图像。"
      },
      "midjourney": {
        "title": "Midjourney - AI 艺术生成器",
        "description": "Midjourney 是领先的 AI 艺术生成器。从文本提示创建令人惊叹的图像、艺术和设计，适合艺术家、设计师和内容创作者。"
      },
      "gptimage1": {
        "title": "GPT-Image-1 - OpenAI AI 图像模型",
        "description": "OpenAI GPT-Image-1 从文本生成高质量 AI 图像。创建逼真创意视觉内容，适用于设计、营销和内容创作。"
      },
      "gptimage15": {
        "title": "GPT Image 1.5 - OpenAI AI 图像生成 - Miral",
        "description": "使用 OpenAI GPT Image 1.5 模型生成高质量 AI 图像。"
      },
      "fluxpro11ultra": {
        "title": "Flux Pro 1.1 Ultra - 高端 AI 图像生成器",
        "description": "Flux Pro 1.1 Ultra 提供超高画质 AI 图像生成。利用高级 AI 创建逼真细致的图像，适合专业设计和艺术创作。"
      },
      "fluxschnell": {
        "title": "Flux Schnell - 快速 AI 图像生成器",
        "description": "Flux Schnell 是极速 AI 图像生成器。快速创建高质量图像，适合需要快速专业视觉内容的创作者。"
      },
      "flux1": {
        "title": "FLUX.1 AI 图片生成器免费在线使用 | Miral",
        "description": "免费在线使用 FLUX.1 AI 图片生成器，可选择 Flux Pro 1.1 Ultra 或 Flux Schnell，支持九种宽高比及多种视觉风格，快速创作高质量图片。",
        "heroHeadline": "FLUX.1 AI 图片生成器",
        "heroIntro": "免费使用 FLUX.1 AI 图片生成器。注册即可领取免费积分，并在 Flux Pro 1.1 Ultra 的高质量输出与 Flux Schnell 的快速多风格生成之间选择。",
        "eyebrow": "Black Forest Labs · FLUX.1",
        "sectionKicker": "FLUX.1",
        "ctaTag": "FLUX.1 · Miral",
        "badges": ["文生图", "9 种宽高比", "Pro 与 Schnell", "写实 / 数字艺术 / 动漫"],
        "previewLabel": "Flux Pro 1.1 Ultra",
        "previewMeta": ["1:1", "16:9", "9:16", "共 9 种比例"],
        "previewTitle": "在高质量成片与快速创作之间灵活选择",
        "previewDesc": "使用 Pro 1.1 Ultra 创作精致视觉，或用 Schnell 快速探索写实、数字艺术和动漫方向。",
        "keyFeaturesTitle": "使用 FLUX.1 文生图生成器创作高质量视觉",
        "keyFeaturesIntro": "了解 Flux Pro 1.1 Ultra 和 Flux Schnell 在提示词理解、输出速度、视觉风格与灵活比例方面的能力。",
        "exploreTitle": "探索更多 AI 图片模型",
        "mainFeaturesTitle": "FLUX.1 主要特点",
        "generatedImageLabel": "生成的图片",
        "versionLabel": "版本",
        "featureLabel": "主要特点",
        "useCaseLabel": "适用场景",
        "controlsTitle": "选择合适的模型、比例与视觉风格",
        "controlsIntro": "需要精致成片时选择 Flux Pro 1.1 Ultra，需要快速探索时选择 Flux Schnell，再根据发布渠道设置宽高比和视觉风格。",
        "galleryTitle": "更多 FLUX.1 图片生成示例",
        "discussionTitle": "FLUX.1 常见选择问题",
        "communityTitle": "FLUX.1 热门创作场景",
        "tutorialPrompt": "日出时分临海玻璃书店的安静室内，温暖阅读灯、浅色橡木书架、地面柔和倒影，写实室内摄影。",
        "qualityBenefits": [
          "更完整地呈现材质、光影与空间层次。",
          "准确理解包含主体、构图、镜头和风格的详细提示词。",
          "根据清晰的文字说明探索写实、数字艺术和动漫方向。"
        ],
        "features": [
          { "name": "高质量 FLUX.1 文生图", "short": "通过文字提示词创作细节丰富的专业视觉。", "desc": "Flux Pro 1.1 Ultra 适合重视画面细节、材质、光影和整体完成度的创作。清楚描述主体、构图、镜头与风格，有助于生成更贴合项目方向的图片。", "demo": { "type": "table", "rows": [
            { "prompt": "蓝调时刻的沙漠精品酒店外观，夯土墙面，温暖窗光，本土草丛，长阴影，写实建筑摄影。" },
            { "prompt": "手工意式馄饨的编辑风美食摄影，哑光黑盘，罗勒油，亚麻餐巾，定向窗光，浅景深。" }
          ] } },
          { "name": "Flux Schnell 快速生成", "short": "用于快速草稿、提示词测试和批量创意探索。", "desc": "Flux Schnell 更适合需要快速验证构图、风格或创意方向的工作流。它可以帮助你先生成草稿，再根据结果调整提示词并继续迭代。", "prompt": "环保创业公司的模块化纸板展台概念，简洁商品展示台，再生纸材质，明亮展会灯光，干净布局。" },
          { "name": "9 种图片宽高比", "short": "覆盖超宽、横版、正方形、竖版和超长画幅。", "desc": "Flux Pro 1.1 Ultra 与 Flux Schnell 均支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16 和 9:21，可适配横幅、商品图、社交内容、海报和移动端视觉。", "prompt": "21:9 全景阿尔卑斯观景台位于云海之上，玻璃观景平台，清晨光线，远处小型徒步者提供尺度感，电影感概念绘景。" },
          { "name": "Schnell 多种视觉风格", "short": "可选择自动、写实、数字艺术或动漫风格。", "desc": "Flux Schnell 提供 Auto、Photographic、Digital Art 和 Anime 四种风格方向，适合快速切换照片感、插画感和动漫视觉，不需要为每种风格单独更换模型。", "demo": { "type": "table", "rows": [
            { "prompt": "写实风格：自行车技师在阳光车库里调整复古公路车，沾有机油的双手，真实铬金属反射。" },
            { "prompt": "动漫风格：天空列车里的温馨猫咖，窗外是粉彩落日云层，表情丰富的人物，干净线稿。" }
          ] } },
          { "name": "灵活的创作场景", "short": "适合商品、营销、人像、概念艺术和社交视觉。", "desc": "FLUX.1 系列既能用于专业商品与品牌视觉，也适合快速生成活动概念、人物肖像、环境设计和不同平台所需的图片比例。", "prompt": "可持续运动鞋发布视觉，再生织物纹理，漂浮鞋带细节，苔绿色渐变背景，为社交广告文案保留大胆留白。" }
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "FLUX.1 提示词示例：生成更好的 AI 图片",
        "showcaseIntro": "使用这些 FLUX.1 提示词作为起点，清楚描述主体、构图、光线、镜头、材质、配色和视觉风格。",
        "variantsKicker": "模型指南",
        "variantsTitle": "Flux Pro 1.1 Ultra 与 Flux Schnell 对比",
        "variantsIntro": "根据项目对画质、速度和风格控制的需求选择合适的 FLUX.1 模型。",
        "variants": [
          { "name": "Flux Pro 1.1 Ultra", "tag": "高质量", "desc": "面向重视细节、真实感和完成度的专业文生图，支持 9 种宽高比。", "bestFor": "适合商品摄影、营销主视觉与高质量成片" },
          { "name": "Flux Schnell", "tag": "快速", "desc": "面向快速迭代和创意探索，支持 9 种宽高比，以及自动、写实、数字艺术和动漫风格。", "bestFor": "适合草稿、提示词测试、社交内容与快速创意" }
        ],
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "FLUX.1 热门使用场景",
        "useCases": [
          { "name": "FLUX.1 商品摄影", "desc": "创作商品主图、生活场景图和电商视觉概念。" },
          { "name": "FLUX.1 营销与广告", "desc": "生成社交广告、活动横幅和品牌营销视觉。" },
          { "name": "FLUX.1 写实人像", "desc": "创作光线、背景和构图可控的照片感人像。" },
          { "name": "FLUX.1 数字艺术", "desc": "使用 Schnell 快速探索插画、奇幻和数字艺术方向。" },
          { "name": "FLUX.1 动漫图片", "desc": "使用 Schnell 的 Anime 风格创作角色和动漫场景。" },
          { "name": "FLUX.1 概念艺术", "desc": "探索电影环境、游戏场景、角色和视觉世界观。" },
          { "name": "FLUX.1 社交媒体图片", "desc": "利用 9 种比例生成横版、正方形和竖版平台内容。" },
          { "name": "FLUX.1 海报与横幅", "desc": "为活动、宣传和移动端页面选择合适比例并生成版式概念。" }
        ],
        "howToKicker": "简单三步",
        "howToTitle": "如何免费在线使用 FLUX.1 AI 图片生成器",
        "howToIntro": "注册即可领取免费积分，并在 Miral 在线使用 Flux Pro 1.1 Ultra 或 Flux Schnell。",
        "howToSteps": [
          { "title": "输入详细提示词", "desc": "描述主体、场景、构图、光线、镜头、材质、配色和目标风格。" },
          { "title": "选择模型和比例", "desc": "高质量成片选择 Pro 1.1 Ultra，快速探索选择 Schnell，再设置所需宽高比和 Schnell 风格。" },
          { "title": "生成并继续调整", "desc": "开始生成，检查结果并下载图片，也可以调整提示词、比例或风格后继续创作。" }
        ],
        "howToCta": "免费使用 FLUX.1 AI 图片生成器",
        "faqTitle": "关于 FLUX.1 的常见问题",
        "faqs": [
          { "q": "FLUX.1 AI 图片生成器是什么？", "a": "FLUX.1 是 Black Forest Labs 的图像生成模型系列。在 Miral 上，你可以使用 Flux Pro 1.1 Ultra 和 Flux Schnell，将文字提示词转化为商品、营销、人像、动漫和概念艺术图片。" },
          { "q": "可以免费使用 FLUX.1 AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 FLUX.1 AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "Flux Pro 1.1 Ultra 和 Flux Schnell 有什么区别？", "a": "Flux Pro 1.1 Ultra 更适合重视细节和完成度的高质量成片；Flux Schnell 更适合快速草稿、提示词测试和多风格探索，并提供 Auto、Photographic、Digital Art 和 Anime 风格。" },
          { "q": "FLUX.1 支持哪些图片比例？", "a": "Miral 上的 Flux Pro 1.1 Ultra 和 Flux Schnell 均支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16 和 9:21，共 9 种宽高比。" },
          { "q": "Flux Schnell 支持哪些风格？", "a": "Flux Schnell 支持 Auto、Photographic、Digital Art 和 Anime，分别适合自动匹配、写实摄影、数字艺术和动漫视觉。" },
          { "q": "如何在线使用 FLUX.1 AI 图片生成器？", "a": "输入文字提示词，选择 Flux Pro 1.1 Ultra 或 Flux Schnell，再设置宽高比。使用 Schnell 时还可以选择视觉风格，然后点击生成。" },
          { "q": "有哪些优秀的 FLUX.1 提示词示例？", "a": "有效的 FLUX.1 提示词应清楚描述主体、场景、构图、光线、镜头、材质、配色和目标风格。可以使用本页示例作为起点，再根据项目调整。" },
          { "q": "FLUX.1 和 FLUX.2 应该怎么选？", "a": "如果需要 Flux Pro 1.1 Ultra 的高质量输出或 Flux Schnell 的快速多风格创作，可以选择 FLUX.1；如果需要 Klein、Max、Pro 和 Flex 等更新的版本选择，可以使用 Miral 的 FLUX.2 页面。" },
          { "q": "FLUX.1 和 Midjourney 应该怎么选？", "a": "FLUX.1 适合需要明确宽高比、快速 Schnell 工作流或 Pro 1.1 Ultra 高质量输出的用户；Midjourney 更适合偏好其艺术风格、参考图工作流和创作方式的用户。" }
        ],
        "ctaTitle": "在 Miral 免费使用 FLUX.1！",
        "ctaDesc": "注册即可领取免费积分。选择 Flux Pro 1.1 Ultra 或 Flux Schnell，并使用适合项目的比例和风格创作图片。"
      },
      "flux2": {
        "title": "FLUX.2 - AI 图像生成 - Miral",
        "description": "使用 FLUX.2 模型生成专业级 AI 图像——5 个版本满足速度、质量和控制需求。"
      },
      "zimageturbo": {
        "title": "Z Image Turbo - AI 图像生成 - Miral",
        "description": "使用 Z Image Turbo 模型生成高分辨率 AI 图像。"
      }
    },
    "tools": {
      "title": "AI 图像工具 - Miral",
      "description": "Miral 提供多种 AI 图像处理工具，包括去水印、背景移除、图片增强等。",
      "watermarkRemover": {
        "title": "免费 AI 水印去除器 - 在线去除照片水印 | Miral",
        "description": "免费使用 AI 水印去除器，在线清除照片中的全图水印、Logo、时间戳、文字和样稿标记。支持 JPG、PNG 和 WebP 图片。"
      },
      "backgroundRemover": {
        "title": "免费 AI 图片去背景 - 在线一键抠图生成透明 PNG | Miral",
        "description": "免费使用 AI 在线去除图片背景，一键抠出人像和商品主体，保留发丝与细小边缘，支持 JPG、PNG、WebP，快速下载透明背景 PNG。"
      },
      "imageEraser": {
        "title": "AI 图片擦除 - 去除照片中的物体",
        "description": "使用 AI 擦除照片中不需要的物体、人物、水印和文字。涂抹对应区域，AI 将无缝移除并用自然内容填补，轻松清理照片。"
      },
      "objectRemover": {
        "title": "AI 物体移除工具 - 在线去除照片中的多余物体 | Miral",
        "description": "在线移除照片中的多余物体、路人、标牌、电线和背景杂物。涂抹需要清理的区域，让 AI 重建自然干净的照片背景。"
      },
      "aiPersonRemover": {
        "title": "AI 人物移除 - 去除照片中的多余人物",
        "description": "使用 AI 移除照片中不需要的人物。涂抹对应人物，AI 将无缝移除并用自然内容填补，去除画面中的路人和陌生人。"
      },
      "whiteBackground": {
        "title": "AI 白色背景替换 - 商品白底图",
        "description": "使用 AI 自动将图片背景替换为纯白色。适合电商商品白底图、证件照等场景。"
      },
      "blueBackground": {
        "title": "AI 蓝色背景替换 - 证件照蓝底",
        "description": "使用 AI 自动将图片背景替换为纯蓝色。适合证件照、护照照片等场景。"
      },
      "faceSwap": {
        "title": "AI 在线换脸工具 - 交换两张照片中的人脸 | Miral",
        "description": "使用 AI 在线交换两张照片中的人脸。上传目标照片和清晰的源人脸，为人像、自拍和创意图片生成自然的换脸效果。"
      },
      "imageEnhancer": {
        "title": "AI 图片增强 - 放大增强照片",
        "description": "使用 AI 增强和放大图片。锐化细节、修复模糊、提升分辨率、修复老照片，获得高质量专业效果。"
      },
      "docCropEnhance": {
        "title": "免费 AI 文档切边矫正 - 试卷与作业扫描增强 | Miral",
        "description": "免费在线裁剪和矫正文档、试卷、作业及教材照片，修复倾斜、透视、弯曲和阴影，并锐化文字生成清晰扫描效果。"
      },
      "handwrittenErase": {
        "title": "免费 AI 试卷手写答案擦除工具 - 在线还原空白试卷 | Miral",
        "description": "免费在线擦除试卷、作业和练习册中的学生手写答案，尽量保留印刷试题。支持扫描文档旋转、切边和弯曲矫正。"
      }
    },
    "imageModels": {
      "title": "AI 图片模型 - Miral",
      "description": "在 Miral 探索顶级 AI 图片模型，通过文字描述生成精美图片。",
      "relatedModelsTitle": "探索更多 AI 图片模型",
      "demoPrompt": "文字描述",
      "demoOutput": "生成图片",
      "demoPlaceholder": "示例图 — 即将上线",
      "promptLabel": "使用模型",
      "usePrompt": "使用这个提示词 →",
      "imagePlaceholder": "AI 生成图片示例",
      "replaceImageHint": "根据左侧提示词生成的示例结果",
      "flux1": {
        "title": "FLUX.1 AI 图片生成器免费版 - 免费在线使用 | Miral",
        "description": "免费使用 FLUX.1 AI 图片生成器，通过 Flux Pro 1.1 Ultra 或 Flux Schnell 创作高质量图片，支持 9 种宽高比和多种视觉风格。注册即可领取免费积分，并立即生成图片。",
        "heroHeadline": "FLUX.1 AI 图片生成器",
        "heroIntro": "在 Miral AI 免费使用黑森林实验室（Black Forest Labs）推出的 FLUX.1 AI 图片生成器。注册即可领取免费积分，并可在 Flux Pro 1.1 Ultra 的高质量输出与 Flux Schnell 的快速多风格生成之间选择。",
        "eyebrow": "Black Forest Labs · FLUX.1",
        "sectionKicker": "FLUX.1",
        "ctaTag": "FLUX.1 · Miral",
        "badges": ["文生图", "9 种宽高比", "Pro 与 Schnell", "写实 / 数字艺术 / 动漫"],
        "previewLabel": "Flux Pro 1.1 Ultra",
        "previewMeta": ["1:1", "16:9", "9:16", "共 9 种比例"],
        "previewTitle": "在高质量成片与快速创作之间灵活选择",
        "previewDesc": "使用 Pro 1.1 Ultra 创作精致视觉，或用 Schnell 快速探索写实、数字艺术和动漫方向。",
        "keyFeaturesTitle": "使用 FLUX.1 文生图生成器创作高质量视觉",
        "keyFeaturesIntro": "了解 Flux Pro 1.1 Ultra 和 Flux Schnell 在提示词理解、输出速度、视觉风格与灵活比例方面的能力。",
        "exploreTitle": "探索更多 AI 图片模型",
        "mainFeaturesTitle": "FLUX.1 主要特点",
        "generatedImageLabel": "生成的图片",
        "versionLabel": "版本",
        "featureLabel": "主要特点",
        "useCaseLabel": "适用场景",
        "controlsTitle": "选择合适的模型、比例与视觉风格",
        "controlsIntro": "需要精致成片时选择 Flux Pro 1.1 Ultra，需要快速探索时选择 Flux Schnell，再根据发布渠道设置宽高比和视觉风格。",
        "galleryTitle": "更多 FLUX.1 图片生成示例",
        "discussionTitle": "FLUX.1 常见选择问题",
        "communityTitle": "FLUX.1 热门创作场景",
        "tutorialPrompt": "日出时分临海玻璃书店的安静室内，温暖阅读灯、浅色橡木书架、地面柔和倒影，写实室内摄影。",
        "qualityBenefits": [
          "更完整地呈现材质、光影与空间层次。",
          "准确理解包含主体、构图、镜头和风格的详细提示词。",
          "根据清晰的文字说明探索写实、数字艺术和动漫方向。"
        ],
        "features": [
          { "name": "高质量 FLUX.1 文生图", "short": "通过文字提示词创作细节丰富的专业视觉。", "desc": "Flux Pro 1.1 Ultra 适合重视画面细节、材质、光影和整体完成度的创作。清楚描述主体、构图、镜头与风格，有助于生成更贴合项目方向的图片。", "demo": { "type": "table", "rows": [
            { "prompt": "蓝调时刻的沙漠精品酒店外观，夯土墙面，温暖窗光，本土草丛，长阴影，写实建筑摄影。", "image": require("@/assets/images/flux1/b9d1e267-bb35-4d5c-a196-fae49460749d.webp") },
            { "prompt": "手工意式馄饨的编辑风美食摄影，哑光黑盘，罗勒油，亚麻餐巾，定向窗光，浅景深。", "image": require("@/assets/images/flux1/2ab9dde4-0420-4594-b875-a8465741b767.webp") }
          ] } },
          { "name": "Flux Schnell 快速生成", "short": "用于快速草稿、提示词测试和批量创意探索。", "desc": "Flux Schnell 更适合需要快速验证构图、风格或创意方向的工作流。它可以帮助你先生成草稿，再根据结果调整提示词并继续迭代。", "prompt": "环保创业公司的模块化纸板展台概念，简洁商品展示台，再生纸材质，明亮展会灯光，干净布局。", "image": require("@/assets/images/flux1/b8ffe8cb-1d2f-4bfc-897f-1068861614f9.webp") },
          { "name": "9 种图片宽高比", "short": "覆盖超宽、横版、正方形、竖版和超长画幅。", "desc": "Flux Pro 1.1 Ultra 与 Flux Schnell 均支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16 和 9:21，可适配横幅、商品图、社交内容、海报和移动端视觉。", "prompt": "21:9 全景阿尔卑斯观景台位于云海之上，玻璃观景平台，清晨光线，远处小型徒步者提供尺度感，电影感概念绘景。", "image": require("@/assets/images/flux1/a5efd8d2-571d-406d-9a01-f30581d4ea3b.webp") },
          { "name": "Schnell 多种视觉风格", "short": "可选择自动、写实、数字艺术或动漫风格。", "desc": "Flux Schnell 提供 Auto、Photographic、Digital Art 和 Anime 四种风格方向，适合快速切换照片感、插画感和动漫视觉，不需要为每种风格单独更换模型。", "demo": { "type": "table", "rows": [
            { "prompt": "写实风格：自行车技师在阳光车库里调整复古公路车，沾有机油的双手，真实铬金属反射。", "image": require("@/assets/images/flux1/2b870b40-a436-42b9-980f-538e303cdfce.webp") },
            { "prompt": "动漫风格：天空列车里的温馨猫咖，窗外是粉彩落日云层，表情丰富的人物，干净线稿。", "image": require("@/assets/images/flux1/faded76c-4da1-49bb-98dc-10b8276f7da8.webp") }
          ] } },
          { "name": "灵活的创作场景", "short": "适合商品、营销、人像、概念艺术和社交视觉。", "desc": "FLUX.1 系列既能用于专业商品与品牌视觉，也适合快速生成活动概念、人物肖像、环境设计和不同平台所需的图片比例。", "prompt": "可持续运动鞋发布视觉，再生织物纹理，漂浮鞋带细节，苔绿色渐变背景，为社交广告文案保留大胆留白。", "image": require("@/assets/images/flux1/0dfa0b4b-7722-40f4-9bc0-7bbf9bb1c000.webp") }
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "FLUX.1 提示词示例：生成更好的 AI 图片",
        "showcaseIntro": "使用这些 FLUX.1 提示词作为起点，清楚描述主体、构图、光线、镜头、材质、配色和视觉风格。",
        "variantsKicker": "模型指南",
        "variantsTitle": "Flux Pro 1.1 Ultra 与 Flux Schnell 对比",
        "variantsIntro": "根据项目对画质、速度和风格控制的需求选择合适的 FLUX.1 模型。",
        "variants": [
          { "name": "Flux Pro 1.1 Ultra", "tag": "高质量", "desc": "面向重视细节、真实感和完成度的专业文生图，支持 9 种宽高比。", "bestFor": "适合商品摄影、营销主视觉与高质量成片" },
          { "name": "Flux Schnell", "tag": "快速", "desc": "面向快速迭代和创意探索，支持 9 种宽高比，以及自动、写实、数字艺术和动漫风格。", "bestFor": "适合草稿、提示词测试、社交内容与快速创意" }
        ],
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "FLUX.1 热门使用场景",
        "useCases": [
          { "name": "FLUX.1 商品摄影", "desc": "创作商品主图、生活场景图和电商视觉概念。" },
          { "name": "FLUX.1 营销与广告", "desc": "生成社交广告、活动横幅和品牌营销视觉。" },
          { "name": "FLUX.1 写实人像", "desc": "创作光线、背景和构图可控的照片感人像。" },
          { "name": "FLUX.1 数字艺术", "desc": "使用 Schnell 快速探索插画、奇幻和数字艺术方向。" },
          { "name": "FLUX.1 动漫图片", "desc": "使用 Schnell 的 Anime 风格创作角色和动漫场景。" },
          { "name": "FLUX.1 概念艺术", "desc": "探索电影环境、游戏场景、角色和视觉世界观。" },
          { "name": "FLUX.1 社交媒体图片", "desc": "利用 9 种比例生成横版、正方形和竖版平台内容。" },
          { "name": "FLUX.1 海报与横幅", "desc": "为活动、宣传和移动端页面选择合适比例并生成版式概念。" }
        ],
        "howToKicker": "简单三步",
        "howToTitle": "如何免费在线使用 FLUX.1 AI 图片生成器",
        "howToIntro": "注册即可领取免费积分，并在 Miral 在线使用 Flux Pro 1.1 Ultra 或 Flux Schnell。",
        "howToSteps": [
          { "title": "输入详细提示词", "desc": "描述主体、场景、构图、光线、镜头、材质、配色和目标风格。" },
          { "title": "选择模型和比例", "desc": "高质量成片选择 Pro 1.1 Ultra，快速探索选择 Schnell，再设置所需宽高比和 Schnell 风格。" },
          { "title": "生成并继续调整", "desc": "开始生成，检查结果并下载图片，也可以调整提示词、比例或风格后继续创作。" }
        ],
        "howToCta": "免费使用 FLUX.1 AI 图片生成器",
        "faqTitle": "关于 FLUX.1 的常见问题",
        "faqs": [
          { "q": "FLUX.1 AI 图片生成器是什么？", "a": "FLUX.1 是 Black Forest Labs 的图像生成模型系列。在 Miral 上，你可以使用 Flux Pro 1.1 Ultra 和 Flux Schnell，将文字提示词转化为商品、营销、人像、动漫和概念艺术图片。" },
          { "q": "可以免费使用 FLUX.1 AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 FLUX.1 AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "Flux Pro 1.1 Ultra 和 Flux Schnell 有什么区别？", "a": "Flux Pro 1.1 Ultra 更适合重视细节和完成度的高质量成片；Flux Schnell 更适合快速草稿、提示词测试和多风格探索，并提供 Auto、Photographic、Digital Art 和 Anime 风格。" },
          { "q": "FLUX.1 支持哪些图片比例？", "a": "Miral 上的 Flux Pro 1.1 Ultra 和 Flux Schnell 均支持 21:9、16:9、4:3、3:2、1:1、2:3、3:4、9:16 和 9:21，共 9 种宽高比。" },
          { "q": "Flux Schnell 支持哪些风格？", "a": "Flux Schnell 支持 Auto、Photographic、Digital Art 和 Anime，分别适合自动匹配、写实摄影、数字艺术和动漫视觉。" },
          { "q": "如何在线使用 FLUX.1 AI 图片生成器？", "a": "输入文字提示词，选择 Flux Pro 1.1 Ultra 或 Flux Schnell，再设置宽高比。使用 Schnell 时还可以选择视觉风格，然后点击生成。" },
          { "q": "有哪些优秀的 FLUX.1 提示词示例？", "a": "有效的 FLUX.1 提示词应清楚描述主体、场景、构图、光线、镜头、材质、配色和目标风格。可以使用本页示例作为起点，再根据项目调整。" },
          { "q": "FLUX.1 和 FLUX.2 应该怎么选？", "a": "如果需要 Flux Pro 1.1 Ultra 的高质量输出或 Flux Schnell 的快速多风格创作，可以选择 FLUX.1；如果需要 Klein、Max、Pro 和 Flex 等更新的版本选择，可以使用 Miral 的 FLUX.2 页面。" },
          { "q": "FLUX.1 和 Midjourney 应该怎么选？", "a": "FLUX.1 适合需要明确宽高比、快速 Schnell 工作流或 Pro 1.1 Ultra 高质量输出的用户；Midjourney 更适合偏好其艺术风格、参考图工作流和创作方式的用户。" }
        ],
        "ctaTitle": "在 Miral 免费使用 FLUX.1！",
        "ctaDesc": "注册即可领取免费积分。选择 Flux Pro 1.1 Ultra 或 Flux Schnell，并使用适合项目的比例和风格创作图片。"
      },
      "flux2": {
        "title": "FLUX.2 AI 图片生成器免费在线使用 | Miral",
        "description": "免费在线使用 FLUX.2 AI 图片生成器，通过五种模型版本创作照片级图片、商品摄影、艺术作品、宣传海报及高质量营销视觉。",
        "heroHeadline": "FLUX.2 AI 图片生成器",
        "heroIntro": "在 Miral AI 免费使用黑森林实验室（Black Forest Labs）推出的 FLUX.2 AI 图片生成器。注册即可领取免费积分，并立即生成照片级图片、商品摄影、海报和营销视觉。",
        "eyebrow": "Black Forest Labs · FLUX.2",
        "sectionKicker": "FLUX.2",
        "ctaTag": "FLUX.2 · Miral",
        "badges": ["文生图", "照片级写实", "精准文字生成", "多种图片比例"],
        "previewLabel": "FLUX.2",
        "previewMeta": ["1:1", "1024 × 1024", "PNG"],
        "previewTitle": "从精准提示词到可直接使用的专业视觉",
        "previewDesc": "在统一流程中创作商品图、营销概念、人像和包含文字的设计作品。",
        "keyFeaturesTitle": "使用 FLUX.2 文生图生成器创作专业视觉",
        "keyFeaturesIntro": "了解 FLUX.2 AI 图片生成器在提示词还原、精细画质、写实输出和稳定视觉控制方面的核心能力。",
        "exploreTitle": "探索更多 AI 图片模型",
        "mainFeaturesTitle": "FLUX.2 主要特点",
        "generatedImageLabel": "生成的图片",
        "versionLabel": "版本",
        "featureLabel": "主要特点",
        "useCaseLabel": "适用场景",
        "controlsTitle": "选择合适的 FLUX.2 版本与输出设置",
        "controlsIntro": "快速迭代可选择 Klein，最高质量成片可选择 Max，规模化生产可选择 Pro，文字与精细细节控制可选择 Flex。",
        "galleryTitle": "更多 FLUX.2 图片示例",
        "discussionTitle": "FLUX.2 模型选择常见问题",
        "communityTitle": "FLUX.2 热门创作场景",
        "tutorialPrompt": "高端广告摄影：半透明祖母绿色香水瓶放在浅色石灰岩上，柔和晨光，真实玻璃折射，精致文字排版，大面积留白。",
        "qualityBenefits": [
          "更准确地遵循包含主体、构图、光线与风格的复杂提示词。",
          "生成适合专业视觉工作的真实纹理、自然景深和精细画面。",
          "为海报、商品标签和营销图形呈现更清晰的图片内文字。"
        ],
        "features": [
          { "name": "高端图像合成", "short": "在不增加延迟的前提下，提升提示词还原度与画质。", "desc": "FLUX.2 大幅增强了提示词的对齐能力，甚至支持长篇脚本与场景描述等长文本输入。它在保证速度的同时让生成图片拥有更高的保真度，减少反复调整的需要，帮助创作者更快得到成品。", "demo": { "type": "table", "rows": [
            { "prompt": "一幅色彩鲜艳、细节丰富的壮丽风景，展现山脉上空的日落。", "image": require('@/assets/images/flux2/1a2627bd-61e0-406a-9308-19f2883d004e.webp') },
            { "prompt": "用于在函数式语言与底层语言之间转换的抽象艺术。", "image": require('@/assets/images/flux2/sample.webp') },
            { "prompt": "一个动漫/卡通风格的角色头像，细节精致、制作精良，却宛如手绘。", "image": require('@/assets/images/flux2/57047990-2e26-4b44-bacf-f10bca5ee70d.webp') }
          ] } },
          { "name": "出色的细节与真实感", "short": "呈现逼真的纹理、光影与景深，达到影棚级画质。", "desc": "FLUX.2 能捕捉细腻的纹理、真实的光影与自然的景深，让生成图片看起来真正具有照片质感。这使它非常适合商品图、人像与电影感视觉等对真实度要求极高的场景。", "prompt": "银色机械腕表放在深色板岩上的影棚商品摄影，柔和侧光，真实拉丝金属纹理，浅景深，细腻反射，高端编辑风构图。", "image": require('@/assets/images/flux2/b1d818f0-ff1f-4612-b586-62f75e14466c.webp') },
          { "name": "强大的提示词还原", "short": "精准遵循复杂描述，包括具体主体、风格与构图。", "desc": "FLUX.2 对多层次、多要素的提示词有出色的解读能力——可在一次生成中同时处理特定主体、艺术风格、配色与构图指令。这赋予创作者更强的控制力，描述理想画面时无需反复重抽。", "prompt": "雨天傍晚，一辆红色有轨电车穿过欧洲广场，前景有三名骑行者，左侧咖啡馆窗户透出暖光，蓝调天空，对称构图，电影感摄影。", "image": require('@/assets/images/flux2/2026b767-edcb-4441-b70e-a6d94ae6ebb9.webp') },
          { "name": "进阶文字处理能力", "short": "在图片中渲染文字，拼写更清晰、风格更一致。", "desc": "FLUX.2 对图片内文字的生成与控制有所提升，字体风格一致性更佳。这让它能够制作海报、广告、漫画与品牌图形等文字类素材，瑕疵明显减少。", "demo": { "type": "table", "rows": [
            { "prompt": "一张唯美的神秘风景照，画面中带有文字「FLUX 2」，含蓄美感，融入蓝莓元素。", "image": require('@/assets/images/flux2/c2f47f20-00b4-4cec-b972-e7a69d40be56.webp') },
            { "prompt": "一个黑森林蛋糕，上面用文字拼出「FLUX 2 Pro」，诱人，美食摄影。", "image": require('@/assets/images/flux2/2258b023-29ba-433f-b909-88f542adc3b9.webp') }
          ] } },
          { "name": "快速可扩展的生成", "short": "从亚秒级迭代到最高质量输出，可按需求选择。", "desc": "FLUX.2 同时提供高速 Klein 模型以及面向生产的 Pro、Max 和 Flex 版本，既适合快速草稿和批量内容生产，也能完成高质量营销与创意成片。", "prompt": "一张干净的编辑风商品摄影：半透明绿色香水瓶放在石灰岩上，柔和晨光，细腻阴影，高端广告质感。", "image": require('@/assets/images/flux2/2a4b147b-31c2-4ded-a626-d7e209fb751b.webp') }
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "生成更好 AI 图片的 FLUX.2 提示词示例",
        "showcaseIntro": "使用这些 FLUX.2 提示词示例作为起点，调整主体、构图、光线和风格，然后直接发送到生成器。",
        "variantsKicker": "模型指南",
        "variantsTitle": "FLUX.2 模型对比：Klein、Max、Pro 与 Flex",
        "variantsIntro": "对比 FLUX.2 Klein、Max、Pro 和 Flex，按照快速迭代、最终成片、规模化生产或精细文字控制需求选择合适的 AI 图片模型。",
        "variants": [
          { "name": "FLUX.2 Klein 4B / 9B", "tag": "速度最快", "desc": "选择 FLUX.2 Klein 进行快速、大批量图片生成、草稿设计和原型迭代。", "bestFor": "适合草稿、批量生成与快速迭代" },
          { "name": "FLUX.2 Max", "tag": "最高质量", "desc": "选择 FLUX.2 Max 制作最终成片，获得更强的提示词还原和搜索增强能力。", "bestFor": "适合高端营销与主视觉图片" },
          { "name": "FLUX.2 Pro", "tag": "生产级", "desc": "选择 FLUX.2 Pro，在画质、生成效率与规模化输出之间取得生产级平衡。", "bestFor": "适合营销与内容生产" },
          { "name": "FLUX.2 Flex", "tag": "精细控制", "desc": "选择 FLUX.2 Flex 调节引导参数，完成文字渲染、海报设计和小细节保留。", "bestFor": "适合海报、标签与设计素材" }
        ],
        "useCasesKicker": "面向真实工作流",
        "useCasesTitle": "热门 FLUX.2 使用场景",
        "useCases": [
          { "name": "FLUX.2 商品摄影", "desc": "制作精致商品图、生活场景图和电商图片变体。" },
          { "name": "FLUX.2 营销与广告设计", "desc": "将营销概念转化为社交广告、横幅和统一的品牌视觉。" },
          { "name": "FLUX.2 海报与文字生成", "desc": "利用 FLUX.2 文字渲染能力制作更清晰的标题、标签、海报和文字图形。" },
          { "name": "FLUX.2 写实人像生成", "desc": "创作光线、造型和构图可控的照片级 AI 人像。" },
          { "name": "FLUX.2 概念艺术", "desc": "快速探索电影感环境、角色与不同视觉方向。" },
          { "name": "FLUX.2 编辑设计", "desc": "为文章、封面和演示文稿制作独特插图。" }
        ],
        "howToKicker": "简单三步",
        "howToTitle": "如何在线使用 FLUX.2 AI 图片生成器",
        "howToIntro": "在 Miral 在线使用 FLUX.2 AI 图片生成器，将详细文字提示词转化为生成图片。",
        "howToSteps": [
          { "title": "输入提示词", "desc": "清楚描述主体、构图、光线、配色、风格，以及需要出现在图片中的文字。" },
          { "title": "选择 FLUX.2 设置", "desc": "进入生成器，选择 Klein、Max、Pro 或 Flex，并根据项目选择输出尺寸。" },
          { "title": "生成并查看图片", "desc": "开始生成，检查结果并下载图片，也可以调整提示词后再次创作。" }
        ],
        "howToCta": "体验 FLUX.2 AI 图片生成器",
        "faqTitle": "关于 FLUX.2 的常见问题",
        "faqs": [
          { "q": "FLUX.2 是什么？", "a": "FLUX.2 是 Black Forest Labs 的下一代文生图 AI 模型，能将文字描述转化为高质量、细节丰富的图片。在 Miral 上，你可以直接在浏览器中用它创作艺术、设计、营销与产品视觉。" },
          { "q": "FLUX.2 有什么特别之处？", "a": "FLUX.2 在提示词连贯性、细节、真实感与文字处理方面都更进了一步。由于相比早期 FLUX 版本使用了更多算力，它非常适合对保真度与准确性要求较高的专业创作任务。" },
          { "q": "可以免费使用 FLUX.2 AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 FLUX.2 AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "如何在线使用 FLUX.2 AI 图片生成器？", "a": "输入详细的文字提示词，选择 FLUX.2 Klein、Max、Pro 或 Flex，设置图片尺寸，然后点击生成。FLUX.2 适合营销素材、商品摄影、电影感概念、社交创意和海报设计。" },
          { "q": "FLUX.2 生成一张图片需要多久？", "a": "生成时间取决于所选 FLUX.2 版本、图片尺寸和当前服务负载。Klein 面向高速迭代，而 Max、Pro 和 Flex 分别侧重不同的画质与控制能力。" },
          { "q": "有哪些优秀的 FLUX.2 提示词示例？", "a": "有效的 FLUX.2 提示词应清楚描述主体、场景、构图、光线、镜头或艺术风格、配色，以及需要出现在图片中的文字。你可以使用本页的 FLUX.2 提示词示例作为起点，再根据项目调整。" },
          { "q": "应该选择哪个 FLUX.2 模型？", "a": "快速草稿和批量生成选择 FLUX.2 Klein；最高质量成片选择 Max；规模化生产选择 Pro；文字渲染和精细控制优先选择 Flex。" },
          { "q": "FLUX.2 Max 和 Pro 有什么区别？", "a": "FLUX.2 Max 更重视最高画质、提示词还原和搜索增强生成；FLUX.2 Pro 在生产级画质、生成效率和规模化输出之间取得平衡，更适合日常创意工作流。" },
          { "q": "FLUX.2 和 Midjourney 应该怎么选？", "a": "两者没有适用于所有人的统一答案。FLUX.2 更适合重视提示词还原、文字生成、商品视觉和 API 生产流程的用户；Midjourney 则更适合偏好其艺术风格、创作流程和社区工具的创作者。" }
        ],
        "ctaTitle": "在 Miral 免费体验 FLUX.2！",
        "ctaDesc": "在上方输入你的创意，使用 FLUX.2 AI 图片生成器，并选择适合工作流的模型版本创作细节丰富的图片。"
      },
      "seedream": {
        "title": "Seedream AI 图片生成器免费在线使用 | Miral",
        "description": "免费在线使用 Seedream AI 图片生成器，体验精准提示词理解、清晰文字渲染以及细节丰富的 2K 至 4K 输出，轻松完成专业图片创作。",
        "heroHeadline": "Seedream AI 图片生成器",
        "heroIntro": "免费使用 Seedream AI 图片生成器。注册即可领取免费积分，并立即生成高质量的商品视觉、海报、人像和营销图片。",
        "eyebrow": "字节跳动 Seed · Seedream AI",
        "sectionKicker": "Seedream AI",
        "ctaTag": "Seedream · Miral",
        "badges": ["文生图", "意图理解", "2K / 3K / 4K 输出", "清晰文字渲染"],
        "previewLabel": "Seedream AI",
        "previewMeta": ["1:1", "2K / 3K / 4K", "自定义尺寸"],
        "previewTitle": "从创作意图到精准高分辨率视觉",
        "previewDesc": "通过更强的提示词控制，创作复杂构图、商品图、人像和包含文字的设计作品。",
        "keyFeaturesTitle": "使用 Seedream AI 文生图生成器创作精准视觉",
        "keyFeaturesIntro": "了解 Seedream AI 文生图在意图理解、复杂构图、高分辨率输出、真实细节和精准文字渲染方面的能力。",
        "exploreTitle": "探索 Seedream AI 模型",
        "mainFeaturesTitle": "Seedream AI 文生图主要功能",
        "seedream5Desc": "使用最新 Seedream 模型完成精准提示词理解、真实细节、文字渲染和高分辨率图片生成。",
        "seedream4Desc": "打开成熟的 Seedream 4 工作流，进行稳定的文生图创作并选择灵活的输出设置。",
        "features": [
          { "name": "深度提示词理解", "short": "理解创作意图、空间关系和详细指令。", "desc": "Seedream AI 不只是匹配提示词中的孤立词语，还会分析主体、布局、属性和视觉语境之间的关系，让复杂文字指令得到更连贯的呈现。", "demo": { "type": "table", "rows": [
            { "prompt": "正面视角的 3×3 展示架，九种不同材质和颜色的物体按要求排列，保持统一影棚光和准确空间位置。" ,image: require('@/assets/images/seedream/0217834949526105a9f949eb72c2227dac5c405ca3d9cd6c996b9_0.webp') },
            { "prompt": "手表、折叠亚麻布与陶瓷杯组成的编辑风商品摄影，三角构图，柔和晨光。"  ,image: require('@/assets/images/seedream/021783495149924e4fd4c285bd49f804239cddc30345c48dc6024_0.webp')},
            { "prompt": "电影感市场场景，前景有人群，中心主体清晰，空间层次丰富，暖光映照在湿润路面上。"  ,image: require('@/assets/images/seedream/994ae318-58d7-4ffa-98e1-ea97553ff0c0.webp')}
          ] } },
          { "name": "复杂构图控制", "short": "更连贯地处理多个主体、属性和结构化布局。", "desc": "Seedream AI 图片生成器能够遵循复杂场景中的多部分指令，在同一构图中尽量保持物体属性、位置、颜色和相互关系。", "prompt": "正面视角的编辑风场景：三个不同造型的陶瓷花瓶摆放在错落的石质展台上，最高花瓶后方放置一个红色球体，柔和侧光，间距均衡，中性影棚背景。" ,image: require('@/assets/images/seedream/021783495389730ffa263910bfaab0198f27d0234753c494fd2fa_0.webp') },
          { "name": "2K、3K 与 4K 输出", "short": "根据项目需要的细节和画面尺寸选择输出分辨率。", "desc": "Miral 上的 Seedream AI 支持选择 2K、3K 和 4K 输出，也支持自定义图片尺寸。请根据最终用途所需的画面尺寸和细节程度进行选择。", "prompt": "日出时分的未来海滨城市全景，层叠建筑、倒映水面、丰富空气透视、精细建筑细节，宽幅电影感构图。"  ,image: require('@/assets/images/seedream/0217834956211361c17ef9c173e8babb4a0658490f0169e937059_0.webp')},
          { "name": "增强的文字渲染", "short": "为海报、版式、标签和演示图形生成更清晰的文字。", "desc": "Seedream AI 将视觉推理与改进的文字创作能力结合，适合制作海报、演示图形、广告、包装概念，以及其他需要将可读文字作为画面组成部分的设计。", "demo": { "type": "table", "rows": [
            { "prompt": "极简活动海报，标题「设计未来」，粗体几何字体，白色背景，绿色网格点缀。"  ,image: require('@/assets/images/seedream/0217834957232579f663fff68d336b1dca042ed755c42d2babd5a_0.webp')},
            { "prompt": "标有「MIRAL ROAST」的高端咖啡包装，简洁风味说明，暖色纸张纹理，影棚商品摄影。" ,image: require('@/assets/images/seedream/021783495813482572fdc12977fa128088f145c73a50ff1524591_0.webp') }
          ] } },
          { "name": "精细画质与真实感", "short": "呈现可信的光影、材质、景深和商品质感。", "desc": "Seedream AI 能为商品摄影、人像、编辑视觉和电影感概念呈现精细纹理与连贯光影，适合重视画面清晰度和结构可信度的创作。", "prompt": "一张干净的编辑风商品摄影：半透明绿色香水瓶放在石灰岩上，柔和晨光，细腻阴影，高端广告质感。"  ,image: require('@/assets/images/seedream/021783495894855ad8f78454eef31552c89ebf2f2559e7d2d47a0_0.webp')}
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "Seedream AI 提示词示例：生成更好的 AI 图片",
        "showcaseIntro": "使用这些 Seedream AI 提示词示例作为起点，清楚描述主体、空间关系、文字、光线和布局，然后直接发送到生成器。",
        "variantsKicker": "分辨率指南",
        "variantsTitle": "Seedream AI 分辨率指南：2K、3K 与 4K",
        "variantsIntro": "根据迭代效率和最终素材的细节要求，选择适合的 Seedream AI 输出分辨率。",
        "variants": [
          { "name": "2K", "tag": "标准输出", "desc": "适合社交内容、日常创作和常规数字版式。", "bestFor": "适合常规数字内容" },
          { "name": "3K", "tag": "更多细节", "desc": "为营销和演示工作中的较大版式提供更多画面细节。", "bestFor": "适合营销与演示素材" },
          { "name": "4K", "tag": "最高细节", "desc": "当精细纹理、文字版式或高端交付质量更重要时使用最高预设。", "bestFor": "适合最终广告与高分辨率成片" }
        ],
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "Seedream AI 热门使用场景",
        "useCases": [
          { "name": "Seedream AI 商品摄影", "desc": "制作精致商品图、生活场景图和电商图片概念。" },
          { "name": "Seedream AI 营销设计", "desc": "将结构化营销创意转化为社交广告、横幅和品牌视觉。" },
          { "name": "Seedream AI 海报与文字", "desc": "制作海报概念、演示图形、标签和文字版式。" },
          { "name": "Seedream AI 复杂构图", "desc": "在连贯的视觉结构中安排多个主体及其指定属性。" },
          { "name": "Seedream AI 概念艺术", "desc": "探索电影感环境、角色和细致视觉方向。" },
          { "name": "Seedream AI 编辑视觉", "desc": "制作封面、插图、信息图和适合演示的视觉素材。" }
        ],
        "howToKicker": "简单三步",
        "howToTitle": "如何免费在线使用 Seedream AI 图片生成器",
        "howToIntro": "注册即可领取免费积分并在线使用 Seedream AI 图片生成器，通过清晰提示词和项目所需分辨率创作图片。",
        "howToSteps": [
          { "title": "输入创作意图", "desc": "尽可能清楚地描述主体、空间关系、构图、光线、风格和需要出现的文字。" },
          { "title": "选择分辨率和尺寸", "desc": "进入生成器，根据最终用途选择 2K、3K、4K 或支持的自定义尺寸。" },
          { "title": "生成并检查结果", "desc": "开始生成，检查构图和细节，然后下载结果或继续调整提示词。" }
        ],
        "howToCta": "免费使用 Seedream AI 图片生成器",
        "faqTitle": "关于 Seedream AI 的常见问题",
        "faqs": [
          { "q": "Seedream AI 图片生成器是什么？", "a": "Seedream AI 是字节跳动 Seed 团队推出的智能图像创作模型。在 Miral 上，它可以把详细文字提示词转化为适用于设计、营销、商品概念、海报和编辑视觉的高分辨率图片。" },
          { "q": "Seedream AI 有什么不同？", "a": "Seedream AI 重点提升了意图理解、视觉推理、复杂指令遵循、精准构图和文字创作，而不是简单追求更高分辨率或更快生成速度。" },
          { "q": "可以免费使用 Seedream AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 Seedream AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "如何在线使用 Seedream AI 图片生成器？", "a": "输入详细文字提示词，选择 2K、3K 或 4K 输出，也可以设置支持的自定义尺寸，然后点击生成。为了获得更好结果，请清楚描述主体、空间关系、属性、光线、文字和布局。" },
          { "q": "Seedream AI 支持 2K、3K 和 4K 图片吗？", "a": "支持。Miral 为 Seedream AI 提供 2K、3K 和 4K 分辨率预设，以及适用于不同宽高比和交付需求的自定义尺寸。" },
          { "q": "有哪些优秀的 Seedream AI 提示词示例？", "a": "优秀的 Seedream AI 提示词会明确描述主体、物体之间的关系、构图、光线、配色、风格和所需文字。你可以使用本页示例作为起点，并明确写出每项视觉要求。" },
          { "q": "应该选择哪个 Seedream AI 分辨率？", "a": "常规数字内容选择 2K；营销或演示版式需要更多细节时选择 3K；大型广告、海报和高端设计素材需要最大细节时选择 4K。" },
          { "q": "Seedream AI 和 Midjourney 应该怎么选？", "a": "Seedream AI 更适合结构化提示词、复杂构图、包含文字的版式，以及在 Miral 中选择高分辨率输出。Midjourney 更适合偏好其艺术风格、创作流程和社区工具的创作者。" }
        ],
        "ctaTitle": "在 Miral 免费使用 Seedream AI！",
        "ctaDesc": "注册即可领取免费积分。描述你的创意，选择适合的分辨率，并使用 Seedream AI 图片生成器创作精准、高分辨率的视觉。"
      },
      "gptImage": {
        "title": "GPT Image AI 图片生成器免费在线使用 | Miral",
        "description": "在 Miral AI 免费在线使用 GPT Image AI 图片生成器，通过 GPT-Image-1.5 将文字提示词转为高质量图片，可选择实用尺寸及不同画质，适合海报、商品图和人像创作。",
        "heroHeadline": "GPT Image AI 图片生成器",
        "heroIntro": "在 Miral AI 免费使用 GPT Image AI 图片生成器。注册即可领取免费积分，并使用 GPT-Image-1.5 创作高质量商品图、海报、人像和营销视觉。",
        "eyebrow": "OpenAI · GPT-Image-1.5",
        "sectionKicker": "GPT Image",
        "ctaTag": "GPT Image · Miral",
        "badges": ["文生图", "可选画质", "横版 / 竖版 / 正方形", "精准提示词理解"],
        "previewLabel": "GPT-Image-1.5",
        "previewMeta": ["1024 × 1024", "1536 × 1024", "1024 × 1536"],
        "previewTitle": "从文字创意到精致、实用的 AI 图片",
        "previewDesc": "通过清晰提示词和可选画质，创作商品视觉、海报、人像与品牌内容。",
        "keyFeaturesTitle": "使用 GPT Image AI 图片生成器创作高质量视觉",
        "keyFeaturesIntro": "了解 GPT-Image-1.5 在提示词理解、画质控制、常用图片尺寸和专业视觉创作方面的能力。",
        "features": [
          { "name": "自然语言与多主体提示词", "short": "使用自然语言描述主体、构图、光线、风格和画面关系。", "desc": "GPT Image AI 图片生成器支持自然语言提示词，能够处理包含多个主体、属性和构图要求的描述。你可以从简单提示词开始，也可以明确每个主体的位置、颜色和关系，生成结构更连贯的多主体图片。", "demo": { "type": "table", "rows": [
            { "prompt": "编辑风商品摄影：透明香水瓶放在浅色石材底座上，柔和晨光从左侧照入，背景干净，浅景深，高端品牌质感。", "image": require('@/assets/images/gptImage/perfume-editorial.webp') },
            { "prompt": "雨夜城市街道，前景三名行人撑着不同颜色的伞，远处有轨电车驶过，霓虹倒映在湿润路面，电影感宽幅构图。", "image": require('@/assets/images/gptImage/rainy-city-tram.webp') }
          ] } },
          { "name": "GPT-Image-1.5 画质控制", "short": "根据速度和细节需求选择自动、低、中或高画质。", "desc": "GPT-Image-1.5 提供 auto、low、medium 和 high 四档画质。快速探索时可选择较低画质，最终商品图、海报或营销素材可选择更高画质。", "prompt": "高画质食品广告：黑色背景上的草莓蛋糕，奶油纹理清晰，柔和轮廓光，细腻食物摄影，商业广告构图。", "image": require('@/assets/images/gptImage/strawberry-cake.webp') },
          { "name": "三种实用图片尺寸", "short": "支持正方形、横版和竖版输出。", "desc": "可选择 1024×1024、1536×1024 或 1024×1536，分别适合社交配图、横幅与演示视觉，以及竖版海报和移动端内容。", "prompt": "1024×1536 竖版旅行海报，海边悬崖与灯塔，清晨薄雾，顶部预留标题空间，现代编辑版式。", "image": require('@/assets/images/gptImage/lighthouse-travel-poster.webp') },
          { "name": "清晰文字与版式创作", "short": "为海报、标签和品牌视觉生成包含文字的设计。", "desc": "通过明确写出文字内容、位置、字体氛围和版式关系，GPT Image 可用于探索海报、包装、活动视觉和带标题的营销图片。", "demo": { "type": "table", "rows": [
            { "prompt": "极简科技活动海报，标题「CREATE THE FUTURE」，粗体无衬线字体，深蓝背景，绿色几何网格，标题清晰居中。", "image": require('@/assets/images/gptImage/create-the-future.webp') },
            { "prompt": "高端咖啡包装概念，包装正面文字「MIRAL ROAST」，暖棕色纸张纹理，简洁标签，影棚商品摄影。", "image": require('@/assets/images/gptImage/miral-roast-package.webp') }
          ] } },
          { "name": "细节与真实感", "short": "呈现可信的材质、光影、人物和商品细节。", "desc": "GPT Image 适合生成商品摄影、人像、室内场景和编辑视觉，通过清晰描述材质、镜头、光线与景深获得更可信的画面。", "prompt": "自然窗光下的陶艺师近景人像，真实皮肤纹理，双手带有陶土粉尘，工作室背景，浅景深，温暖编辑摄影。", "image": require('@/assets/images/gptImage/ceramic-artist.webp') }
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "GPT Image 提示词示例：生成更好的 AI 图片",
        "showcaseIntro": "使用这些 GPT Image 提示词作为起点，清楚描述主体、构图、光线、风格、材质和需要出现的文字。",
        "variantsKicker": "版本指南",
        "variantsTitle": "GPT-Image-1.5 与 GPT-Image-1 对比",
        "variantsIntro": "根据是否需要画质控制选择 GPT Image 版本；两个版本都支持常用的正方形、横版和竖版尺寸。",
        "variants": [
          { "name": "GPT-Image-1.5", "tag": "推荐", "desc": "支持 1024×1024、1536×1024、1024×1536，并提供 auto、low、medium、high 画质选项。", "bestFor": "适合需要画质控制的日常与专业创作" },
          { "name": "GPT-Image-1", "tag": "经典版本", "desc": "支持相同的三种常用图片尺寸，界面参数更精简。", "bestFor": "适合简单直接的通用文生图" }
        ],
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "GPT Image 热门使用场景",
        "useCases": [
          { "name": "GPT Image 商品摄影与产品模型图", "desc": "生成商品主图、生活场景图、产品模型图和电商视觉概念。" },
          { "name": "GPT Image 电商详情页图片", "desc": "探索商品详情页、产品卖点图、包装展示和广告素材的视觉方向。" },
          { "name": "GPT Image 营销与社交媒体广告", "desc": "创作社交媒体广告、活动横幅、邮件横幅和品牌营销视觉。" },
          { "name": "GPT Image UI/UX 与网站布局", "desc": "生成应用界面、网站布局、落地页和产品展示页面的视觉概念。" },
          { "name": "GPT Image 信息图与视觉报告", "desc": "探索信息图、视觉报告和演示图形的版式概念；正式使用前应核对文字与数据。" },
          { "name": "GPT Image 海报与产品包装", "desc": "探索包含标题、标签和版式要求的海报、产品标签与包装设计。" },
          { "name": "GPT Image 书籍封面与博客配图", "desc": "创作书籍封面、文章插图、博客头图和出版视觉概念。" },
          { "name": "GPT Image 人像生成", "desc": "创作光线、背景和造型可控的编辑风人像。" },
          { "name": "GPT Image 游戏角色概念", "desc": "快速探索游戏角色、服装、道具和不同艺术方向。" },
          { "name": "GPT Image 游戏场景与环境概念", "desc": "生成游戏环境、电影感场景和世界观视觉概念，用于前期创意探索。" },
          { "name": "GPT Image 社交内容", "desc": "为不同平台生成正方形、横版和竖版图片。" }
        ],
        "howToKicker": "简单三步",
        "howToTitle": "如何免费在线使用 GPT Image AI 图片生成器",
        "howToIntro": "注册即可领取免费积分，并在 Miral 在线使用 GPT Image AI 图片生成器。",
        "howToSteps": [
          { "title": "输入详细提示词", "desc": "描述主体、场景、构图、光线、风格、材质和需要出现的文字。" },
          { "title": "选择尺寸和画质", "desc": "选择正方形、横版或竖版尺寸，并根据需要设置 GPT-Image-1.5 画质。" },
          { "title": "生成并查看结果", "desc": "开始生成，查看图片并下载结果，也可以调整提示词后继续创作。" }
        ],
        "howToCta": "免费使用 GPT Image AI 图片生成器",
        "faqTitle": "关于 GPT Image 的常见问题",
        "faqs": [
          { "q": "GPT Image AI 图片生成器是什么？", "a": "GPT Image 是 OpenAI 的通用文生图模型系列。在 Miral 上，GPT Image AI 图片生成器可以将文字提示词转化为适用于设计、营销、商品概念、海报和社交内容的高质量图片。" },
          { "q": "可以免费使用 GPT Image AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 GPT Image AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "如何在线使用 GPT Image AI 图片生成器？", "a": "输入详细提示词，选择 1024×1024、1536×1024 或 1024×1536。使用 GPT-Image-1.5 时还可以选择 auto、low、medium 或 high 画质，然后点击生成。" },
          { "q": "GPT-Image-1.5 和 GPT-Image-1 有什么区别？", "a": "两个版本都支持三种常用图片尺寸。Miral 上的 GPT-Image-1.5 额外提供 auto、low、medium 和 high 画质控制；GPT-Image-1 的参数更精简。" },
          { "q": "GPT Image 支持哪些图片尺寸？", "a": "Miral 上的 GPT-Image-1 和 GPT-Image-1.5 均支持 1024×1024 正方形、1536×1024 横版和 1024×1536 竖版图片。" },
          { "q": "GPT Image 的画质应该怎么选？", "a": "快速测试提示词时可以选择 low 或 medium；需要最终商品图、海报或营销素材时可以选择 high；不确定时选择 auto。画质选项适用于 GPT-Image-1.5。" },
          { "q": "有哪些优秀的 GPT Image 提示词示例？", "a": "有效的 GPT Image 提示词应明确描述主体、场景、构图、光线、镜头、材质、风格和所需文字。可以使用本页示例作为起点，再根据项目调整。" },
          { "q": "使用 GPT Image 需要提示词工程经验吗？", "a": "不需要。你可以先用简单的自然语言提示词描述想要的图片，再逐步补充主体位置、构图、光线、颜色、材质和文字要求。更清晰的描述通常有助于生成更贴近创作意图的结果。" },
          { "q": "GPT Image 适合哪些专业使用场景？", "a": "GPT Image 可用于 UI/UX 界面概念、网站布局、电商详情页、产品模型图、信息图版式、书籍封面、博客配图、邮件横幅，以及游戏角色和环境概念。生成内容正式使用前，应检查文字、数据、品牌元素和结构细节。" },
          { "q": "GPT Image 和 Midjourney 应该怎么选？", "a": "GPT Image 适合重视清晰提示词控制、常用尺寸和浏览器内直接生成的用户；Midjourney 更适合偏好其艺术风格、参考图工作流和创作方式的用户。" }
        ],
        "ctaTitle": "在 Miral 免费使用 GPT Image！",
        "ctaDesc": "注册即可领取免费积分。描述你的创意，选择尺寸和画质，并使用 GPT Image AI 图片生成器创作高质量视觉。"
      },
      "qwenImage2Pro": {
        "title": "Qwen Image 2.0 Pro AI 图片生成器免费在线使用 | Miral",
        "description": "免费在线使用 Qwen Image 2.0 Pro AI 图片生成器，支持负向提示词、提示词增强和灵活宽高比，每次可生成一至四张高质量图片。",
        "heroHeadline": "Qwen Image 2.0 Pro AI 图片生成器",
        "heroIntro": "在 Miral AI 免费使用 Qwen Image 2.0 Pro AI 图片生成器。注册即可领取免费积分，并通过负向提示词、提示词增强和灵活比例快速生成高质量图片。",
        "eyebrow": "阿里巴巴通义千问 · Qwen-Image-2.0-Pro",
        "sectionKicker": "Qwen Image 2.0 Pro",
        "ctaTag": "Qwen Image 2.0 Pro · Miral",
        "badges": ["文生图", "负向提示词", "提示词增强", "单次 1-4 张", "灵活比例"],
        "previewLabel": "Qwen Image 2.0 Pro",
        "previewMeta": ["1:1", "2048 × 2048", "单次最多 1-4 张"],
        "previewTitle": "从带排除项的精准提示词到精致视觉",
        "previewDesc": "把正向提示词与负向提示词、提示词增强结合，一次生成多张贴合需求的图片。",
        "keyFeaturesTitle": "使用 Qwen Image 2.0 Pro 文生图生成器创作精准视觉",
        "keyFeaturesIntro": "了解 Qwen Image 2.0 Pro AI 图片生成器在精细控制、负向提示词、提示词增强、批量输出和灵活比例方面的核心能力。",
        "mainFeaturesTitle": "Qwen Image 2.0 Pro 主要能力",
        "promptLabel": "正向提示词",
        "negativePromptLabel": "负向提示词",
        "shortPromptLabel": "简短提示词",
        "negativePromptFallback": "低清晰度、细节变形、构图杂乱",
        "features": [
          { "name": "负向提示词控制", "short": "描述要排除的内容，得到更干净、更贴合的结果。", "desc": "Qwen Image 2.0 Pro AI 图片生成器支持专门的负向提示词，你可以告诉模型要避免什么，例如低清晰度、畸形手指或杂乱构图。这让你对最终画面拥有更精细的控制力，减少反复重抽的需要。", "demo": { "type": "table", "rows": [
            { "prompt": "高端商品摄影：玻璃护肤瓶放在湿润的石头上，柔和晨光，干净背景。（负向：杂乱背景，低分辨率，畸形反射。）",image: require('@/assets/images/qwenImage2Pro/32ccbe94-155c-4873-9e85-602969ecb6e4.webp') },
            { "prompt": "一位年轻女性的秋日光下人像，自然皮肤纹理，浅景深。（负向：过度磨皮，蜡像感，过饱和色彩。）" ,image: require('@/assets/images/qwenImage2Pro/b4c88e78-6c88-4db5-9ea2-a6041609a380.webp')}
          ] } },
          { "name": "提示词增强", "short": "可选地将简短提示词扩展为更丰富的细节。", "desc": "开启提示词增强后，Qwen Image 2.0 Pro 会在生成前自动为简短提示词补充额外细节。这能让非专业的提示词也能生成更完整、生动的图片，无需手动重写。", "demo": { "type": "table", "rows": [
            { "prompt": "雨中窗边的温馨阅读角落。" ,image: require('@/assets/images/qwenImage2Pro/f9f87426-60d9-4f97-a372-7cb55b5bf7de.webp')},
            { "prompt": "雨夜窗前的木质书桌，一盏暖色台灯照亮摊开的书和热茶，窗上布满雨滴，室内温暖宁静。" ,image: require('@/assets/images/qwenImage2Pro/qwen-enhance-rainy-desk.webp')}
          ] } },
          { "name": "单次生成 1-4 张", "short": "一次生成多个变体。", "desc": "Qwen Image 2.0 Pro 单次请求最多可生成 4 张图片，让你可以并排对比同一概念、角度或风格的变体，挑选最满意的一张。这能加快营销与商品视觉的创意探索。", "prompt": "极简陶瓷台灯放在胡桃木边桌上，温暖的夜间室内环境，奶油色墙面，柔和阴影，北欧风商品摄影。",image: require('@/assets/images/qwenImage2Pro/c4581d5b-f28a-4ae5-8bb2-b110c30d954c.webp') },
          { "name": "灵活的图片比例", "short": "选择横版、竖版、正方形或自定义尺寸。", "desc": "可从现成比例中选择，如 2688×1536 横版、1536×2688 竖版、2048×2048 正方形，以及 2368×1728 / 1728×2368，也可输入 512×512 到 2048×2048 之间的自定义尺寸。这让 Qwen Image 2.0 Pro 文生图生成器同时适合横幅、海报、社交配图和方形缩略图。", "prompt": "一张电影感宽幅风景：金色时刻的海岸悬崖，戏剧性云层，细腻岩石纹理，2688×1536。" ,image: require('@/assets/images/qwenImage2Pro/e2bd1179-48db-4ce6-a713-2a0a62dd5dd5.webp')},
          { "name": "精细的细节与真实感", "short": "呈现逼真的纹理、光影与景深。", "desc": "Qwen Image 2.0 Pro 能生成细腻的纹理、真实的光影与自然的景深，非常适合商品摄影、人像和编辑类视觉等对真实度要求较高的场景。", "prompt": "一位年长陶艺师在阳光照进的工作室中的编辑风近景人像，自然皮肤纹理，双手沾有陶土粉末，温暖窗光，浅景深。" ,image: require('@/assets/images/qwenImage2Pro/3204b3e8-c5ca-40b4-afa9-a65f6dd806e2.webp')}
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "Qwen Image 2.0 Pro 提示词示例：生成更好的 AI 图片",
        "showcaseIntro": "把这些 Qwen Image 2.0 Pro 提示词示例作为起点。为每条正向提示词搭配负向提示词以排除不想要的元素，再直接发送到生成器。",
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "Qwen Image 2.0 Pro 热门使用场景",
        "useCases": [
          { "name": "Qwen Image 2.0 Pro 商品摄影", "desc": "用负向提示词排除杂物，在受控背景下创作干净的商品图。" },
          { "name": "Qwen Image 2.0 Pro 营销设计", "desc": "在多种比例下生成营销概念、社交广告和横幅。" },
          { "name": "Qwen Image 2.0 Pro 海报与文字", "desc": "制作海报版式和包含清晰标题、标签的文字设计。" },
          { "name": "Qwen Image 2.0 Pro 人像生成", "desc": "用负向提示词避免瑕疵，生成带自然皮肤纹理的细节人像。" },
          { "name": "Qwen Image 2.0 Pro 概念艺术", "desc": "单次生成 1-4 张变体，快速探索角色、环境与视觉方向。" },
          { "name": "Qwen Image 2.0 Pro 电商视觉", "desc": "一次生成即可产出多张商品详情页与广告的图片变体。" }
        ],
        "howToKicker": "简单三步",
        "howToTitle": "如何在线使用 Qwen Image 2.0 Pro AI 图片生成器",
        "howToIntro": "在 Miral 在线使用 Qwen Image 2.0 Pro AI 图片生成器，结合正向提示词、负向提示词和灵活输出控制。",
        "howToSteps": [
          { "title": "输入主要提示词", "desc": "描述想要的主体、场景、构图、光线、风格和视觉细节。" },
          { "title": "配置生成控制", "desc": "按需添加负向提示词、开启提示词增强、选择尺寸，并设置生成一到四张图片。" },
          { "title": "生成并比较结果", "desc": "开始生成，对比返回的图片变体，并下载最符合创作意图的结果。" }
        ],
        "howToCta": "体验 Qwen Image 2.0 Pro AI 图片生成器",
        "faqTitle": "关于 Qwen Image 2.0 Pro 的常见问题",
        "faqs": [
          { "q": "Qwen Image 2.0 Pro AI 图片生成器是什么？", "a": "Qwen Image 2.0 Pro 是阿里巴巴通义千问的文生图模型。Qwen Image 2.0 Pro AI 图片生成器能将文字提示词转化为高质量、细节丰富的图片，在 Miral 上你可以直接在浏览器中用它创作艺术、设计、营销与产品视觉。" },
          { "q": "Qwen Image 2.0 Pro 有什么特别之处？", "a": "Qwen Image 2.0 Pro 的亮点在于精准控制：专门的负向提示词用于排除不想要的元素、可选的提示词增强用于丰富简短提示词、单次生成 1-4 张的能力，以及灵活的比例。这些优势让它非常适合商品摄影、营销和电商视觉。" },
          { "q": "可以免费使用 Qwen Image 2.0 Pro AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 Qwen Image 2.0 Pro AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "如何在线使用 Qwen Image 2.0 Pro AI 图片生成器？", "a": "输入详细的文字提示词，可选地添加负向提示词描述要避免的内容，按需开启提示词增强，选择比例或自定义尺寸，设置生成张数（1-4），然后点击生成。Qwen Image 2.0 Pro 适合营销素材、商品摄影、人像和海报设计。" },
          { "q": "Qwen Image 2.0 Pro 的负向提示词是什么？", "a": "负向提示词用于描述你不希望出现在图片中的元素，例如低清晰度、畸形手指或杂乱背景。Qwen Image 2.0 Pro 会据此引导生成远离这些结果，让你得到更干净、更贴合需求的图片，减少反复重抽。" },
          { "q": "Qwen Image 2.0 Pro 一次能生成几张图片？", "a": "Qwen Image 2.0 Pro 单次请求最多可生成 4 张图片（n = 1 到 4），你可以对比同一概念、角度或风格的变体，挑选最满意的一张。" },
          { "q": "Qwen Image 2.0 Pro 支持哪些尺寸和比例？", "a": "在 Miral 上，Qwen Image 2.0 Pro 提供现成比例，如 2688×1536、1536×2688、2048×2048、2368×1728 和 1728×2368，以及 512×512 到 2048×2048 之间的自定义尺寸，覆盖横版、竖版和正方形输出，适合横幅、海报、社交配图和缩略图。" },
          { "q": "有哪些优秀的 Qwen Image 2.0 Pro 提示词示例？", "a": "有效的 Qwen Image 2.0 Pro 提示词应清楚描述主体、场景、构图、光线和风格，并为正向提示词搭配负向提示词以排除不想要的细节。你可以使用本页的 Qwen Image 2.0 Pro 提示词示例作为起点，再根据项目调整。" },
          { "q": "Qwen Image 2.0 Pro 和 Midjourney 应该怎么选？", "a": "两者没有适用于所有人的统一答案。当你需要在 Miral 浏览器内的生成器中使用明确的负向提示词、提示词增强、单次 1-4 张和灵活比例时，Qwen Image 2.0 Pro 是更合适的选择；Midjourney 则更适合偏好其艺术风格、创作流程和社区工具的创作者。" }
        ],
        "ctaTitle": "在 Miral 免费体验 Qwen Image 2.0 Pro！",
        "ctaDesc": "在上方输入你的创意，使用 Qwen Image 2.0 Pro AI 图片生成器和可选控制项创作精准的图片变体。"
      },
      "stableDiffusion": {
        "title": "Stable Diffusion 3.5 AI 图片生成器在线版 | Miral",
        "description": "在线使用 Stable Diffusion 3.5 AI 图片生成器，支持负向提示词、预设宽高比以及 512 至 2048 像素自定义尺寸，灵活创作高质量图片。",
        "heroHeadline": "Stable Diffusion 3.5 AI 图片生成器",
        "heroIntro": "在 Miral AI 免费使用 Stable Diffusion 3.5 AI 图片生成器。注册即可领取免费积分，并通过详细提示词、负向提示词和灵活尺寸快速生成高质量图片。",
        "eyebrow": "Stability AI · Stable Diffusion 3.5",
        "sectionKicker": "Stable Diffusion 3.5",
        "ctaTag": "Stable Diffusion 3.5 · Miral",
        "badges": ["文生图", "负向提示词", "灵活比例", "自定义尺寸"],
        "previewLabel": "Stable Diffusion 3.5",
        "previewMeta": ["1:1", "512 – 2048", "64 的倍数"],
        "previewTitle": "从详细提示词到可控的精致图片",
        "previewDesc": "把正向提示词与负向提示词结合，并选择合适的比例，引导 Stable Diffusion 3.5 生成干净、贴合需求的视觉。",
        "keyFeaturesTitle": "使用 Stable Diffusion 3.5 文生图生成器创作可控视觉",
        "keyFeaturesIntro": "了解 Stable Diffusion 3.5 AI 图片生成器在负向提示词、灵活比例、自定义尺寸和提示词理解方面的核心能力。",
        "exploreTitle": "探索更多 AI 图片模型",
        "mainFeaturesTitle": "Stable Diffusion 3.5 主要功能",
        "generatedImageLabel": "生成的图片",
        "versionLabel": "控制项",
        "featureLabel": "作用",
        "useCaseLabel": "适合场景",
        "variantsTitle": "Stable Diffusion 3.5 输出控制指南",
        "variantsIntro": "根据最终版式需求，将 Stable Diffusion 3.5 与预设比例或精确自定义尺寸结合使用。",
        "variants": [
          { "name": "Stable Diffusion 3.5", "desc": "支持正向和负向提示词控制的细节文生图模型。", "bestFor": "商品视觉、人像、概念美术和营销图片。" },
          { "name": "预设宽高比", "desc": "提供常用横版、竖版和正方形输出尺寸。", "bestFor": "社交配图、横幅、海报和缩略图。" },
          { "name": "自定义图片尺寸", "desc": "输入 512 至 2048、步进为 64 的精确宽度和高度。", "bestFor": "需要匹配特定版位或精确像素尺寸的项目。" }
        ],
        "controlsTitle": "选择合适的提示词控制和图片尺寸",
        "controlsIntro": "使用负向提示词减少不需要的细节，再根据发布渠道选择预设比例或输入自定义尺寸。",
        "galleryTitle": "更多 Stable Diffusion 3.5 图片示例",
        "discussionTitle": "Stable Diffusion 3.5 常见问题",
        "communityTitle": "Stable Diffusion 3.5 热门创作场景",
        "tutorialPrompt": "编辑风商品摄影：雕塑感陶瓷音箱置于浅色石材上，柔和晨间窗光，真实材质，平衡构图，细腻阴影，干净背景。",
        "qualityBenefits": [
          "通过负向提示词减少杂乱、结构变形和不需要的视觉风格。",
          "遵循对主体、构图、光线、材质和氛围的分层描述。",
          "使用预设比例或精确自定义尺寸生成横版、竖版和正方形图片。"
        ],
        "features": [
          { "name": "负向提示词控制", "short": "描述要排除的内容，获得更干净、贴合需求的结果。", "desc": "Stable Diffusion 3.5 AI 图片生成器支持专门的负向提示词，你可以告诉模型要避免的内容，例如清晰度不足、手部变形或背景杂乱。这让你对最终图片有更精细的控制，并减少反复重抽的次数。", "demo": { "type": "table", "rows": [
            { "prompt": "高端商品图，磨砂黑陶瓷花瓶置于大理石底座上，柔和的影棚光，干净背景。（负向：杂乱背景、低分辨率、变形反光。）", "image": require('@/assets/images/stableDiffusion/1783501013638.webp') },
            { "prompt": "年轻男性肖像，柔和窗光，自然皮肤纹理，浅景深。（负向：过度磨皮、蜡像感、过饱和色彩。）", "image": require('@/assets/images/stableDiffusion/1783501332038.webp') }
          ] } },
          { "name": "灵活比例", "short": "选择横版、竖版、正方形或自定义尺寸。", "desc": "从现成比例中选择，如 1024×1024、1280×1280、896×1536、1536×896、768×1344、1344×768、1024×1536 和 1536×1536，或输入 512×512 到 2048×2048 之间的自定义尺寸。这让 Stable Diffusion 3.5 文生图生成器同样适合横幅、海报、社交配图和正方形缩略图。", "prompt": "电影感海岸悬崖的宽幅风光，金色时刻，戏剧性的云层，细腻的岩石质感，1536×896。", "image": require('@/assets/images/stableDiffusion/1783501396803.webp') },
          { "name": "自定义图片尺寸", "short": "设置精确的像素尺寸以获得精准输出。", "desc": "当现成比例不合适时，切换到自定义尺寸，输入 512 到 2048 之间、步进为 64 的任意宽高。这让你直接匹配特定版式、横幅位或打印比例，无需手动裁剪。", "prompt": "极简海报背景，居中的几何构图，深蓝渐变，细微颗粒，1280×1280。", "image": require('@/assets/images/stableDiffusion/0217835023294345bd2f0b9e6315ce45b86fb4e22ec7496156d5f_0.webp') },
          { "name": "提示词细节理解", "short": "遵循对主体、光线和风格的分层描述。", "desc": "Stable Diffusion 3.5 会读取分层文字指令，并渲染你所描述的主体、场景、光线和氛围。把清晰的正向提示词与负向提示词结合，能在更少的尝试次数内把结果推向你的意图。", "demo": { "type": "table", "rows": [
            { "prompt": "商品编辑图，手表旁是折叠的亚麻布和一只陶瓷杯，平衡的三角构图，柔和晨光。", "image": require('@/assets/images/stableDiffusion/1783501741652.webp') },
            { "prompt": "雨窗旁温馨的阅读角，温暖台灯光，堆叠的书本，质感毛毯，电影感氛围。", "image": require('@/assets/images/stableDiffusion/1783501817217.webp') }
          ] } },
          { "name": "细腻细节与真实感", "short": "渲染可信的光线、材质和景深。", "desc": "Stable Diffusion 3.5 能产出细腻的纹理、真实的光线和自然的景深，让 Stable Diffusion 3.5 AI 图片生成器适合商品摄影、人像、概念美术和编辑视觉等对真实感有要求的场景。", "prompt": "老年陶艺师的编辑特写肖像，阳光充沛的工作室，自然皮肤纹理，手上的陶土粉尘，温暖窗光，浅景深。", "image": require('@/assets/images/stableDiffusion/021783502374347ebd7c24e3cae4a4b683f52566c3e30e2cb26b5_0.webp') }
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "Stable Diffusion 3.5 提示词示例，助你生成更好的 AI 图片",
        "showcaseIntro": "以这些 Stable Diffusion 3.5 提示词示例为起点。清楚描述主体、构图、光线和风格，并为每条提示词搭配负向提示词，再直接发送到生成器。",
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "Stable Diffusion 3.5 常见使用场景",
        "useCases": [
          { "name": "Stable Diffusion 3.5 商品摄影", "desc": "用负向提示词排除杂乱，创建背景受控的干净商品图。" },
          { "name": "Stable Diffusion 3.5 营销", "desc": "在多种比例下生成活动概念、社交广告和横幅。" },
          { "name": "Stable Diffusion 3.5 海报与版式", "desc": "用自定义像素尺寸产出海报背景和可直接排版的视觉。" },
          { "name": "Stable Diffusion 3.5 人像", "desc": "生成带有自然皮肤纹理的细节人像，并用负向提示词避免瑕疵。" },
          { "name": "Stable Diffusion 3.5 概念美术", "desc": "用分层提示词探索角色、环境和视觉方向。" },
          { "name": "Stable Diffusion 3.5 社交内容", "desc": "为不同社交平台创建正方形、竖版和横版图片。" }
        ],
        "howToKicker": "三个简单步骤",
        "howToTitle": "如何在线使用 Stable Diffusion 3.5 AI 图片生成器",
        "howToIntro": "在 Miral 上在线使用 Stable Diffusion 3.5 AI 图片生成器，搭配清晰的提示词、负向提示词以及项目所需的比例。",
        "howToSteps": [
          { "title": "输入主要提示词", "desc": "描述想要的主体、场景、构图、光线、风格和视觉细节。" },
          { "title": "配置生成控制项", "desc": "按需添加负向提示词，再选择现成比例或输入自定义尺寸。" },
          { "title": "生成并查看", "desc": "开始生成，查看结果，下载图片或调整提示词再生成一次。" }
        ],
        "howToCta": "体验 Stable Diffusion 3.5 AI 图片生成器",
        "faqTitle": "关于 Stable Diffusion 3.5 的常见问题",
        "faqs": [
          { "q": "什么是 Stable Diffusion 3.5 AI 图片生成器？", "a": "Stable Diffusion 3.5 是 Stability AI 推出的文生图模型。Stable Diffusion 3.5 AI 图片生成器可将文字提示词转化为细节丰富的图片，在 Miral 上可用于美术、设计、营销和商品视觉创作，全部在浏览器内完成。" },
          { "q": "Stable Diffusion 3.5 有什么用处？", "a": "Stable Diffusion 3.5 通过专门的负向提示词、面向常见版式的现成比例，以及 512 到 2048 的自定义尺寸提供精细控制。这些优势使其非常适合商品摄影、营销视觉、人像和概念美术。" },
          { "q": "可以免费使用 Stable Diffusion 3.5 AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 Stable Diffusion 3.5 AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "如何在线使用 Stable Diffusion 3.5 AI 图片生成器？", "a": "输入详细的文字提示词，按需添加描述要避免内容的负向提示词，选择现成比例或输入自定义尺寸，然后点击生成。Stable Diffusion 3.5 适合营销素材、商品摄影、人像和海报版式。" },
          { "q": "Stable Diffusion 3.5 中的负向提示词是什么？", "a": "负向提示词描述你不希望出现在图片中的元素，例如清晰度不足、手部变形或背景杂乱。Stable Diffusion 3.5 会据此引导生成避开这些结果，让图片更干净、更贴合需求，减少反复重抽。" },
          { "q": "Stable Diffusion 3.5 支持哪些尺寸和比例？", "a": "在 Miral 上，Stable Diffusion 3.5 提供现成比例，如 1024×1024、1280×1280、896×1536、1536×896、768×1344、1344×768、1024×1536 和 1536×1536，以及 512×512 到 2048×2048、步进为 64 的自定义尺寸，覆盖横版、竖版和正方形输出，适合横幅、海报、社交配图和缩略图。" },
          { "q": "有哪些优秀的 Stable Diffusion 3.5 提示词示例？", "a": "有效的 Stable Diffusion 3.5 提示词应清楚描述主体、场景、构图、光线和风格，并为正向提示词搭配负向提示词以排除不想要的细节。你可以使用本页的 Stable Diffusion 3.5 提示词示例作为起点，再根据项目调整。" },
          { "q": "Stable Diffusion 3.5 和 Midjourney 应该怎么选？", "a": "两者没有适用于所有人的统一答案。当你需要在 Miral 浏览器内的生成器中使用明确的负向提示词、现成比例和自定义像素尺寸时，Stable Diffusion 3.5 是更合适的选择；Midjourney 则更适合偏好其艺术风格、创作流程和社区工具的创作者。" }
        ],
        "ctaTitle": "在 Miral 免费体验 Stable Diffusion 3.5！",
        "ctaDesc": "在上方输入你的创意，使用 Stable Diffusion 3.5 AI 图片生成器，搭配负向提示词和灵活尺寸创作可控的视觉。"
      },
      "zImageTurbo": {
        "title": "Z Image Turbo AI 图片生成器免费在线使用 | Miral",
        "description": "免费在线使用 Z Image Turbo AI 图片生成器，支持提示词扩展、灵活宽高比、自定义图片尺寸及随机种子控制，快速生成细节丰富的高质量图片。",
        "heroHeadline": "Z Image Turbo AI 图片生成器",
        "heroIntro": "在 Miral AI 免费使用 Z Image Turbo AI 图片生成器。注册即可领取免费积分，并通过提示词扩展、灵活比例和种子控制快速生成高质量图片。",
        "eyebrow": "Z Image Turbo",
        "sectionKicker": "Z Image Turbo",
        "ctaTag": "Z Image Turbo · Miral",
        "badges": ["文生图", "提示词扩展", "灵活比例", "自定义尺寸", "种子控制"],
        "previewLabel": "Z Image Turbo",
        "previewMeta": ["1:1", "512 – 2048", "种子控制"],
        "previewTitle": "从简短提示词到精致的高分辨率视觉",
        "previewDesc": "用提示词扩展丰富简短创意，选择合适的比例，并复用种子在不同图片间保持一致的风格。",
        "keyFeaturesTitle": "使用 Z Image Turbo 文生图生成器创作精致视觉",
        "keyFeaturesIntro": "了解 Z Image Turbo AI 图片生成器在提示词扩展、灵活比例、自定义尺寸和基于种子的一致性方面的核心能力。",
        "exploreTitle": "探索更多 AI 图片模型",
        "mainFeaturesTitle": "Z Image Turbo 主要功能",
        "generatedImageLabel": "生成的图片",
        "versionLabel": "控制项",
        "featureLabel": "作用",
        "useCaseLabel": "适合场景",
        "variantsTitle": "Z Image Turbo 创作控制指南",
        "variantsIntro": "根据项目对细节和视觉一致性的要求，组合使用提示词扩展、灵活尺寸和种子控制。",
        "variants": [
          { "name": "Z Image Turbo", "desc": "快速完成细节丰富、高分辨率的文生图生成。", "bestFor": "商品视觉、人像、概念美术和营销图片。" },
          { "name": "提示词扩展", "desc": "自动为简短提示词补充更多视觉细节。", "bestFor": "把快速创意转化为更完整的生成指令。" },
          { "name": "种子控制", "desc": "调整其他设置时复用相同的初始种子。", "bestFor": "在图片变体或系列活动中保持协调的视觉风格。" }
        ],
        "controlsTitle": "选择合适的提示词、尺寸和种子设置",
        "controlsIntro": "创意需要更多细节时开启提示词扩展，选择目标输出尺寸，并在需要视觉一致性时复用种子。",
        "galleryTitle": "更多 Z Image Turbo 图片示例",
        "discussionTitle": "Z Image Turbo 常见问题",
        "communityTitle": "Z Image Turbo 热门创作场景",
        "tutorialPrompt": "一辆紧凑型电动滑板车陈列在明亮的建筑摄影棚中，浅色混凝土地面，柔和天窗光，精致商品摄影，平衡构图，真实材质。",
        "qualityBenefits": [
          "自动扩展简短创意，无需手动重写每一项视觉细节。",
          "根据最终发布渠道选择横版、竖版、正方形或精确自定义尺寸。",
          "复用种子，让多次生成中的光线、配色和构图更容易保持一致。"
        ],
        "features": [
          { "name": "提示词扩展", "short": "可选择把简短提示词扩展为更丰富的细节。", "desc": "开启提示词扩展后，Z Image Turbo 会在生成前自动为简短提示词补充额外细节。这能帮助简短或简单的提示词在不手动改写的情况下产出更完整、更生动的图片。", "demo": { "type": "table", "rows": [
            { "prompt": "火星表面的一座玻璃温室，内部生长着茂盛的热带植物。", "image": require('@/assets/images/zImageTurbo/b1057f7b-3e0e-9687-aa55-56cfed42147a0.webp') },
            { "prompt": "建在复古列车车厢里的微型手工面包店。", "image": require('@/assets/images/zImageTurbo/a8dbab92-cfb4-928b-bd20-4f01835aa0ac0.webp') }
          ] } },
          { "name": "灵活比例", "short": "选择横版、竖版、正方形或自定义尺寸。", "desc": "从现成比例中选择，如 1024×1024、1280×1280、864×1536、1536×864、720×1280、1280×720、1024×1536 和 1536×1536，或输入 512×512 到 2048×2048 之间的自定义尺寸。这让 Z Image Turbo 文生图生成器同样适合横幅、海报、社交配图和正方形缩略图。", "prompt": "雨夜东京市场的超宽幅航拍视角，发光纸灯笼、拥挤食摊、湿润反光街道，电影感氛围，1536×864。", "image": require('@/assets/images/zImageTurbo/b2964bd5-066f-90b6-8c86-91dad79e44120.webp') },
          { "name": "自定义图片尺寸", "short": "设置精确的像素尺寸以获得精准输出。", "desc": "当现成比例不合适时，切换到自定义尺寸，输入 512 到 2048 之间的任意宽高。这让你直接匹配特定版式、横幅位或打印比例，无需手动裁剪。", "prompt": "竖版植物展览海报，超大橙色字体、珍稀热带叶片、暖白纸张纹理、精确编辑网格，1152×1728。", "image": require('@/assets/images/zImageTurbo/2d5a0c7e-3ef6-9433-be0d-606be80f99e80.webp') },
          { "name": "种子控制实现一致性", "short": "复用种子在不同图片间保持稳定风格。", "desc": "设置固定种子（0 到 2147483647），Z Image Turbo AI 图片生成器会在多次生成中沿用相同的起点，让你在调整提示词时更容易保持一致的外观。将种子保留为 0，则每次都获得全新随机的结果。", "prompt": "三款磨砂玻璃护肤瓶组成的系列广告，浅绿色石材、柔和漫射光、桉树叶点缀——复用同一种子，在系列图片中保持一致的光线、配色与构图。", "image": require('@/assets/images/zImageTurbo/f688ab6d-a723-969d-8df1-fbac721e66350.webp') },
          { "name": "细腻细节与真实感", "short": "渲染可信的光线、材质和景深。", "desc": "Z Image Turbo 能产出细腻的纹理、真实的光线和自然的景深，适合商品摄影、人像、概念美术和编辑视觉等对真实感有要求的场景。", "prompt": "纪实特写：小提琴制作师在安静工作室里雕刻枫木琴桥，细碎木屑、磨损手工工具、自然皮肤纹理、柔和北窗光、浅景深。", "image": require('@/assets/images/zImageTurbo/715e19f5-fea4-9361-a1e3-0f04d595db660.webp') }
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "Z Image Turbo 提示词示例，助你生成更好的 AI 图片",
        "showcaseIntro": "以这些 Z Image Turbo 提示词示例为起点。清楚描述主体、构图、光线和风格，按需开启提示词扩展，再直接发送到生成器。",
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "Z Image Turbo 常见使用场景",
        "useCases": [
          { "name": "Z Image Turbo 商品摄影", "desc": "用受控背景和固定种子创建干净、风格一致的商品图。" },
          { "name": "Z Image Turbo 营销", "desc": "在多种比例下生成活动概念、社交广告和横幅。" },
          { "name": "Z Image Turbo 海报与版式", "desc": "用自定义像素尺寸产出海报背景和可直接排版的视觉。" },
          { "name": "Z Image Turbo 人像", "desc": "生成带有自然皮肤纹理和可信光线的细节人像。" },
          { "name": "Z Image Turbo 概念美术", "desc": "用分层提示词探索角色、环境和视觉方向。" },
          { "name": "Z Image Turbo 社交内容", "desc": "为不同社交平台创建正方形、竖版和横版图片。" }
        ],
        "howToKicker": "三个简单步骤",
        "howToTitle": "如何在线使用 Z Image Turbo AI 图片生成器",
        "howToIntro": "在 Miral 上在线使用 Z Image Turbo AI 图片生成器，搭配清晰的提示词、可选的提示词扩展以及项目所需的比例。",
        "howToSteps": [
          { "title": "输入主要提示词", "desc": "描述想要的主体、场景、构图、光线、风格和视觉细节。" },
          { "title": "配置生成控制项", "desc": "按需开启提示词扩展，选择现成比例或输入自定义尺寸，并按需设置种子以保持一致性。" },
          { "title": "生成并查看", "desc": "开始生成，查看结果，下载图片或调整提示词再生成一次。" }
        ],
        "howToCta": "体验 Z Image Turbo AI 图片生成器",
        "faqTitle": "关于 Z Image Turbo 的常见问题",
        "faqs": [
          { "q": "什么是 Z Image Turbo AI 图片生成器？", "a": "Z Image Turbo 是一个用于高分辨率图像生成的文生图模型。Z Image Turbo AI 图片生成器可将文字提示词转化为细节丰富的图片，在 Miral 上可用于美术、设计、营销和商品视觉创作，全部在浏览器内完成。" },
          { "q": "Z Image Turbo 有什么用处？", "a": "Z Image Turbo 提供提示词扩展以丰富简短提示词、面向常见版式的现成比例、512 到 2048 的自定义尺寸，以及用于保持一致结果的种子控制。这些优势使其非常适合商品摄影、营销视觉、人像和概念美术。" },
          { "q": "可以免费使用 Z Image Turbo AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 Z Image Turbo AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "如何在线使用 Z Image Turbo AI 图片生成器？", "a": "输入详细的文字提示词，按需开启提示词扩展，选择现成比例或输入自定义尺寸，按需设置种子以保持一致外观，然后点击生成。Z Image Turbo 适合营销素材、商品摄影、人像和海报版式。" },
          { "q": "Z Image Turbo 中的提示词扩展是什么？", "a": "提示词扩展是一个可选开关，让 Z Image Turbo 在生成前自动为简短或简单的提示词补充额外细节。这能帮助非专业的提示词在不手动改写的情况下产出更完整、更生动的图片。" },
          { "q": "Z Image Turbo 中种子有什么作用？", "a": "种子（0 到 2147483647）设置生成的起点。在调整其他参数时复用相同种子有助于在不同图片间保持一致的风格。将种子保留为 0，则每次都获得全新随机的结果。" },
          { "q": "Z Image Turbo 支持哪些尺寸和比例？", "a": "在 Miral 上，Z Image Turbo 提供现成比例，如 1024×1024、1280×1280、864×1536、1536×864、720×1280、1280×720、1024×1536 和 1536×1536，以及 512×512 到 2048×2048 的自定义尺寸，覆盖横版、竖版和正方形输出，适合横幅、海报、社交配图和缩略图。" },
          { "q": "有哪些优秀的 Z Image Turbo 提示词示例？", "a": "有效的 Z Image Turbo 提示词应清楚描述主体、场景、构图、光线和风格。对于简短创意，可开启提示词扩展让模型自动补充细节。你可以使用本页的 Z Image Turbo 提示词示例作为起点，再根据项目调整。" }
        ],
        "ctaTitle": "在 Miral 免费体验 Z Image Turbo！",
        "ctaDesc": "在上方输入你的创意，使用 Z Image Turbo AI 图片生成器，搭配提示词扩展、灵活尺寸和种子控制创作精致视觉。"
      },
      "midjourney": {
        "title": "Midjourney AI 图片生成器免费在线使用 | Miral",
        "description": "在 Miral AI 免费在线使用 Midjourney AI 图片生成器，可选择写实或动漫风格，并通过参考图片引导生成效果，将文字提示词快速转化为精美视觉作品。",
        "heroHeadline": "Midjourney AI 图片生成器",
        "heroIntro": "在 Miral AI 免费使用 Midjourney AI 图片生成器。注册即可领取免费积分，并通过写实或动漫风格与参考图引导立即生成高质量图片。",
        "eyebrow": "Midjourney",
        "sectionKicker": "Midjourney",
        "ctaTag": "Midjourney · Miral",
        "badges": ["文生图", "写实与动漫风格", "参考图引导", "艺术导向"],
        "previewLabel": "Midjourney",
        "previewMeta": ["写实", "动漫", "最多 5 张参考图"],
        "previewTitle": "从生动的提示词到电影感、艺术感十足的图片",
        "previewDesc": "选择风格，描述氛围与光线，让 Midjourney 塑造你的概念图、海报或角色的艺术调性。",
        "keyFeaturesTitle": "使用 Midjourney 文生图生成器创作艺术感视觉",
        "keyFeaturesIntro": "了解 Midjourney AI 图片生成器在风格切换、参考图引导和丰富艺术导向方面的核心能力。",
        "features": [
          { "name": "写实与动漫风格", "short": "一键切换视觉风格。", "desc": "Miral 上的 Midjourney AI 图片生成器提供两种现成风格——写实和动漫。写实偏向照片级细节、自然光线和真实纹理，动漫则强调风格化线条、鲜明色彩和手绘质感。风格在面板上选择，因此提示词可以专注于场景本身。", "demo": { "type": "table", "rows": [
            { "prompt": "一位独行旅人站在日出时分的薄雾山脊边缘，体积光，电影感宽镜头，细腻的织物与岩石质感。", "image": require("@/assets/images/midjourney/1783505533006329.webp") },
            { "prompt": "坚定的年轻女剑士站在黄昏的屋顶上，飘动的长发，发光的灯笼，富有表现力的动漫线条，明快的赛璐璐上色。", "image": require("@/assets/images/midjourney/45f1eae9-39b9-4cc9-8a4e-e597aa4d344b.webp") }
          ] } },
          { "name": "参考图引导", "short": "上传最多五张图片来引导风格。", "desc": "用最多五张参考图（PNG、JPG、JPEG 或 WebP）引导 Midjourney AI 图片生成器。它们可帮助延续配色、人物形象、商品造型或整体美学，让结果更贴近参考方向，而不仅依赖文字。", "prompt": "高端商品图，磨砂黑陶瓷花瓶置于大理石底座上，柔和影棚光，干净背景，贴合所上传参考图的氛围与配色。", "image": require("@/assets/images/midjourney/1783506116812275.webp") },
          { "name": "电影感光线与氛围", "short": "渲染戏剧性的光线、氛围和景深。", "desc": "Midjourney 以艺术导向的光线和氛围见长。描述金色时刻、霓虹光晕、雾气、轮廓光或烛光，模型会向电影感靠拢，适合海报、主视觉和概念视觉。", "demo": { "type": "table", "rows": [
            { "prompt": "夜晚被雨淋湿的霓虹小巷，反光的积水，远处招牌的柔和散景，氛围浓郁的电影感，一个撑伞的孤独身影。", "image": require("@/assets/images/midjourney/1783506281563151.webp") },
            { "prompt": "金色时刻下屋顶上的音乐家肖像，温暖的逆光，镜头眩光，浅景深，胶片颗粒。", "image": require("@/assets/images/midjourney/1783506420066100.webp") }
          ] } },
          { "name": "角色与概念美术", "short": "塑造富有表现力的人物与世界。", "desc": "Midjourney 文生图生成器非常适合角色设计、奇幻场景和概念美术。描述人物的姿势、服装、表情和场景，选择风格，反复迭代直到满意。", "prompt": "身披层层旅行斗篷的流浪炼金师，手提黄铜灯笼和发光药瓶，古老的林间小径，斑驳光影，繁复的服装细节。", "image": require("@/assets/images/midjourney/1783506547640511.webp") },
          { "name": "海报与编辑插画", "short": "产出有冲击力的版式与主视觉。", "desc": "从活动主视觉到编辑插画，Midjourney 能塑造大胆构图与精致美学。把清晰的主角与所描述的氛围结合，让模型为营销与编辑用途产出艺术感视觉。", "prompt": "一幅大胆的活动主视觉，蜂鸟悬停在一朵发光的热带花卉上方，饱和的宝石色调，干净的留白，高对比影棚光。", "image": require("@/assets/images/midjourney/55889f96-30d2-4032-9340-2d27090394e6.webp") }
        ],
        "showcaseKicker": "提示词示例",
        "showcaseTitle": "Midjourney 提示词示例，助你生成更好的 AI 图片",
        "showcaseIntro": "以这些 Midjourney 提示词示例为起点。清楚描述场景的主体、氛围、光线和风格，再在面板上选择写实或动漫，然后发送到生成器。",
        "useCasesKicker": "为真实工作而生",
        "useCasesTitle": "Midjourney 常见使用场景",
        "useCases": [
          { "name": "Midjourney 概念美术", "desc": "用艺术导向的光线和氛围构建角色、奇幻世界和视觉方向。" },
          { "name": "Midjourney 主视觉与海报", "desc": "创作大胆的活动主视觉、海报和编辑插画，呈现精致质感。" },
          { "name": "Midjourney 商品与品牌视觉", "desc": "塑造高端商品概念和品牌图像，并用参考图保持一致性。" },
          { "name": "Midjourney 人像", "desc": "生成带有自然光线、胶片颗粒或动漫风格化上色的电影感人像。" },
          { "name": "Midjourney 动漫与插画", "desc": "切换到动漫风格，获得富有表现力的线条、鲜明色彩和手绘人物。" },
          { "name": "Midjourney 社交内容", "desc": "为信息流、缩略图和创意社交帖产出有冲击力、可分享的视觉。" }
        ],
        "howToKicker": "三个简单步骤",
        "howToTitle": "如何在线使用 Midjourney AI 图片生成器",
        "howToIntro": "在 Miral 上在线使用 Midjourney AI 图片生成器，搭配生动的提示词、所选风格和可选的参考图。",
        "howToSteps": [
          { "title": "描述你的场景", "desc": "写一段生动的提示词，涵盖主体、场景、氛围、光线和你想要的艺术质感。" },
          { "title": "选择风格与参考图", "desc": "在面板上选择写实或动漫，并按需上传最多五张参考图来引导风格。" },
          { "title": "生成并打磨", "desc": "开始生成，查看结果，下载图片或调整提示词与参考图再生成一次。" }
        ],
        "howToCta": "体验 Midjourney AI 图片生成器",
        "faqTitle": "关于 Midjourney 的常见问题",
        "faqs": [
          { "q": "什么是 Midjourney AI 图片生成器？", "a": "Midjourney 是一款广受欢迎的文生图模型，以艺术导向、电影感的视觉著称。在 Miral 上，Midjourney AI 图片生成器可将文字提示词转化为有冲击力的图片，用于概念美术、主视觉、海报和编辑创作，全部在浏览器内完成。" },
          { "q": "Midjourney 有什么特别之处？", "a": "Midjourney 以丰富的艺术导向、戏剧性光线和精致美学见长。在 Miral 上，它还提供现成的写实与动漫风格，以及参考图引导，非常适合概念美术、主视觉和品牌图像。" },
          { "q": "可以免费使用 Midjourney AI 图片生成器吗？", "a": "可以。注册即可领取免费积分，并立即使用 Midjourney AI 图片生成器创作高质量图片。生成图片时会使用相应积分。" },
          { "q": "如何在线使用 Midjourney AI 图片生成器？", "a": "输入一段生动的文字提示词，描述主体、氛围、光线和风格，在面板上选择写实或动漫，按需上传最多五张参考图，然后点击生成。Midjourney 适合概念美术、主视觉、海报、人像和编辑插画。" },
          { "q": "写实风格和动漫风格有什么区别？", "a": "写实偏向照片级细节、自然光线和真实纹理，动漫则强调风格化线条、鲜明色彩和手绘质感。你在面板上选择风格，因此提示词可以专注于场景本身。" },
          { "q": "Midjourney 中参考图如何工作？", "a": "在 Miral 上，你可以上传最多五张参考图（PNG、JPG、JPEG 或 WebP）来引导 Midjourney AI 图片生成器。它们可帮助延续配色、人物形象、商品造型或整体美学，让结果更贴近参考方向。" },
          { "q": "有哪些优秀的 Midjourney 提示词示例？", "a": "有效的 Midjourney 提示词会详细描述主体、场景、氛围、光线和艺术质感，再在面板上搭配合适的风格。你可以使用本页的 Midjourney 提示词示例作为起点，再根据项目调整。" },
          { "q": "Midjourney 和 Stable Diffusion 3.5 应该怎么选？", "a": "两者没有适用于所有人的统一答案。当你需要在 Miral 上追求艺术导向的概念图、电影感光线，以及现成写实与动漫风格和参考图引导时，Midjourney 是更合适的选择；Stable Diffusion 3.5 则更适合需要明确负向提示词和带自定义尺寸的灵活比例的创作者。" }
        ],
        "ctaTitle": "在 Miral 免费体验 Midjourney！",
        "ctaDesc": "在上方输入你的创意，使用 Midjourney AI 图片生成器，搭配写实或动漫风格与参考图引导创作艺术感视觉。"
      }
    },
    "music": {
      "title": "AI 音乐生成 - Miral",
      "description": "使用 Miral 的 AI 音乐生成功能，根据文字描述创作独特的音乐作品。"
    },
    "inspiration": {
      "title": "创作灵感 - Miral",
      "description": "浏览 Miral 社区的精选作品，获取 AI 创作灵感。"
    },
    "gallery": {
      "title": "我的作品 - Miral",
      "description": "查看和管理您在 Miral 平台创作的所有作品。"
    },
    "faq": {
      "title": "常见问题 - Miral",
      "description": "Miral 平台使用常见问题解答，帮助您快速上手 AI 创作。"
    },
    "about": {
      "title": "关于我们 - Miral",
      "description": "了解 Miral AI 图像、视频与音乐创作平台。"
    },
    "contact": {
      "title": "联系我们 - Miral",
      "description": "联系 Miral 支持团队，获取帮助与反馈渠道。"
    },
    "terms": {
      "title": "服务条款 - Miral",
      "description": "Miral 平台服务条款和用户协议。"
    },
    "privacy": {
      "title": "隐私政策 - Miral",
      "description": "Miral 平台隐私政策和数据保护说明。"
    },
    "trustSafety": {
      "title": "信任与安全 - Miral",
      "description": "Miral 平台信任与安全政策。"
    }
  }
}
